// Generated by scripts/generate-validator.mjs from lesson.schema.json.
// Do not edit: run `pnpm --filter @vrlearning/lesson-schema generate:validator`.
//
// Precompiled so the headset app can run under a Content Security Policy with
// no 'unsafe-eval' (docs/06-security-compliance.md). Ajv would otherwise build
// this function from a string at startup, which such a policy forbids.
//
// Emitted as TypeScript rather than JavaScript purely so the package's normal
// tsc build carries it into dist with no allowJs special case. It is generated
// code, so it is not ours to type-check.
// @ts-nocheck
/* eslint-disable */
import * as ajvRuntime0Module from 'ajv/dist/runtime/ucs2length.js';
const unwrapDefault = (module) => {
    let value = module;
    while (value && typeof value !== 'function' && 'default' in value)
        value = value.default;
    return value;
};
const ajvRuntime0 = unwrapDefault(ajvRuntime0Module);
('use strict');
export const validate = validate10;
export default validate10;
const schema11 = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $id: 'https://vrlearning.eu/schemas/lesson-v1.json',
    title: 'Lesson',
    description: 'A VR or AR lesson. The headset app renders any document that validates against this schema; adding a lesson must never require changing the app.',
    type: 'object',
    additionalProperties: false,
    required: [
        'schemaVersion',
        'id',
        'title',
        'language',
        'mode',
        'audience',
        'learningGoals',
        'scene',
        'steps',
    ],
    properties: {
        schemaVersion: {
            description: 'Bumped only for a breaking change. Additions within v1 must stay backward compatible.',
            const: 1,
        },
        id: {
            description: 'Stable slug, unique per language variant (solar-system-nl, solar-system-en). Maps to lesson.slug in the database; the database id is a uuid.',
            $ref: '#/definitions/slug',
        },
        title: { type: 'string', minLength: 1, maxLength: 120 },
        language: {
            description: 'Dutch first (ADR-008); each language is its own document, and English is written when a customer needs it (ADR-013).',
            enum: ['nl', 'en'],
        },
        mode: {
            description: 'Which WebXR session the lesson needs. Must agree with scene.type.',
            enum: ['vr', 'ar'],
        },
        selfPractice: {
            description: 'Whether a student may start this alone, in the free time a teacher gives them after a lesson. Absent means no: a lesson is teacher-led unless somebody has decided otherwise, which is the safe way round for a list a child browses unsupervised.',
            type: 'boolean',
            default: false,
        },
        audience: {
            type: 'object',
            additionalProperties: false,
            required: ['ageMin'],
            properties: {
                ageMin: { type: 'integer', minimum: 4, maximum: 99 },
                level: { type: 'string', minLength: 1, maxLength: 60 },
            },
        },
        learningGoals: {
            description: 'Phrased as actions. At most two, per docs/10-pedagogy.md.',
            type: 'array',
            minItems: 1,
            maxItems: 2,
            items: { type: 'string', minLength: 1, maxLength: 200 },
        },
        scene: { $ref: '#/definitions/scene' },
        objects: {
            description: 'Things the lesson can look at, focus or hang hotspots on. AR lessons usually have none.',
            type: 'object',
            propertyNames: { $ref: '#/definitions/slug' },
            additionalProperties: { $ref: '#/definitions/lessonObject' },
        },
        steps: { type: 'array', minItems: 1, items: { $ref: '#/definitions/step' } },
        labels: {
            description: 'When an object\'s name floats beside it. "always" suits a handful of far-apart objects; "on-demand" suits many close together, where every name at once is a wall of text rather than a label -- then a name appears only for the step\'s focus or its hotspots. Default "always".',
            enum: ['always', 'on-demand'],
        },
    },
    definitions: {
        slug: { type: 'string', pattern: '^[a-z0-9]+(-[a-z0-9]+)*$', maxLength: 64 },
        worldFeature: {
            description: "A feature of the lesson's world, as wereld:<feature>: the catalogue lists each world's.",
            type: 'string',
            pattern: '^wereld:[a-z0-9]+(-[a-z0-9]+)*$',
            maxLength: 71,
        },
        mediaId: {
            description: 'Media is referenced by id, never by URL (CLAUDE.md). The API issues signed URLs at load time.',
            type: 'string',
            pattern: '^m_[A-Za-z0-9_-]{1,64}$',
        },
        vec3: {
            description: 'Metres in the room, [x, y, z].',
            type: 'array',
            minItems: 3,
            maxItems: 3,
            items: { type: 'number' },
        },
        scene: {
            description: 'Where the lesson takes place. `type` says which kind of scene, and picks the rules the rest is checked against.',
            type: 'object',
            discriminator: { propertyName: 'type' },
            oneOf: [
                {
                    type: 'object',
                    additionalProperties: false,
                    required: ['type', 'preset'],
                    properties: {
                        type: { const: 'procedural' },
                        preset: {
                            description: 'A scene builder that lives in the headset app. The vocabulary grows per milestone, not per lesson.',
                            enum: ['solar-system', 'campus'],
                        },
                    },
                },
                {
                    type: 'object',
                    additionalProperties: false,
                    required: ['type', 'media'],
                    properties: { type: { const: 'gltf' }, media: { $ref: '#/definitions/mediaId' } },
                },
                {
                    type: 'object',
                    additionalProperties: false,
                    required: ['type'],
                    properties: {
                        type: {
                            description: 'A real place in a 360° photo around a flat stage of 6 m radius (ADR-036). VR. One source: want with search, or brief; media, credit and yaw are filled in by the platform.',
                            const: 'pano360',
                        },
                        media: {
                            description: 'The photo, equirectangular 2:1. Filled in by the platform, never written by a model.',
                            $ref: '#/definitions/mediaId',
                        },
                        want: {
                            description: 'Which place and view the photo should show, in Dutch. The platform finds the photo.',
                            type: 'string',
                            minLength: 1,
                            maxLength: 200,
                        },
                        search: {
                            description: '1-6 English words to search for the photo with.',
                            type: 'string',
                            minLength: 1,
                            maxLength: 80,
                        },
                        brief: {
                            description: "The school's own photo n from the brief, 1-4, instead of want and search.",
                            type: 'integer',
                            minimum: 1,
                            maximum: 4,
                        },
                        credit: {
                            description: 'Who made the photo and under which licence. Filled in by the platform.',
                            type: 'string',
                            minLength: 1,
                            maxLength: 140,
                        },
                        yaw: {
                            description: "The photo's azimuth, degrees, that faces the pupil at the start. Filled in by the platform; default 0.",
                            type: 'number',
                            minimum: -180,
                            maximum: 180,
                        },
                    },
                },
                {
                    type: 'object',
                    additionalProperties: false,
                    required: ['type'],
                    properties: { type: { const: 'ar-room' } },
                },
                {
                    type: 'object',
                    additionalProperties: false,
                    required: ['type'],
                    properties: {
                        type: {
                            description: 'A neutral room built in code: a soft floor, light from above and a gradient sky, and no media. For VR lessons made of shapes (ADR-030).',
                            const: 'studio',
                        },
                    },
                },
                {
                    type: 'object',
                    additionalProperties: false,
                    required: ['type', 'world'],
                    properties: {
                        type: {
                            description: 'A real-looking place around a flat stage of 6 m radius (ADR-032). VR.',
                            const: 'world',
                        },
                        world: {
                            description: 'Which world, by its slug: a code world (volcanic-island, science-lab, forest, meadow, polder, beach, sea-floor, town-square, modern-street, museum-hall, villa) or a published world package. Whether it exists is checked against the world catalogue when a lesson is saved, generated or published; a headset that cannot build it shows the studio. Its stage is 6 m round the origin, floor y = 0, unless the world is not staged (the villa: its rooms are its places, for a furnish task only, ADR-037).',
                            type: 'string',
                            pattern: '^[a-z][a-z0-9-]{1,39}$',
                        },
                    },
                },
            ],
        },
        lessonObject: {
            type: 'object',
            additionalProperties: false,
            required: ['kind', 'label'],
            properties: {
                kind: {
                    description: 'namespace:name. The engine registers a builder per namespace, which is what makes new object types pluggable.',
                    type: 'string',
                    pattern: '^(model:[a-z0-9-]{2,40}|[a-z][a-z0-9-]*:[a-z][a-z0-9-]*)$',
                },
                label: { type: 'string', minLength: 1, maxLength: 60 },
                pos: { $ref: '#/definitions/vec3' },
                radius: { type: 'number', exclusiveMinimum: 0 },
                spin: { description: 'Radians per second about the y axis.', type: 'number' },
                tilt: { description: 'Axial tilt in radians.', type: 'number' },
                ring: {
                    description: "Inner and outer radius as a multiple of the object's radius.",
                    type: 'array',
                    minItems: 2,
                    maxItems: 2,
                    items: { type: 'number', exclusiveMinimum: 0 },
                },
                parent: {
                    description: 'Another object this one orbits. The Moon is modelled this way rather than as a flag on Earth, so hotspots can target it.',
                    $ref: '#/definitions/slug',
                },
                orbit: {
                    description: 'Orbit radius in metres around parent.',
                    type: 'number',
                    exclusiveMinimum: 0,
                },
                parts: {
                    description: 'What a shape: object is made of (ADR-030). Only a shape takes parts, and a shape must have them. At most 64 in total, counting the parts inside groups, and at most 30 shape objects per lesson: both checked by the validator, because a schema cannot count across levels.',
                    type: 'array',
                    minItems: 1,
                    maxItems: 64,
                    items: { $ref: '#/definitions/shapePart' },
                },
                hidden: { description: 'True: not there until a step shows it. VR only.', type: 'boolean' },
                rot: {
                    description: 'A shape only: degrees about x, y and z, turned about its pos.',
                    $ref: '#/definitions/shapeRotation',
                },
                scale: {
                    description: 'A shape only: bigger or smaller alike in every direction.',
                    type: 'number',
                    minimum: 0.1,
                    maximum: 10,
                },
                width: {
                    description: "A poster only: the photo's width in metres. Its height follows the photo.",
                    type: 'number',
                    minimum: 0.4,
                    maximum: 3,
                },
                facing: {
                    description: 'A poster only: degrees about the vertical axis; 0 faces +z. Absent: it faces where the pupil stands for the first step about it.',
                    type: 'number',
                    minimum: -360,
                    maximum: 360,
                },
                caption: {
                    description: 'A poster only: a short Dutch caption under the photo.',
                    type: 'string',
                    minLength: 1,
                    maxLength: 80,
                },
                want: {
                    description: 'A poster only: what the photo should show, in Dutch. The platform finds the photo.',
                    type: 'string',
                    minLength: 1,
                    maxLength: 200,
                },
                search: {
                    description: 'A poster only: 1-6 English words to search for the photo with.',
                    type: 'string',
                    minLength: 1,
                    maxLength: 80,
                },
                media: {
                    description: 'A poster only: the photo. Filled in by the platform, never written by a model.',
                    $ref: '#/definitions/mediaId',
                },
                aspect: {
                    description: "A poster only: the photo's width divided by its height. Filled in by the platform.",
                    type: 'number',
                    minimum: 0.4,
                    maximum: 2.5,
                },
                credit: {
                    description: 'A poster only: who made the photo and under which licence. Filled in by the platform.',
                    type: 'string',
                    minLength: 1,
                    maxLength: 140,
                },
                turn: {
                    description: 'A model only: degrees about the vertical axis; 0 faces -z, the way the pupil looks at the start, and positive turns left.',
                    type: 'number',
                    minimum: -360,
                    maximum: 360,
                },
                size: {
                    description: 'A model only: metres along its size axis. Absent: its real size.',
                    type: 'number',
                    minimum: 0.05,
                    maximum: 80,
                },
                above: {
                    description: 'A model that swims or flies only: metres from the land up to the bottom of its box; default 0. The same for the whole lesson.',
                    type: 'number',
                    minimum: 0,
                    maximum: 20,
                },
            },
        },
        view: {
            description: 'Where the visitor stands and what they look at. Three forms, all used by the prototypes.',
            oneOf: [
                {
                    type: 'object',
                    additionalProperties: false,
                    required: ['look'],
                    properties: {
                        look: {
                            oneOf: [{ $ref: '#/definitions/slug' }, { $ref: '#/definitions/worldFeature' }],
                        },
                    },
                },
                {
                    type: 'object',
                    additionalProperties: false,
                    required: ['pos', 'look'],
                    properties: {
                        pos: { $ref: '#/definitions/vec3' },
                        look: {
                            oneOf: [
                                { $ref: '#/definitions/slug' },
                                { $ref: '#/definitions/worldFeature' },
                                { $ref: '#/definitions/vec3' },
                            ],
                        },
                    },
                },
                {
                    type: 'object',
                    additionalProperties: false,
                    required: ['station'],
                    properties: { station: { $ref: '#/definitions/slug' } },
                },
            ],
        },
        panel: {
            description: 'Text on the lectern. In a predict step it is the introduction, shown before the question. Limits come from what stayed readable in the prototypes.',
            type: 'object',
            additionalProperties: false,
            required: ['title', 'text'],
            properties: {
                title: { type: 'string', minLength: 1, maxLength: 80 },
                text: { type: 'string', minLength: 1, maxLength: 260 },
            },
        },
        hotspot: {
            type: 'object',
            additionalProperties: false,
            required: ['title', 'text'],
            properties: {
                object: {
                    description: 'The object the hotspot hangs on. Exactly one of object, find and toward.',
                    $ref: '#/definitions/slug',
                },
                feature: {
                    description: 'A world lesson, instead of object: the feature of the lesson\'s world the hotspot hangs on, by its id ("bloedstroom"), in any state. Its badge sits at the feature.',
                    type: 'string',
                    minLength: 1,
                    maxLength: 64,
                },
                find: {
                    description: 'A pano360 lesson only, instead of object: what to look for in the photo, in Dutch. The platform points it.',
                    type: 'string',
                    minLength: 1,
                    maxLength: 60,
                },
                point: {
                    description: "A pano360 lesson of a place with named points, instead of object: the point's name. The platform fills toward.",
                    type: 'string',
                    minLength: 1,
                    maxLength: 40,
                },
                toward: {
                    description: 'Where find points in the photo, [azimuth, elevation] in degrees. Filled in by the platform.',
                    type: 'array',
                    minItems: 2,
                    maxItems: 2,
                    items: [
                        { type: 'number', minimum: -180, maximum: 180 },
                        { type: 'number', minimum: -90, maximum: 90 },
                    ],
                },
                title: { type: 'string', minLength: 1, maxLength: 80 },
                text: { type: 'string', minLength: 1, maxLength: 200 },
            },
        },
        panoPhoto: {
            description: "A 360° photo from this step on, in a pano360 lesson: the scene's fields without type.",
            type: 'object',
            additionalProperties: false,
            properties: {
                media: {
                    description: 'The photo, equirectangular 2:1. Filled in by the platform, never written by a model.',
                    $ref: '#/definitions/mediaId',
                },
                want: {
                    description: 'Which place and view the photo should show, in Dutch. The platform finds the photo.',
                    type: 'string',
                    minLength: 1,
                    maxLength: 200,
                },
                search: {
                    description: '1-6 English words to search for the photo with.',
                    type: 'string',
                    minLength: 1,
                    maxLength: 80,
                },
                brief: {
                    description: "The school's own photo n from the brief, 1-4, instead of want and search.",
                    type: 'integer',
                    minimum: 1,
                    maximum: 4,
                },
                credit: {
                    description: 'Who made the photo and under which licence. Filled in by the platform.',
                    type: 'string',
                    minLength: 1,
                    maxLength: 140,
                },
                yaw: {
                    description: "The photo's azimuth, degrees, that faces the pupil at the start. Filled in by the platform; default 0.",
                    type: 'number',
                    minimum: -180,
                    maximum: 180,
                },
            },
        },
        quiz: {
            description: 'Retrieval at the end of a lesson. answer is a zero-based index into options.',
            type: 'object',
            additionalProperties: false,
            required: ['question', 'options', 'answer', 'explain'],
            properties: {
                question: { type: 'string', minLength: 1, maxLength: 200 },
                options: {
                    type: 'array',
                    minItems: 2,
                    maxItems: 4,
                    items: { type: 'string', minLength: 1, maxLength: 80 },
                },
                answer: { type: 'integer', minimum: 0 },
                explain: { type: 'string', minLength: 1, maxLength: 260 },
                level: {
                    description: "How hard the question is: herkennen (recognise it), begrijpen (understand why), toepassen (apply it to a new case). A lesson's questions rise: never an easier one after a harder one.",
                    enum: ['herkennen', 'begrijpen', 'toepassen'],
                },
                doordenk: {
                    description: "The lesson's doordenkvraag: its last question, a reasoning question (why, or what would happen if, in a new case) answered from memory, at level toepassen. The teacher's console shows it after the lesson as a starter for a class discussion.",
                    type: 'boolean',
                },
            },
        },
        predict: {
            description: "Asked after the step's panel (its introduction), before the reveal: the task, or the next step. Omit answer when a task decides what was right, as in AR measuring.",
            type: 'object',
            additionalProperties: false,
            required: ['question', 'options'],
            properties: {
                question: { type: 'string', minLength: 1, maxLength: 200 },
                options: {
                    type: 'array',
                    minItems: 2,
                    maxItems: 4,
                    items: { type: 'string', minLength: 1, maxLength: 80 },
                },
                answer: { type: 'integer', minimum: 0 },
            },
        },
        task: {
            description: 'Something the pupil does. measure and assemble: AR, in the real world; furnish: VR, in the villa.',
            oneOf: [
                {
                    type: 'object',
                    additionalProperties: false,
                    required: ['type', 'instruction'],
                    properties: {
                        type: { const: 'measure' },
                        instruction: { type: 'string', minLength: 1, maxLength: 200 },
                        edges: {
                            description: 'Ascending bucket boundaries in metres. With a predict, there must be one fewer edge than there are options.',
                            type: 'array',
                            minItems: 1,
                            items: { type: 'number', exclusiveMinimum: 0 },
                        },
                    },
                },
                {
                    type: 'object',
                    additionalProperties: false,
                    required: ['type', 'instruction', 'parts'],
                    properties: {
                        type: { const: 'assemble' },
                        instruction: { type: 'string', minLength: 1, maxLength: 200 },
                        parts: {
                            description: "Object ids the student has to put in place. Each one's `pos` in `objects` is where it belongs -- the lesson states the finished thing and the engine scatters it, so there is no second copy of the right answer to keep in step.",
                            type: 'array',
                            minItems: 2,
                            maxItems: 24,
                            items: { $ref: '#/definitions/slug' },
                        },
                        snapMetres: {
                            description: 'How close counts as placed. Default 0.08. A ten-year-old pinching a bone in mid-air is not accurate to a centimetre, and a lesson about the skeleton is not a test of fine motor control.',
                            type: 'number',
                            exclusiveMinimum: 0,
                            maximum: 0.5,
                        },
                    },
                },
                {
                    type: 'object',
                    additionalProperties: false,
                    required: ['type', 'instruction'],
                    properties: {
                        type: {
                            description: "The pupils place the school's own work (furniture, sculptures, cars: a set of werkstukken the teacher picks when the lesson starts, never named in the lesson). Only in a world with a placement space (the villa, or a package with a plaatsruimte), one step per lesson (ADR-037, ADR-050).",
                            const: 'furnish',
                        },
                        instruction: { type: 'string', minLength: 1, maxLength: 200 },
                    },
                },
            ],
        },
        step: {
            type: 'object',
            additionalProperties: false,
            required: ['id', 'title'],
            properties: {
                id: { $ref: '#/definitions/slug' },
                title: { type: 'string', minLength: 1, maxLength: 80 },
                focus: {
                    description: 'Which object the step is about; the engine dims the other labels.',
                    oneOf: [{ $ref: '#/definitions/slug' }, { $ref: '#/definitions/worldFeature' }],
                },
                view: { $ref: '#/definitions/view' },
                panel: { $ref: '#/definitions/panel' },
                narration: {
                    description: "What the voice says for this step: spoken Dutch, 15–45 s. Absent: the panel's text, then the step's question. Write numbers and abbreviations out.",
                    type: 'string',
                    minLength: 1,
                    maxLength: 600,
                    pattern: '^ *[^ ].*$',
                },
                voiceover: { $ref: '#/definitions/mediaId' },
                hotspots: { type: 'array', maxItems: 6, items: { $ref: '#/definitions/hotspot' } },
                quiz: { $ref: '#/definitions/quiz' },
                predict: { $ref: '#/definitions/predict' },
                task: { $ref: '#/definitions/task' },
                show: {
                    description: 'Objects that appear when this step starts, growing into place. VR only.',
                    type: 'array',
                    maxItems: 12,
                    items: { $ref: '#/definitions/slug' },
                },
                hide: {
                    description: 'Objects that disappear when this step starts, shrinking away. VR only.',
                    type: 'array',
                    maxItems: 12,
                    items: { $ref: '#/definitions/slug' },
                },
                move: {
                    description: 'Shapes that move, turn or grow to a new place when this step starts, after show and hide. VR only.',
                    type: 'array',
                    maxItems: 8,
                    items: { $ref: '#/definitions/stepMove' },
                },
                highlight: {
                    description: 'The object this step points out: it lights up twice once the changes are done. VR only.',
                    $ref: '#/definitions/slug',
                },
                world: {
                    description: 'States of the world\'s features from this step on, by feature: {"vulkaan": "uitbarsting"}.',
                    type: 'object',
                    additionalProperties: { type: 'string' },
                },
                pano: {
                    description: 'Changes the 360° photo from this step on; a pano360 lesson only.',
                    $ref: '#/definitions/panoPhoto',
                },
                models: {
                    description: "What the lesson's models do when this step starts, one entry per model, in this order: walk, face, play. A model with no entry carries on. VR only.",
                    type: 'array',
                    maxItems: 5,
                    items: { $ref: '#/definitions/stepModel' },
                },
                spannend: {
                    description: "An exciting version of this step's models, played instead of models only when the teacher turned Spannend on.",
                    $ref: '#/definitions/stepSpannend',
                },
                pause: {
                    description: "A good moment for the teacher to pause the class after this step: only the teacher's console shows it; the lesson never stops by itself.",
                    type: 'boolean',
                },
            },
            not: {
                description: 'A step asks one thing. predict may accompany a task (estimate, then measure), but quiz and task are alternatives.',
                required: ['quiz', 'task'],
            },
        },
        stepModel: {
            description: 'What one model does when the step starts: walkTo, then face, then play.',
            type: 'object',
            additionalProperties: false,
            required: ['object'],
            properties: {
                object: { $ref: '#/definitions/slug' },
                walkTo: {
                    description: 'Where it walks to, [x, z] on the ground; "pupil" only in a spannend part.',
                    oneOf: [
                        { type: 'array', minItems: 2, maxItems: 2, items: { type: 'number' } },
                        { const: 'pupil' },
                    ],
                },
                gait: {
                    description: 'How it walks; default lopen.',
                    enum: ['lopen', 'rennen', 'zwemmen', 'vliegen', 'rijden'],
                },
                face: { description: 'Turns to look at the pupil.', const: 'pupil' },
                turn: {
                    description: "Turns where it stands to this heading, degrees as an object's turn (0 faces -z, positive turns left), eased, before it plays: the pupil sees another side. Not with walkTo, face or circle; never in a spannend part.",
                    type: 'number',
                    minimum: -360,
                    maximum: 360,
                },
                play: {
                    description: 'The animation it plays, one the model has.',
                    enum: [
                        'staan',
                        'lopen',
                        'rennen',
                        'brullen',
                        'bijten',
                        'eten',
                        'kijken',
                        'liggen',
                        'zwemmen',
                        'vliegen',
                        'springen',
                        'aanvallen',
                        'slapen',
                        'rijden',
                        'werken',
                    ],
                },
                loop: {
                    description: 'Whether play repeats; default as the library says.',
                    type: 'boolean',
                },
                then: {
                    description: 'What it does once the rest of this entry is done: after a walk with no play, or after a once-only play; default staan.',
                    enum: [
                        'staan',
                        'lopen',
                        'rennen',
                        'brullen',
                        'bijten',
                        'eten',
                        'kijken',
                        'liggen',
                        'zwemmen',
                        'vliegen',
                        'springen',
                        'aanvallen',
                        'slapen',
                        'rijden',
                        'werken',
                    ],
                },
                circle: {
                    description: "Goes round on a circle while it plays a travelling loop (play), always facing along it. The radius is where the step finds the model; the speed is play's. Not with walkTo, face, gait or loop; never in a spannend part. VR.",
                    type: 'object',
                    additionalProperties: false,
                    required: ['direction', 'rounds'],
                    properties: {
                        around: {
                            description: 'The centre: [x, z] on the ground (default [0, 0], the stage centre), or an object that stays put.',
                            oneOf: [
                                { type: 'array', minItems: 2, maxItems: 2, items: { type: 'number' } },
                                { $ref: '#/definitions/slug' },
                            ],
                        },
                        direction: {
                            description: 'links: counter-clockwise seen from above; rechts: clockwise.',
                            enum: ['links', 'rechts'],
                        },
                        rounds: {
                            description: 'How many rounds, 0.25 to 4 in quarters, or "loop": on until a later step names the model.',
                            oneOf: [
                                { type: 'number', minimum: 0.25, maximum: 4, multipleOf: 0.25 },
                                { const: 'loop' },
                            ],
                        },
                    },
                },
            },
        },
        stepSpannend: {
            description: "The models of a step's exciting version.",
            type: 'object',
            additionalProperties: false,
            required: ['models'],
            properties: {
                models: {
                    type: 'array',
                    minItems: 1,
                    maxItems: 5,
                    items: { $ref: '#/definitions/stepModel' },
                },
            },
        },
        stepMove: {
            description: 'Where a shape ends up; what is left out stays as it was.',
            type: 'object',
            additionalProperties: false,
            required: ['object'],
            properties: {
                object: { $ref: '#/definitions/slug' },
                pos: { $ref: '#/definitions/vec3' },
                rot: { $ref: '#/definitions/shapeRotation' },
                scale: { type: 'number', minimum: 0.1, maximum: 10 },
                seconds: {
                    description: 'How long the move takes; default 2.',
                    type: 'number',
                    minimum: 0.5,
                    maximum: 10,
                },
            },
        },
        shapeColour: {
            description: 'A flat colour, #rrggbb. Shapes have no textures.',
            type: 'string',
            pattern: '^#[0-9a-fA-F]{6}$',
        },
        shapeSize: {
            description: 'Metres, between 5 mm and 10 m: nothing too small to see, nothing bigger than a room.',
            type: 'number',
            minimum: 0.005,
            maximum: 10,
        },
        shapeOffset: {
            description: 'Metres from the middle of the object, or of the group the part is in, [x, y, z].',
            type: 'array',
            minItems: 3,
            maxItems: 3,
            items: { type: 'number', minimum: -10, maximum: 10 },
        },
        shapeRotation: {
            description: 'Degrees about the x, y and z axes, [x, y, z].',
            type: 'array',
            minItems: 3,
            maxItems: 3,
            items: { type: 'number', minimum: -360, maximum: 360 },
        },
        shapeOpacity: {
            description: '1 is solid. Lower lets what is inside show through; below 0.1 a part is as good as invisible.',
            type: 'number',
            minimum: 0.1,
            maximum: 1,
        },
        shapeStand: {
            description: 'True on the part a thing stands on -- a plinth, a pedestal -- and not on what a step is about. The engine frames the subject without it, so a plinth on the floor does not drag the view down to the floor. Drawn as any other part.',
            type: 'boolean',
        },
        shapeFinish: {
            description: 'How the surface looks: matte (the default), gloss (wet or polished) or glow (hot, or giving light).',
            enum: ['matte', 'gloss', 'glow'],
        },
        shapeScale: {
            description: 'Makes everything in the group bigger or smaller alike.',
            type: 'number',
            minimum: 0.1,
            maximum: 10,
        },
        profilePoint: {
            description: 'A point of a flat outline in metres, [x, y]. For a lathe, x is the distance from the axis.',
            type: 'array',
            minItems: 2,
            maxItems: 2,
            items: { type: 'number', minimum: -10, maximum: 10 },
        },
        shapeBox: {
            type: 'object',
            additionalProperties: false,
            required: ['type', 'size', 'color'],
            properties: {
                type: { const: 'box' },
                size: {
                    description: '[width, height, depth]',
                    type: 'array',
                    minItems: 3,
                    maxItems: 3,
                    items: { $ref: '#/definitions/shapeSize' },
                },
                pos: { $ref: '#/definitions/shapeOffset' },
                rot: { $ref: '#/definitions/shapeRotation' },
                color: { $ref: '#/definitions/shapeColour' },
                opacity: { $ref: '#/definitions/shapeOpacity' },
                stand: { $ref: '#/definitions/shapeStand' },
                finish: { $ref: '#/definitions/shapeFinish' },
            },
        },
        shapeSphere: {
            type: 'object',
            additionalProperties: false,
            required: ['type', 'size', 'color'],
            properties: {
                type: { const: 'sphere' },
                size: {
                    description: '[radius]',
                    type: 'array',
                    minItems: 1,
                    maxItems: 1,
                    items: { $ref: '#/definitions/shapeSize' },
                },
                pos: { $ref: '#/definitions/shapeOffset' },
                rot: { $ref: '#/definitions/shapeRotation' },
                color: { $ref: '#/definitions/shapeColour' },
                opacity: { $ref: '#/definitions/shapeOpacity' },
                stand: { $ref: '#/definitions/shapeStand' },
                finish: { $ref: '#/definitions/shapeFinish' },
            },
        },
        shapeCylinder: {
            type: 'object',
            additionalProperties: false,
            required: ['type', 'size', 'color'],
            properties: {
                type: { const: 'cylinder' },
                size: {
                    description: '[top radius, bottom radius, height], standing on the y axis',
                    type: 'array',
                    minItems: 3,
                    maxItems: 3,
                    items: { $ref: '#/definitions/shapeSize' },
                },
                pos: { $ref: '#/definitions/shapeOffset' },
                rot: { $ref: '#/definitions/shapeRotation' },
                color: { $ref: '#/definitions/shapeColour' },
                opacity: { $ref: '#/definitions/shapeOpacity' },
                stand: { $ref: '#/definitions/shapeStand' },
                finish: { $ref: '#/definitions/shapeFinish' },
            },
        },
        shapeCone: {
            type: 'object',
            additionalProperties: false,
            required: ['type', 'size', 'color'],
            properties: {
                type: { const: 'cone' },
                size: {
                    description: '[radius, height], point up',
                    type: 'array',
                    minItems: 2,
                    maxItems: 2,
                    items: { $ref: '#/definitions/shapeSize' },
                },
                pos: { $ref: '#/definitions/shapeOffset' },
                rot: { $ref: '#/definitions/shapeRotation' },
                color: { $ref: '#/definitions/shapeColour' },
                opacity: { $ref: '#/definitions/shapeOpacity' },
                stand: { $ref: '#/definitions/shapeStand' },
                finish: { $ref: '#/definitions/shapeFinish' },
            },
        },
        shapeTorus: {
            type: 'object',
            additionalProperties: false,
            required: ['type', 'size', 'color'],
            properties: {
                type: { const: 'torus' },
                size: {
                    description: '[radius of the ring, radius of the tube], lying in the x-y plane',
                    type: 'array',
                    minItems: 2,
                    maxItems: 2,
                    items: { $ref: '#/definitions/shapeSize' },
                },
                pos: { $ref: '#/definitions/shapeOffset' },
                rot: { $ref: '#/definitions/shapeRotation' },
                color: { $ref: '#/definitions/shapeColour' },
                opacity: { $ref: '#/definitions/shapeOpacity' },
                stand: { $ref: '#/definitions/shapeStand' },
                finish: { $ref: '#/definitions/shapeFinish' },
            },
        },
        shapeCapsule: {
            type: 'object',
            additionalProperties: false,
            required: ['type', 'size', 'color'],
            properties: {
                type: { const: 'capsule' },
                size: {
                    description: '[radius, length of the straight middle], standing on the y axis',
                    type: 'array',
                    minItems: 2,
                    maxItems: 2,
                    items: { $ref: '#/definitions/shapeSize' },
                },
                pos: { $ref: '#/definitions/shapeOffset' },
                rot: { $ref: '#/definitions/shapeRotation' },
                color: { $ref: '#/definitions/shapeColour' },
                opacity: { $ref: '#/definitions/shapeOpacity' },
                stand: { $ref: '#/definitions/shapeStand' },
                finish: { $ref: '#/definitions/shapeFinish' },
            },
        },
        shapePlane: {
            type: 'object',
            additionalProperties: false,
            required: ['type', 'size', 'color'],
            properties: {
                type: { const: 'plane' },
                size: {
                    description: '[width, height], facing +z; seen from both sides',
                    type: 'array',
                    minItems: 2,
                    maxItems: 2,
                    items: { $ref: '#/definitions/shapeSize' },
                },
                pos: { $ref: '#/definitions/shapeOffset' },
                rot: { $ref: '#/definitions/shapeRotation' },
                color: { $ref: '#/definitions/shapeColour' },
                opacity: { $ref: '#/definitions/shapeOpacity' },
                stand: { $ref: '#/definitions/shapeStand' },
                finish: { $ref: '#/definitions/shapeFinish' },
            },
        },
        shapeLathe: {
            description: "An outline turned about the y axis, as on a potter's wheel: a vase, a volcano, a flask.",
            type: 'object',
            additionalProperties: false,
            required: ['type', 'points', 'color'],
            properties: {
                type: { const: 'lathe' },
                points: {
                    description: '[distance from the axis, height] from bottom to top. A negative distance is drawn as 0.',
                    type: 'array',
                    minItems: 2,
                    maxItems: 64,
                    items: { $ref: '#/definitions/profilePoint' },
                },
                pos: { $ref: '#/definitions/shapeOffset' },
                rot: { $ref: '#/definitions/shapeRotation' },
                color: { $ref: '#/definitions/shapeColour' },
                opacity: { $ref: '#/definitions/shapeOpacity' },
                stand: { $ref: '#/definitions/shapeStand' },
                finish: { $ref: '#/definitions/shapeFinish' },
            },
        },
        shapeExtrude: {
            description: 'A flat outline pushed out along z, as a biscuit cutter through dough, centred on its pos: a cross-section, an arrow, a leaf.',
            type: 'object',
            additionalProperties: false,
            required: ['type', 'outline', 'depth', 'color'],
            properties: {
                type: { const: 'extrude' },
                outline: {
                    description: '[x, y] corners in order, in metres. The outline closes itself and must not cross itself.',
                    type: 'array',
                    minItems: 3,
                    maxItems: 64,
                    items: { $ref: '#/definitions/profilePoint' },
                },
                depth: { $ref: '#/definitions/shapeSize' },
                pos: { $ref: '#/definitions/shapeOffset' },
                rot: { $ref: '#/definitions/shapeRotation' },
                color: { $ref: '#/definitions/shapeColour' },
                opacity: { $ref: '#/definitions/shapeOpacity' },
                stand: { $ref: '#/definitions/shapeStand' },
                finish: { $ref: '#/definitions/shapeFinish' },
            },
        },
        shapeLeaf: {
            description: 'One part that is drawn: a primitive, a lathe or an extrusion. `type` says which, and picks the rules the rest of the part is checked against.',
            type: 'object',
            discriminator: { propertyName: 'type' },
            oneOf: [
                { $ref: '#/definitions/shapeBox' },
                { $ref: '#/definitions/shapeSphere' },
                { $ref: '#/definitions/shapeCylinder' },
                { $ref: '#/definitions/shapeCone' },
                { $ref: '#/definitions/shapeTorus' },
                { $ref: '#/definitions/shapeCapsule' },
                { $ref: '#/definitions/shapePlane' },
                { $ref: '#/definitions/shapeLathe' },
                { $ref: '#/definitions/shapeExtrude' },
            ],
        },
        shapeGroupInner: {
            description: 'A group inside a group: the third and deepest level, so it holds drawn parts only.',
            type: 'object',
            additionalProperties: false,
            required: ['type', 'parts'],
            properties: {
                type: { const: 'group' },
                parts: {
                    type: 'array',
                    minItems: 1,
                    maxItems: 64,
                    items: { $ref: '#/definitions/shapeLeaf' },
                },
                pos: { $ref: '#/definitions/shapeOffset' },
                rot: { $ref: '#/definitions/shapeRotation' },
                scale: { $ref: '#/definitions/shapeScale' },
            },
        },
        shapeGroup: {
            description: 'Parts moved, turned and scaled together. May hold one more level of groups.',
            type: 'object',
            additionalProperties: false,
            required: ['type', 'parts'],
            properties: {
                type: { const: 'group' },
                parts: {
                    type: 'array',
                    minItems: 1,
                    maxItems: 64,
                    items: {
                        type: 'object',
                        discriminator: { propertyName: 'type' },
                        oneOf: [
                            { $ref: '#/definitions/shapeBox' },
                            { $ref: '#/definitions/shapeSphere' },
                            { $ref: '#/definitions/shapeCylinder' },
                            { $ref: '#/definitions/shapeCone' },
                            { $ref: '#/definitions/shapeTorus' },
                            { $ref: '#/definitions/shapeCapsule' },
                            { $ref: '#/definitions/shapePlane' },
                            { $ref: '#/definitions/shapeLathe' },
                            { $ref: '#/definitions/shapeExtrude' },
                            { $ref: '#/definitions/shapeGroupInner' },
                        ],
                    },
                },
                pos: { $ref: '#/definitions/shapeOffset' },
                rot: { $ref: '#/definitions/shapeRotation' },
                scale: { $ref: '#/definitions/shapeScale' },
            },
        },
        shapePart: {
            description: 'A part of a shape object: something drawn, or a group of parts. Written out level by level rather than as one recursive definition, so nesting stops at three levels by construction and the structured-output variant can inline it (ADR-030).',
            type: 'object',
            discriminator: { propertyName: 'type' },
            oneOf: [
                { $ref: '#/definitions/shapeBox' },
                { $ref: '#/definitions/shapeSphere' },
                { $ref: '#/definitions/shapeCylinder' },
                { $ref: '#/definitions/shapeCone' },
                { $ref: '#/definitions/shapeTorus' },
                { $ref: '#/definitions/shapeCapsule' },
                { $ref: '#/definitions/shapePlane' },
                { $ref: '#/definitions/shapeLathe' },
                { $ref: '#/definitions/shapeExtrude' },
                { $ref: '#/definitions/shapeGroup' },
            ],
        },
    },
};
const schema12 = { type: 'string', pattern: '^[a-z0-9]+(-[a-z0-9]+)*$', maxLength: 64 };
const func2 = Object.prototype.hasOwnProperty;
const func3 = ajvRuntime0;
const pattern0 = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$', 'u');
const schema13 = {
    description: 'Where the lesson takes place. `type` says which kind of scene, and picks the rules the rest is checked against.',
    type: 'object',
    discriminator: { propertyName: 'type' },
    oneOf: [
        {
            type: 'object',
            additionalProperties: false,
            required: ['type', 'preset'],
            properties: {
                type: { const: 'procedural' },
                preset: {
                    description: 'A scene builder that lives in the headset app. The vocabulary grows per milestone, not per lesson.',
                    enum: ['solar-system', 'campus'],
                },
            },
        },
        {
            type: 'object',
            additionalProperties: false,
            required: ['type', 'media'],
            properties: { type: { const: 'gltf' }, media: { $ref: '#/definitions/mediaId' } },
        },
        {
            type: 'object',
            additionalProperties: false,
            required: ['type'],
            properties: {
                type: {
                    description: 'A real place in a 360° photo around a flat stage of 6 m radius (ADR-036). VR. One source: want with search, or brief; media, credit and yaw are filled in by the platform.',
                    const: 'pano360',
                },
                media: {
                    description: 'The photo, equirectangular 2:1. Filled in by the platform, never written by a model.',
                    $ref: '#/definitions/mediaId',
                },
                want: {
                    description: 'Which place and view the photo should show, in Dutch. The platform finds the photo.',
                    type: 'string',
                    minLength: 1,
                    maxLength: 200,
                },
                search: {
                    description: '1-6 English words to search for the photo with.',
                    type: 'string',
                    minLength: 1,
                    maxLength: 80,
                },
                brief: {
                    description: "The school's own photo n from the brief, 1-4, instead of want and search.",
                    type: 'integer',
                    minimum: 1,
                    maximum: 4,
                },
                credit: {
                    description: 'Who made the photo and under which licence. Filled in by the platform.',
                    type: 'string',
                    minLength: 1,
                    maxLength: 140,
                },
                yaw: {
                    description: "The photo's azimuth, degrees, that faces the pupil at the start. Filled in by the platform; default 0.",
                    type: 'number',
                    minimum: -180,
                    maximum: 180,
                },
            },
        },
        {
            type: 'object',
            additionalProperties: false,
            required: ['type'],
            properties: { type: { const: 'ar-room' } },
        },
        {
            type: 'object',
            additionalProperties: false,
            required: ['type'],
            properties: {
                type: {
                    description: 'A neutral room built in code: a soft floor, light from above and a gradient sky, and no media. For VR lessons made of shapes (ADR-030).',
                    const: 'studio',
                },
            },
        },
        {
            type: 'object',
            additionalProperties: false,
            required: ['type', 'world'],
            properties: {
                type: {
                    description: 'A real-looking place around a flat stage of 6 m radius (ADR-032). VR.',
                    const: 'world',
                },
                world: {
                    description: 'Which world, by its slug: a code world (volcanic-island, science-lab, forest, meadow, polder, beach, sea-floor, town-square, modern-street, museum-hall, villa) or a published world package. Whether it exists is checked against the world catalogue when a lesson is saved, generated or published; a headset that cannot build it shows the studio. Its stage is 6 m round the origin, floor y = 0, unless the world is not staged (the villa: its rooms are its places, for a furnish task only, ADR-037).',
                    type: 'string',
                    pattern: '^[a-z][a-z0-9-]{1,39}$',
                },
            },
        },
    ],
};
const schema14 = {
    description: 'Media is referenced by id, never by URL (CLAUDE.md). The API issues signed URLs at load time.',
    type: 'string',
    pattern: '^m_[A-Za-z0-9_-]{1,64}$',
};
const pattern1 = new RegExp('^m_[A-Za-z0-9_-]{1,64}$', 'u');
const pattern3 = new RegExp('^[a-z][a-z0-9-]{1,39}$', 'u');
function validate11(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        const tag0 = data.type;
        if (typeof tag0 == 'string') {
            if (tag0 === 'procedural') {
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    if (data.type === undefined) {
                        const err0 = {
                            instancePath,
                            schemaPath: '#/oneOf/0/required',
                            keyword: 'required',
                            params: { missingProperty: 'type' },
                            message: "must have required property '" + 'type' + "'",
                            schema: schema13.oneOf[0].required,
                            parentSchema: schema13.oneOf[0],
                            data,
                        };
                        if (vErrors === null) {
                            vErrors = [err0];
                        }
                        else {
                            vErrors.push(err0);
                        }
                        errors++;
                    }
                    if (data.preset === undefined) {
                        const err1 = {
                            instancePath,
                            schemaPath: '#/oneOf/0/required',
                            keyword: 'required',
                            params: { missingProperty: 'preset' },
                            message: "must have required property '" + 'preset' + "'",
                            schema: schema13.oneOf[0].required,
                            parentSchema: schema13.oneOf[0],
                            data,
                        };
                        if (vErrors === null) {
                            vErrors = [err1];
                        }
                        else {
                            vErrors.push(err1);
                        }
                        errors++;
                    }
                    for (const key0 in data) {
                        if (!(key0 === 'type' || key0 === 'preset')) {
                            const err2 = {
                                instancePath,
                                schemaPath: '#/oneOf/0/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key0 },
                                message: 'must NOT have additional properties',
                                schema: false,
                                parentSchema: schema13.oneOf[0],
                                data,
                            };
                            if (vErrors === null) {
                                vErrors = [err2];
                            }
                            else {
                                vErrors.push(err2);
                            }
                            errors++;
                        }
                    }
                    if (data.type !== undefined) {
                        let data0 = data.type;
                        if ('procedural' !== data0) {
                            const err3 = {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/oneOf/0/properties/type/const',
                                keyword: 'const',
                                params: { allowedValue: 'procedural' },
                                message: 'must be equal to constant',
                                schema: 'procedural',
                                parentSchema: schema13.oneOf[0].properties.type,
                                data: data0,
                            };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                    }
                    if (data.preset !== undefined) {
                        let data1 = data.preset;
                        if (!(data1 === 'solar-system' || data1 === 'campus')) {
                            const err4 = {
                                instancePath: instancePath + '/preset',
                                schemaPath: '#/oneOf/0/properties/preset/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema13.oneOf[0].properties.preset.enum },
                                message: 'must be equal to one of the allowed values',
                                schema: schema13.oneOf[0].properties.preset.enum,
                                parentSchema: schema13.oneOf[0].properties.preset,
                                data: data1,
                            };
                            if (vErrors === null) {
                                vErrors = [err4];
                            }
                            else {
                                vErrors.push(err4);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err5 = {
                        instancePath,
                        schemaPath: '#/oneOf/0/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                        schema: schema13.oneOf[0].type,
                        parentSchema: schema13.oneOf[0],
                        data,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
            }
            else if (tag0 === 'gltf') {
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    if (data.type === undefined) {
                        const err6 = {
                            instancePath,
                            schemaPath: '#/oneOf/1/required',
                            keyword: 'required',
                            params: { missingProperty: 'type' },
                            message: "must have required property '" + 'type' + "'",
                            schema: schema13.oneOf[1].required,
                            parentSchema: schema13.oneOf[1],
                            data,
                        };
                        if (vErrors === null) {
                            vErrors = [err6];
                        }
                        else {
                            vErrors.push(err6);
                        }
                        errors++;
                    }
                    if (data.media === undefined) {
                        const err7 = {
                            instancePath,
                            schemaPath: '#/oneOf/1/required',
                            keyword: 'required',
                            params: { missingProperty: 'media' },
                            message: "must have required property '" + 'media' + "'",
                            schema: schema13.oneOf[1].required,
                            parentSchema: schema13.oneOf[1],
                            data,
                        };
                        if (vErrors === null) {
                            vErrors = [err7];
                        }
                        else {
                            vErrors.push(err7);
                        }
                        errors++;
                    }
                    for (const key1 in data) {
                        if (!(key1 === 'type' || key1 === 'media')) {
                            const err8 = {
                                instancePath,
                                schemaPath: '#/oneOf/1/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key1 },
                                message: 'must NOT have additional properties',
                                schema: false,
                                parentSchema: schema13.oneOf[1],
                                data,
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                    }
                    if (data.type !== undefined) {
                        let data2 = data.type;
                        if ('gltf' !== data2) {
                            const err9 = {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/oneOf/1/properties/type/const',
                                keyword: 'const',
                                params: { allowedValue: 'gltf' },
                                message: 'must be equal to constant',
                                schema: 'gltf',
                                parentSchema: schema13.oneOf[1].properties.type,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err9];
                            }
                            else {
                                vErrors.push(err9);
                            }
                            errors++;
                        }
                    }
                    if (data.media !== undefined) {
                        let data3 = data.media;
                        if (typeof data3 === 'string') {
                            if (!pattern1.test(data3)) {
                                const err10 = {
                                    instancePath: instancePath + '/media',
                                    schemaPath: '#/definitions/mediaId/pattern',
                                    keyword: 'pattern',
                                    params: { pattern: '^m_[A-Za-z0-9_-]{1,64}$' },
                                    message: 'must match pattern "' + '^m_[A-Za-z0-9_-]{1,64}$' + '"',
                                    schema: '^m_[A-Za-z0-9_-]{1,64}$',
                                    parentSchema: schema14,
                                    data: data3,
                                };
                                if (vErrors === null) {
                                    vErrors = [err10];
                                }
                                else {
                                    vErrors.push(err10);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err11 = {
                                instancePath: instancePath + '/media',
                                schemaPath: '#/definitions/mediaId/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                                schema: schema14.type,
                                parentSchema: schema14,
                                data: data3,
                            };
                            if (vErrors === null) {
                                vErrors = [err11];
                            }
                            else {
                                vErrors.push(err11);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err12 = {
                        instancePath,
                        schemaPath: '#/oneOf/1/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                        schema: schema13.oneOf[1].type,
                        parentSchema: schema13.oneOf[1],
                        data,
                    };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
            }
            else if (tag0 === 'pano360') {
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    if (data.type === undefined) {
                        const err13 = {
                            instancePath,
                            schemaPath: '#/oneOf/2/required',
                            keyword: 'required',
                            params: { missingProperty: 'type' },
                            message: "must have required property '" + 'type' + "'",
                            schema: schema13.oneOf[2].required,
                            parentSchema: schema13.oneOf[2],
                            data,
                        };
                        if (vErrors === null) {
                            vErrors = [err13];
                        }
                        else {
                            vErrors.push(err13);
                        }
                        errors++;
                    }
                    for (const key2 in data) {
                        if (!(key2 === 'type' ||
                            key2 === 'media' ||
                            key2 === 'want' ||
                            key2 === 'search' ||
                            key2 === 'brief' ||
                            key2 === 'credit' ||
                            key2 === 'yaw')) {
                            const err14 = {
                                instancePath,
                                schemaPath: '#/oneOf/2/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key2 },
                                message: 'must NOT have additional properties',
                                schema: false,
                                parentSchema: schema13.oneOf[2],
                                data,
                            };
                            if (vErrors === null) {
                                vErrors = [err14];
                            }
                            else {
                                vErrors.push(err14);
                            }
                            errors++;
                        }
                    }
                    if (data.type !== undefined) {
                        let data4 = data.type;
                        if ('pano360' !== data4) {
                            const err15 = {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/oneOf/2/properties/type/const',
                                keyword: 'const',
                                params: { allowedValue: 'pano360' },
                                message: 'must be equal to constant',
                                schema: 'pano360',
                                parentSchema: schema13.oneOf[2].properties.type,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err15];
                            }
                            else {
                                vErrors.push(err15);
                            }
                            errors++;
                        }
                    }
                    if (data.media !== undefined) {
                        let data5 = data.media;
                        if (typeof data5 === 'string') {
                            if (!pattern1.test(data5)) {
                                const err16 = {
                                    instancePath: instancePath + '/media',
                                    schemaPath: '#/definitions/mediaId/pattern',
                                    keyword: 'pattern',
                                    params: { pattern: '^m_[A-Za-z0-9_-]{1,64}$' },
                                    message: 'must match pattern "' + '^m_[A-Za-z0-9_-]{1,64}$' + '"',
                                    schema: '^m_[A-Za-z0-9_-]{1,64}$',
                                    parentSchema: schema14,
                                    data: data5,
                                };
                                if (vErrors === null) {
                                    vErrors = [err16];
                                }
                                else {
                                    vErrors.push(err16);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err17 = {
                                instancePath: instancePath + '/media',
                                schemaPath: '#/definitions/mediaId/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                                schema: schema14.type,
                                parentSchema: schema14,
                                data: data5,
                            };
                            if (vErrors === null) {
                                vErrors = [err17];
                            }
                            else {
                                vErrors.push(err17);
                            }
                            errors++;
                        }
                    }
                    if (data.want !== undefined) {
                        let data6 = data.want;
                        if (typeof data6 === 'string') {
                            if (func3(data6) > 200) {
                                const err18 = {
                                    instancePath: instancePath + '/want',
                                    schemaPath: '#/oneOf/2/properties/want/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 200 },
                                    message: 'must NOT have more than 200 characters',
                                    schema: 200,
                                    parentSchema: schema13.oneOf[2].properties.want,
                                    data: data6,
                                };
                                if (vErrors === null) {
                                    vErrors = [err18];
                                }
                                else {
                                    vErrors.push(err18);
                                }
                                errors++;
                            }
                            if (func3(data6) < 1) {
                                const err19 = {
                                    instancePath: instancePath + '/want',
                                    schemaPath: '#/oneOf/2/properties/want/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters',
                                    schema: 1,
                                    parentSchema: schema13.oneOf[2].properties.want,
                                    data: data6,
                                };
                                if (vErrors === null) {
                                    vErrors = [err19];
                                }
                                else {
                                    vErrors.push(err19);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err20 = {
                                instancePath: instancePath + '/want',
                                schemaPath: '#/oneOf/2/properties/want/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                                schema: schema13.oneOf[2].properties.want.type,
                                parentSchema: schema13.oneOf[2].properties.want,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err20];
                            }
                            else {
                                vErrors.push(err20);
                            }
                            errors++;
                        }
                    }
                    if (data.search !== undefined) {
                        let data7 = data.search;
                        if (typeof data7 === 'string') {
                            if (func3(data7) > 80) {
                                const err21 = {
                                    instancePath: instancePath + '/search',
                                    schemaPath: '#/oneOf/2/properties/search/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 80 },
                                    message: 'must NOT have more than 80 characters',
                                    schema: 80,
                                    parentSchema: schema13.oneOf[2].properties.search,
                                    data: data7,
                                };
                                if (vErrors === null) {
                                    vErrors = [err21];
                                }
                                else {
                                    vErrors.push(err21);
                                }
                                errors++;
                            }
                            if (func3(data7) < 1) {
                                const err22 = {
                                    instancePath: instancePath + '/search',
                                    schemaPath: '#/oneOf/2/properties/search/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters',
                                    schema: 1,
                                    parentSchema: schema13.oneOf[2].properties.search,
                                    data: data7,
                                };
                                if (vErrors === null) {
                                    vErrors = [err22];
                                }
                                else {
                                    vErrors.push(err22);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err23 = {
                                instancePath: instancePath + '/search',
                                schemaPath: '#/oneOf/2/properties/search/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                                schema: schema13.oneOf[2].properties.search.type,
                                parentSchema: schema13.oneOf[2].properties.search,
                                data: data7,
                            };
                            if (vErrors === null) {
                                vErrors = [err23];
                            }
                            else {
                                vErrors.push(err23);
                            }
                            errors++;
                        }
                    }
                    if (data.brief !== undefined) {
                        let data8 = data.brief;
                        if (!(typeof data8 == 'number' && !(data8 % 1) && !isNaN(data8) && isFinite(data8))) {
                            const err24 = {
                                instancePath: instancePath + '/brief',
                                schemaPath: '#/oneOf/2/properties/brief/type',
                                keyword: 'type',
                                params: { type: 'integer' },
                                message: 'must be integer',
                                schema: schema13.oneOf[2].properties.brief.type,
                                parentSchema: schema13.oneOf[2].properties.brief,
                                data: data8,
                            };
                            if (vErrors === null) {
                                vErrors = [err24];
                            }
                            else {
                                vErrors.push(err24);
                            }
                            errors++;
                        }
                        if (typeof data8 == 'number' && isFinite(data8)) {
                            if (data8 > 4 || isNaN(data8)) {
                                const err25 = {
                                    instancePath: instancePath + '/brief',
                                    schemaPath: '#/oneOf/2/properties/brief/maximum',
                                    keyword: 'maximum',
                                    params: { comparison: '<=', limit: 4 },
                                    message: 'must be <= 4',
                                    schema: 4,
                                    parentSchema: schema13.oneOf[2].properties.brief,
                                    data: data8,
                                };
                                if (vErrors === null) {
                                    vErrors = [err25];
                                }
                                else {
                                    vErrors.push(err25);
                                }
                                errors++;
                            }
                            if (data8 < 1 || isNaN(data8)) {
                                const err26 = {
                                    instancePath: instancePath + '/brief',
                                    schemaPath: '#/oneOf/2/properties/brief/minimum',
                                    keyword: 'minimum',
                                    params: { comparison: '>=', limit: 1 },
                                    message: 'must be >= 1',
                                    schema: 1,
                                    parentSchema: schema13.oneOf[2].properties.brief,
                                    data: data8,
                                };
                                if (vErrors === null) {
                                    vErrors = [err26];
                                }
                                else {
                                    vErrors.push(err26);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data.credit !== undefined) {
                        let data9 = data.credit;
                        if (typeof data9 === 'string') {
                            if (func3(data9) > 140) {
                                const err27 = {
                                    instancePath: instancePath + '/credit',
                                    schemaPath: '#/oneOf/2/properties/credit/maxLength',
                                    keyword: 'maxLength',
                                    params: { limit: 140 },
                                    message: 'must NOT have more than 140 characters',
                                    schema: 140,
                                    parentSchema: schema13.oneOf[2].properties.credit,
                                    data: data9,
                                };
                                if (vErrors === null) {
                                    vErrors = [err27];
                                }
                                else {
                                    vErrors.push(err27);
                                }
                                errors++;
                            }
                            if (func3(data9) < 1) {
                                const err28 = {
                                    instancePath: instancePath + '/credit',
                                    schemaPath: '#/oneOf/2/properties/credit/minLength',
                                    keyword: 'minLength',
                                    params: { limit: 1 },
                                    message: 'must NOT have fewer than 1 characters',
                                    schema: 1,
                                    parentSchema: schema13.oneOf[2].properties.credit,
                                    data: data9,
                                };
                                if (vErrors === null) {
                                    vErrors = [err28];
                                }
                                else {
                                    vErrors.push(err28);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err29 = {
                                instancePath: instancePath + '/credit',
                                schemaPath: '#/oneOf/2/properties/credit/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                                schema: schema13.oneOf[2].properties.credit.type,
                                parentSchema: schema13.oneOf[2].properties.credit,
                                data: data9,
                            };
                            if (vErrors === null) {
                                vErrors = [err29];
                            }
                            else {
                                vErrors.push(err29);
                            }
                            errors++;
                        }
                    }
                    if (data.yaw !== undefined) {
                        let data10 = data.yaw;
                        if (typeof data10 == 'number' && isFinite(data10)) {
                            if (data10 > 180 || isNaN(data10)) {
                                const err30 = {
                                    instancePath: instancePath + '/yaw',
                                    schemaPath: '#/oneOf/2/properties/yaw/maximum',
                                    keyword: 'maximum',
                                    params: { comparison: '<=', limit: 180 },
                                    message: 'must be <= 180',
                                    schema: 180,
                                    parentSchema: schema13.oneOf[2].properties.yaw,
                                    data: data10,
                                };
                                if (vErrors === null) {
                                    vErrors = [err30];
                                }
                                else {
                                    vErrors.push(err30);
                                }
                                errors++;
                            }
                            if (data10 < -180 || isNaN(data10)) {
                                const err31 = {
                                    instancePath: instancePath + '/yaw',
                                    schemaPath: '#/oneOf/2/properties/yaw/minimum',
                                    keyword: 'minimum',
                                    params: { comparison: '>=', limit: -180 },
                                    message: 'must be >= -180',
                                    schema: -180,
                                    parentSchema: schema13.oneOf[2].properties.yaw,
                                    data: data10,
                                };
                                if (vErrors === null) {
                                    vErrors = [err31];
                                }
                                else {
                                    vErrors.push(err31);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err32 = {
                                instancePath: instancePath + '/yaw',
                                schemaPath: '#/oneOf/2/properties/yaw/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                                schema: schema13.oneOf[2].properties.yaw.type,
                                parentSchema: schema13.oneOf[2].properties.yaw,
                                data: data10,
                            };
                            if (vErrors === null) {
                                vErrors = [err32];
                            }
                            else {
                                vErrors.push(err32);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err33 = {
                        instancePath,
                        schemaPath: '#/oneOf/2/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                        schema: schema13.oneOf[2].type,
                        parentSchema: schema13.oneOf[2],
                        data,
                    };
                    if (vErrors === null) {
                        vErrors = [err33];
                    }
                    else {
                        vErrors.push(err33);
                    }
                    errors++;
                }
            }
            else if (tag0 === 'ar-room') {
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    if (data.type === undefined) {
                        const err34 = {
                            instancePath,
                            schemaPath: '#/oneOf/3/required',
                            keyword: 'required',
                            params: { missingProperty: 'type' },
                            message: "must have required property '" + 'type' + "'",
                            schema: schema13.oneOf[3].required,
                            parentSchema: schema13.oneOf[3],
                            data,
                        };
                        if (vErrors === null) {
                            vErrors = [err34];
                        }
                        else {
                            vErrors.push(err34);
                        }
                        errors++;
                    }
                    for (const key3 in data) {
                        if (!(key3 === 'type')) {
                            const err35 = {
                                instancePath,
                                schemaPath: '#/oneOf/3/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key3 },
                                message: 'must NOT have additional properties',
                                schema: false,
                                parentSchema: schema13.oneOf[3],
                                data,
                            };
                            if (vErrors === null) {
                                vErrors = [err35];
                            }
                            else {
                                vErrors.push(err35);
                            }
                            errors++;
                        }
                    }
                    if (data.type !== undefined) {
                        let data11 = data.type;
                        if ('ar-room' !== data11) {
                            const err36 = {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/oneOf/3/properties/type/const',
                                keyword: 'const',
                                params: { allowedValue: 'ar-room' },
                                message: 'must be equal to constant',
                                schema: 'ar-room',
                                parentSchema: schema13.oneOf[3].properties.type,
                                data: data11,
                            };
                            if (vErrors === null) {
                                vErrors = [err36];
                            }
                            else {
                                vErrors.push(err36);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err37 = {
                        instancePath,
                        schemaPath: '#/oneOf/3/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                        schema: schema13.oneOf[3].type,
                        parentSchema: schema13.oneOf[3],
                        data,
                    };
                    if (vErrors === null) {
                        vErrors = [err37];
                    }
                    else {
                        vErrors.push(err37);
                    }
                    errors++;
                }
            }
            else if (tag0 === 'studio') {
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    if (data.type === undefined) {
                        const err38 = {
                            instancePath,
                            schemaPath: '#/oneOf/4/required',
                            keyword: 'required',
                            params: { missingProperty: 'type' },
                            message: "must have required property '" + 'type' + "'",
                            schema: schema13.oneOf[4].required,
                            parentSchema: schema13.oneOf[4],
                            data,
                        };
                        if (vErrors === null) {
                            vErrors = [err38];
                        }
                        else {
                            vErrors.push(err38);
                        }
                        errors++;
                    }
                    for (const key4 in data) {
                        if (!(key4 === 'type')) {
                            const err39 = {
                                instancePath,
                                schemaPath: '#/oneOf/4/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key4 },
                                message: 'must NOT have additional properties',
                                schema: false,
                                parentSchema: schema13.oneOf[4],
                                data,
                            };
                            if (vErrors === null) {
                                vErrors = [err39];
                            }
                            else {
                                vErrors.push(err39);
                            }
                            errors++;
                        }
                    }
                    if (data.type !== undefined) {
                        let data12 = data.type;
                        if ('studio' !== data12) {
                            const err40 = {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/oneOf/4/properties/type/const',
                                keyword: 'const',
                                params: { allowedValue: 'studio' },
                                message: 'must be equal to constant',
                                schema: 'studio',
                                parentSchema: schema13.oneOf[4].properties.type,
                                data: data12,
                            };
                            if (vErrors === null) {
                                vErrors = [err40];
                            }
                            else {
                                vErrors.push(err40);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err41 = {
                        instancePath,
                        schemaPath: '#/oneOf/4/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                        schema: schema13.oneOf[4].type,
                        parentSchema: schema13.oneOf[4],
                        data,
                    };
                    if (vErrors === null) {
                        vErrors = [err41];
                    }
                    else {
                        vErrors.push(err41);
                    }
                    errors++;
                }
            }
            else if (tag0 === 'world') {
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    if (data.type === undefined) {
                        const err42 = {
                            instancePath,
                            schemaPath: '#/oneOf/5/required',
                            keyword: 'required',
                            params: { missingProperty: 'type' },
                            message: "must have required property '" + 'type' + "'",
                            schema: schema13.oneOf[5].required,
                            parentSchema: schema13.oneOf[5],
                            data,
                        };
                        if (vErrors === null) {
                            vErrors = [err42];
                        }
                        else {
                            vErrors.push(err42);
                        }
                        errors++;
                    }
                    if (data.world === undefined) {
                        const err43 = {
                            instancePath,
                            schemaPath: '#/oneOf/5/required',
                            keyword: 'required',
                            params: { missingProperty: 'world' },
                            message: "must have required property '" + 'world' + "'",
                            schema: schema13.oneOf[5].required,
                            parentSchema: schema13.oneOf[5],
                            data,
                        };
                        if (vErrors === null) {
                            vErrors = [err43];
                        }
                        else {
                            vErrors.push(err43);
                        }
                        errors++;
                    }
                    for (const key5 in data) {
                        if (!(key5 === 'type' || key5 === 'world')) {
                            const err44 = {
                                instancePath,
                                schemaPath: '#/oneOf/5/additionalProperties',
                                keyword: 'additionalProperties',
                                params: { additionalProperty: key5 },
                                message: 'must NOT have additional properties',
                                schema: false,
                                parentSchema: schema13.oneOf[5],
                                data,
                            };
                            if (vErrors === null) {
                                vErrors = [err44];
                            }
                            else {
                                vErrors.push(err44);
                            }
                            errors++;
                        }
                    }
                    if (data.type !== undefined) {
                        let data13 = data.type;
                        if ('world' !== data13) {
                            const err45 = {
                                instancePath: instancePath + '/type',
                                schemaPath: '#/oneOf/5/properties/type/const',
                                keyword: 'const',
                                params: { allowedValue: 'world' },
                                message: 'must be equal to constant',
                                schema: 'world',
                                parentSchema: schema13.oneOf[5].properties.type,
                                data: data13,
                            };
                            if (vErrors === null) {
                                vErrors = [err45];
                            }
                            else {
                                vErrors.push(err45);
                            }
                            errors++;
                        }
                    }
                    if (data.world !== undefined) {
                        let data14 = data.world;
                        if (typeof data14 === 'string') {
                            if (!pattern3.test(data14)) {
                                const err46 = {
                                    instancePath: instancePath + '/world',
                                    schemaPath: '#/oneOf/5/properties/world/pattern',
                                    keyword: 'pattern',
                                    params: { pattern: '^[a-z][a-z0-9-]{1,39}$' },
                                    message: 'must match pattern "' + '^[a-z][a-z0-9-]{1,39}$' + '"',
                                    schema: '^[a-z][a-z0-9-]{1,39}$',
                                    parentSchema: schema13.oneOf[5].properties.world,
                                    data: data14,
                                };
                                if (vErrors === null) {
                                    vErrors = [err46];
                                }
                                else {
                                    vErrors.push(err46);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err47 = {
                                instancePath: instancePath + '/world',
                                schemaPath: '#/oneOf/5/properties/world/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string',
                                schema: schema13.oneOf[5].properties.world.type,
                                parentSchema: schema13.oneOf[5].properties.world,
                                data: data14,
                            };
                            if (vErrors === null) {
                                vErrors = [err47];
                            }
                            else {
                                vErrors.push(err47);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err48 = {
                        instancePath,
                        schemaPath: '#/oneOf/5/type',
                        keyword: 'type',
                        params: { type: 'object' },
                        message: 'must be object',
                        schema: schema13.oneOf[5].type,
                        parentSchema: schema13.oneOf[5],
                        data,
                    };
                    if (vErrors === null) {
                        vErrors = [err48];
                    }
                    else {
                        vErrors.push(err48);
                    }
                    errors++;
                }
            }
            else {
                const err49 = {
                    instancePath,
                    schemaPath: '#/discriminator',
                    keyword: 'discriminator',
                    params: { error: 'mapping', tag: 'type', tagValue: tag0 },
                    message: 'value of tag "type" must be in oneOf',
                    schema: schema13.discriminator,
                    parentSchema: schema13,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err49];
                }
                else {
                    vErrors.push(err49);
                }
                errors++;
            }
        }
        else {
            const err50 = {
                instancePath,
                schemaPath: '#/discriminator',
                keyword: 'discriminator',
                params: { error: 'tag', tag: 'type', tagValue: tag0 },
                message: 'tag "type" must be string',
                schema: schema13.discriminator,
                parentSchema: schema13,
                data,
            };
            if (vErrors === null) {
                vErrors = [err50];
            }
            else {
                vErrors.push(err50);
            }
            errors++;
        }
    }
    else {
        const err51 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema13.type,
            parentSchema: schema13,
            data,
        };
        if (vErrors === null) {
            vErrors = [err51];
        }
        else {
            vErrors.push(err51);
        }
        errors++;
    }
    validate11.errors = vErrors;
    return errors === 0;
}
const schema17 = {
    type: 'object',
    additionalProperties: false,
    required: ['kind', 'label'],
    properties: {
        kind: {
            description: 'namespace:name. The engine registers a builder per namespace, which is what makes new object types pluggable.',
            type: 'string',
            pattern: '^(model:[a-z0-9-]{2,40}|[a-z][a-z0-9-]*:[a-z][a-z0-9-]*)$',
        },
        label: { type: 'string', minLength: 1, maxLength: 60 },
        pos: { $ref: '#/definitions/vec3' },
        radius: { type: 'number', exclusiveMinimum: 0 },
        spin: { description: 'Radians per second about the y axis.', type: 'number' },
        tilt: { description: 'Axial tilt in radians.', type: 'number' },
        ring: {
            description: "Inner and outer radius as a multiple of the object's radius.",
            type: 'array',
            minItems: 2,
            maxItems: 2,
            items: { type: 'number', exclusiveMinimum: 0 },
        },
        parent: {
            description: 'Another object this one orbits. The Moon is modelled this way rather than as a flag on Earth, so hotspots can target it.',
            $ref: '#/definitions/slug',
        },
        orbit: {
            description: 'Orbit radius in metres around parent.',
            type: 'number',
            exclusiveMinimum: 0,
        },
        parts: {
            description: 'What a shape: object is made of (ADR-030). Only a shape takes parts, and a shape must have them. At most 64 in total, counting the parts inside groups, and at most 30 shape objects per lesson: both checked by the validator, because a schema cannot count across levels.',
            type: 'array',
            minItems: 1,
            maxItems: 64,
            items: { $ref: '#/definitions/shapePart' },
        },
        hidden: { description: 'True: not there until a step shows it. VR only.', type: 'boolean' },
        rot: {
            description: 'A shape only: degrees about x, y and z, turned about its pos.',
            $ref: '#/definitions/shapeRotation',
        },
        scale: {
            description: 'A shape only: bigger or smaller alike in every direction.',
            type: 'number',
            minimum: 0.1,
            maximum: 10,
        },
        width: {
            description: "A poster only: the photo's width in metres. Its height follows the photo.",
            type: 'number',
            minimum: 0.4,
            maximum: 3,
        },
        facing: {
            description: 'A poster only: degrees about the vertical axis; 0 faces +z. Absent: it faces where the pupil stands for the first step about it.',
            type: 'number',
            minimum: -360,
            maximum: 360,
        },
        caption: {
            description: 'A poster only: a short Dutch caption under the photo.',
            type: 'string',
            minLength: 1,
            maxLength: 80,
        },
        want: {
            description: 'A poster only: what the photo should show, in Dutch. The platform finds the photo.',
            type: 'string',
            minLength: 1,
            maxLength: 200,
        },
        search: {
            description: 'A poster only: 1-6 English words to search for the photo with.',
            type: 'string',
            minLength: 1,
            maxLength: 80,
        },
        media: {
            description: 'A poster only: the photo. Filled in by the platform, never written by a model.',
            $ref: '#/definitions/mediaId',
        },
        aspect: {
            description: "A poster only: the photo's width divided by its height. Filled in by the platform.",
            type: 'number',
            minimum: 0.4,
            maximum: 2.5,
        },
        credit: {
            description: 'A poster only: who made the photo and under which licence. Filled in by the platform.',
            type: 'string',
            minLength: 1,
            maxLength: 140,
        },
        turn: {
            description: 'A model only: degrees about the vertical axis; 0 faces -z, the way the pupil looks at the start, and positive turns left.',
            type: 'number',
            minimum: -360,
            maximum: 360,
        },
        size: {
            description: 'A model only: metres along its size axis. Absent: its real size.',
            type: 'number',
            minimum: 0.05,
            maximum: 80,
        },
        above: {
            description: 'A model that swims or flies only: metres from the land up to the bottom of its box; default 0. The same for the whole lesson.',
            type: 'number',
            minimum: 0,
            maximum: 20,
        },
    },
};
const schema18 = {
    description: 'Metres in the room, [x, y, z].',
    type: 'array',
    minItems: 3,
    maxItems: 3,
    items: { type: 'number' },
};
const schema24 = {
    description: 'Degrees about the x, y and z axes, [x, y, z].',
    type: 'array',
    minItems: 3,
    maxItems: 3,
    items: { type: 'number', minimum: -360, maximum: 360 },
};
const pattern5 = new RegExp('^(model:[a-z0-9-]{2,40}|[a-z][a-z0-9-]*:[a-z][a-z0-9-]*)$', 'u');
const schema20 = {
    description: 'A part of a shape object: something drawn, or a group of parts. Written out level by level rather than as one recursive definition, so nesting stops at three levels by construction and the structured-output variant can inline it (ADR-030).',
    type: 'object',
    discriminator: { propertyName: 'type' },
    oneOf: [
        { $ref: '#/definitions/shapeBox' },
        { $ref: '#/definitions/shapeSphere' },
        { $ref: '#/definitions/shapeCylinder' },
        { $ref: '#/definitions/shapeCone' },
        { $ref: '#/definitions/shapeTorus' },
        { $ref: '#/definitions/shapeCapsule' },
        { $ref: '#/definitions/shapePlane' },
        { $ref: '#/definitions/shapeLathe' },
        { $ref: '#/definitions/shapeExtrude' },
        { $ref: '#/definitions/shapeGroup' },
    ],
};
const schema21 = {
    type: 'object',
    additionalProperties: false,
    required: ['type', 'size', 'color'],
    properties: {
        type: { const: 'box' },
        size: {
            description: '[width, height, depth]',
            type: 'array',
            minItems: 3,
            maxItems: 3,
            items: { $ref: '#/definitions/shapeSize' },
        },
        pos: { $ref: '#/definitions/shapeOffset' },
        rot: { $ref: '#/definitions/shapeRotation' },
        color: { $ref: '#/definitions/shapeColour' },
        opacity: { $ref: '#/definitions/shapeOpacity' },
        stand: { $ref: '#/definitions/shapeStand' },
        finish: { $ref: '#/definitions/shapeFinish' },
    },
};
const schema22 = {
    description: 'Metres, between 5 mm and 10 m: nothing too small to see, nothing bigger than a room.',
    type: 'number',
    minimum: 0.005,
    maximum: 10,
};
const schema23 = {
    description: 'Metres from the middle of the object, or of the group the part is in, [x, y, z].',
    type: 'array',
    minItems: 3,
    maxItems: 3,
    items: { type: 'number', minimum: -10, maximum: 10 },
};
const schema25 = {
    description: 'A flat colour, #rrggbb. Shapes have no textures.',
    type: 'string',
    pattern: '^#[0-9a-fA-F]{6}$',
};
const schema26 = {
    description: '1 is solid. Lower lets what is inside show through; below 0.1 a part is as good as invisible.',
    type: 'number',
    minimum: 0.1,
    maximum: 1,
};
const schema27 = {
    description: 'True on the part a thing stands on -- a plinth, a pedestal -- and not on what a step is about. The engine frames the subject without it, so a plinth on the floor does not drag the view down to the floor. Drawn as any other part.',
    type: 'boolean',
};
const schema28 = {
    description: 'How the surface looks: matte (the default), gloss (wet or polished) or glow (hot, or giving light).',
    enum: ['matte', 'gloss', 'glow'],
};
const pattern7 = new RegExp('^#[0-9a-fA-F]{6}$', 'u');
function validate15(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema21.required,
                parentSchema: schema21,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.size === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'size' },
                message: "must have required property '" + 'size' + "'",
                schema: schema21.required,
                parentSchema: schema21,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.color === undefined) {
            const err2 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'color' },
                message: "must have required property '" + 'color' + "'",
                schema: schema21.required,
                parentSchema: schema21,
                data,
            };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'type' ||
                key0 === 'size' ||
                key0 === 'pos' ||
                key0 === 'rot' ||
                key0 === 'color' ||
                key0 === 'opacity' ||
                key0 === 'stand' ||
                key0 === 'finish')) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema21,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.type !== undefined) {
            let data0 = data.type;
            if ('box' !== data0) {
                const err4 = {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'box' },
                    message: 'must be equal to constant',
                    schema: 'box',
                    parentSchema: schema21.properties.type,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.size !== undefined) {
            let data1 = data.size;
            if (Array.isArray(data1)) {
                if (data1.length > 3) {
                    const err5 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema21.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (data1.length < 3) {
                    const err6 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema21.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (typeof data2 == 'number' && isFinite(data2)) {
                        if (data2 > 10 || isNaN(data2)) {
                            const err7 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        if (data2 < 0.005 || isNaN(data2)) {
                            const err8 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: 0.005 },
                                message: 'must be >= 0.005',
                                schema: 0.005,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err9 = {
                            instancePath: instancePath + '/size/' + i0,
                            schemaPath: '#/definitions/shapeSize/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema22.type,
                            parentSchema: schema22,
                            data: data2,
                        };
                        if (vErrors === null) {
                            vErrors = [err9];
                        }
                        else {
                            vErrors.push(err9);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err10 = {
                    instancePath: instancePath + '/size',
                    schemaPath: '#/properties/size/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema21.properties.size.type,
                    parentSchema: schema21.properties.size,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data3 = data.pos;
            if (Array.isArray(data3)) {
                if (data3.length > 3) {
                    const err11 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
                if (data3.length < 3) {
                    const err12 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
                const len1 = data3.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    let data4 = data3[i1];
                    if (typeof data4 == 'number' && isFinite(data4)) {
                        if (data4 > 10 || isNaN(data4)) {
                            const err13 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err13];
                            }
                            else {
                                vErrors.push(err13);
                            }
                            errors++;
                        }
                        if (data4 < -10 || isNaN(data4)) {
                            const err14 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -10 },
                                message: 'must be >= -10',
                                schema: -10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err14];
                            }
                            else {
                                vErrors.push(err14);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err15 = {
                            instancePath: instancePath + '/pos/' + i1,
                            schemaPath: '#/definitions/shapeOffset/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema23.items.type,
                            parentSchema: schema23.items,
                            data: data4,
                        };
                        if (vErrors === null) {
                            vErrors = [err15];
                        }
                        else {
                            vErrors.push(err15);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err16 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/shapeOffset/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema23.type,
                    parentSchema: schema23,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.rot !== undefined) {
            let data5 = data.rot;
            if (Array.isArray(data5)) {
                if (data5.length > 3) {
                    const err17 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
                if (data5.length < 3) {
                    const err18 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                const len2 = data5.length;
                for (let i2 = 0; i2 < len2; i2++) {
                    let data6 = data5[i2];
                    if (typeof data6 == 'number' && isFinite(data6)) {
                        if (data6 > 360 || isNaN(data6)) {
                            const err19 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 360 },
                                message: 'must be <= 360',
                                schema: 360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err19];
                            }
                            else {
                                vErrors.push(err19);
                            }
                            errors++;
                        }
                        if (data6 < -360 || isNaN(data6)) {
                            const err20 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -360 },
                                message: 'must be >= -360',
                                schema: -360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err20];
                            }
                            else {
                                vErrors.push(err20);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err21 = {
                            instancePath: instancePath + '/rot/' + i2,
                            schemaPath: '#/definitions/shapeRotation/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema24.items.type,
                            parentSchema: schema24.items,
                            data: data6,
                        };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err22 = {
                    instancePath: instancePath + '/rot',
                    schemaPath: '#/definitions/shapeRotation/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema24.type,
                    parentSchema: schema24,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err22];
                }
                else {
                    vErrors.push(err22);
                }
                errors++;
            }
        }
        if (data.color !== undefined) {
            let data7 = data.color;
            if (typeof data7 === 'string') {
                if (!pattern7.test(data7)) {
                    const err23 = {
                        instancePath: instancePath + '/color',
                        schemaPath: '#/definitions/shapeColour/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^#[0-9a-fA-F]{6}$' },
                        message: 'must match pattern "' + '^#[0-9a-fA-F]{6}$' + '"',
                        schema: '^#[0-9a-fA-F]{6}$',
                        parentSchema: schema25,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            else {
                const err24 = {
                    instancePath: instancePath + '/color',
                    schemaPath: '#/definitions/shapeColour/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema25.type,
                    parentSchema: schema25,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err24];
                }
                else {
                    vErrors.push(err24);
                }
                errors++;
            }
        }
        if (data.opacity !== undefined) {
            let data8 = data.opacity;
            if (typeof data8 == 'number' && isFinite(data8)) {
                if (data8 > 1 || isNaN(data8)) {
                    const err25 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 1 },
                        message: 'must be <= 1',
                        schema: 1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
                if (data8 < 0.1 || isNaN(data8)) {
                    const err26 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.1 },
                        message: 'must be >= 0.1',
                        schema: 0.1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            else {
                const err27 = {
                    instancePath: instancePath + '/opacity',
                    schemaPath: '#/definitions/shapeOpacity/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema26.type,
                    parentSchema: schema26,
                    data: data8,
                };
                if (vErrors === null) {
                    vErrors = [err27];
                }
                else {
                    vErrors.push(err27);
                }
                errors++;
            }
        }
        if (data.stand !== undefined) {
            let data9 = data.stand;
            if (typeof data9 !== 'boolean') {
                const err28 = {
                    instancePath: instancePath + '/stand',
                    schemaPath: '#/definitions/shapeStand/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema27.type,
                    parentSchema: schema27,
                    data: data9,
                };
                if (vErrors === null) {
                    vErrors = [err28];
                }
                else {
                    vErrors.push(err28);
                }
                errors++;
            }
        }
        if (data.finish !== undefined) {
            let data10 = data.finish;
            if (!(data10 === 'matte' || data10 === 'gloss' || data10 === 'glow')) {
                const err29 = {
                    instancePath: instancePath + '/finish',
                    schemaPath: '#/definitions/shapeFinish/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema28.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema28.enum,
                    parentSchema: schema28,
                    data: data10,
                };
                if (vErrors === null) {
                    vErrors = [err29];
                }
                else {
                    vErrors.push(err29);
                }
                errors++;
            }
        }
    }
    else {
        const err30 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema21.type,
            parentSchema: schema21,
            data,
        };
        if (vErrors === null) {
            vErrors = [err30];
        }
        else {
            vErrors.push(err30);
        }
        errors++;
    }
    validate15.errors = vErrors;
    return errors === 0;
}
const schema29 = {
    type: 'object',
    additionalProperties: false,
    required: ['type', 'size', 'color'],
    properties: {
        type: { const: 'sphere' },
        size: {
            description: '[radius]',
            type: 'array',
            minItems: 1,
            maxItems: 1,
            items: { $ref: '#/definitions/shapeSize' },
        },
        pos: { $ref: '#/definitions/shapeOffset' },
        rot: { $ref: '#/definitions/shapeRotation' },
        color: { $ref: '#/definitions/shapeColour' },
        opacity: { $ref: '#/definitions/shapeOpacity' },
        stand: { $ref: '#/definitions/shapeStand' },
        finish: { $ref: '#/definitions/shapeFinish' },
    },
};
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema29.required,
                parentSchema: schema29,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.size === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'size' },
                message: "must have required property '" + 'size' + "'",
                schema: schema29.required,
                parentSchema: schema29,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.color === undefined) {
            const err2 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'color' },
                message: "must have required property '" + 'color' + "'",
                schema: schema29.required,
                parentSchema: schema29,
                data,
            };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'type' ||
                key0 === 'size' ||
                key0 === 'pos' ||
                key0 === 'rot' ||
                key0 === 'color' ||
                key0 === 'opacity' ||
                key0 === 'stand' ||
                key0 === 'finish')) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema29,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.type !== undefined) {
            let data0 = data.type;
            if ('sphere' !== data0) {
                const err4 = {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'sphere' },
                    message: 'must be equal to constant',
                    schema: 'sphere',
                    parentSchema: schema29.properties.type,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.size !== undefined) {
            let data1 = data.size;
            if (Array.isArray(data1)) {
                if (data1.length > 1) {
                    const err5 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 1 },
                        message: 'must NOT have more than 1 items',
                        schema: 1,
                        parentSchema: schema29.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (data1.length < 1) {
                    const err6 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/minItems',
                        keyword: 'minItems',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 items',
                        schema: 1,
                        parentSchema: schema29.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (typeof data2 == 'number' && isFinite(data2)) {
                        if (data2 > 10 || isNaN(data2)) {
                            const err7 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        if (data2 < 0.005 || isNaN(data2)) {
                            const err8 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: 0.005 },
                                message: 'must be >= 0.005',
                                schema: 0.005,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err9 = {
                            instancePath: instancePath + '/size/' + i0,
                            schemaPath: '#/definitions/shapeSize/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema22.type,
                            parentSchema: schema22,
                            data: data2,
                        };
                        if (vErrors === null) {
                            vErrors = [err9];
                        }
                        else {
                            vErrors.push(err9);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err10 = {
                    instancePath: instancePath + '/size',
                    schemaPath: '#/properties/size/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema29.properties.size.type,
                    parentSchema: schema29.properties.size,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data3 = data.pos;
            if (Array.isArray(data3)) {
                if (data3.length > 3) {
                    const err11 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
                if (data3.length < 3) {
                    const err12 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
                const len1 = data3.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    let data4 = data3[i1];
                    if (typeof data4 == 'number' && isFinite(data4)) {
                        if (data4 > 10 || isNaN(data4)) {
                            const err13 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err13];
                            }
                            else {
                                vErrors.push(err13);
                            }
                            errors++;
                        }
                        if (data4 < -10 || isNaN(data4)) {
                            const err14 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -10 },
                                message: 'must be >= -10',
                                schema: -10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err14];
                            }
                            else {
                                vErrors.push(err14);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err15 = {
                            instancePath: instancePath + '/pos/' + i1,
                            schemaPath: '#/definitions/shapeOffset/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema23.items.type,
                            parentSchema: schema23.items,
                            data: data4,
                        };
                        if (vErrors === null) {
                            vErrors = [err15];
                        }
                        else {
                            vErrors.push(err15);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err16 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/shapeOffset/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema23.type,
                    parentSchema: schema23,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.rot !== undefined) {
            let data5 = data.rot;
            if (Array.isArray(data5)) {
                if (data5.length > 3) {
                    const err17 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
                if (data5.length < 3) {
                    const err18 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                const len2 = data5.length;
                for (let i2 = 0; i2 < len2; i2++) {
                    let data6 = data5[i2];
                    if (typeof data6 == 'number' && isFinite(data6)) {
                        if (data6 > 360 || isNaN(data6)) {
                            const err19 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 360 },
                                message: 'must be <= 360',
                                schema: 360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err19];
                            }
                            else {
                                vErrors.push(err19);
                            }
                            errors++;
                        }
                        if (data6 < -360 || isNaN(data6)) {
                            const err20 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -360 },
                                message: 'must be >= -360',
                                schema: -360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err20];
                            }
                            else {
                                vErrors.push(err20);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err21 = {
                            instancePath: instancePath + '/rot/' + i2,
                            schemaPath: '#/definitions/shapeRotation/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema24.items.type,
                            parentSchema: schema24.items,
                            data: data6,
                        };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err22 = {
                    instancePath: instancePath + '/rot',
                    schemaPath: '#/definitions/shapeRotation/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema24.type,
                    parentSchema: schema24,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err22];
                }
                else {
                    vErrors.push(err22);
                }
                errors++;
            }
        }
        if (data.color !== undefined) {
            let data7 = data.color;
            if (typeof data7 === 'string') {
                if (!pattern7.test(data7)) {
                    const err23 = {
                        instancePath: instancePath + '/color',
                        schemaPath: '#/definitions/shapeColour/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^#[0-9a-fA-F]{6}$' },
                        message: 'must match pattern "' + '^#[0-9a-fA-F]{6}$' + '"',
                        schema: '^#[0-9a-fA-F]{6}$',
                        parentSchema: schema25,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            else {
                const err24 = {
                    instancePath: instancePath + '/color',
                    schemaPath: '#/definitions/shapeColour/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema25.type,
                    parentSchema: schema25,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err24];
                }
                else {
                    vErrors.push(err24);
                }
                errors++;
            }
        }
        if (data.opacity !== undefined) {
            let data8 = data.opacity;
            if (typeof data8 == 'number' && isFinite(data8)) {
                if (data8 > 1 || isNaN(data8)) {
                    const err25 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 1 },
                        message: 'must be <= 1',
                        schema: 1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
                if (data8 < 0.1 || isNaN(data8)) {
                    const err26 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.1 },
                        message: 'must be >= 0.1',
                        schema: 0.1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            else {
                const err27 = {
                    instancePath: instancePath + '/opacity',
                    schemaPath: '#/definitions/shapeOpacity/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema26.type,
                    parentSchema: schema26,
                    data: data8,
                };
                if (vErrors === null) {
                    vErrors = [err27];
                }
                else {
                    vErrors.push(err27);
                }
                errors++;
            }
        }
        if (data.stand !== undefined) {
            let data9 = data.stand;
            if (typeof data9 !== 'boolean') {
                const err28 = {
                    instancePath: instancePath + '/stand',
                    schemaPath: '#/definitions/shapeStand/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema27.type,
                    parentSchema: schema27,
                    data: data9,
                };
                if (vErrors === null) {
                    vErrors = [err28];
                }
                else {
                    vErrors.push(err28);
                }
                errors++;
            }
        }
        if (data.finish !== undefined) {
            let data10 = data.finish;
            if (!(data10 === 'matte' || data10 === 'gloss' || data10 === 'glow')) {
                const err29 = {
                    instancePath: instancePath + '/finish',
                    schemaPath: '#/definitions/shapeFinish/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema28.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema28.enum,
                    parentSchema: schema28,
                    data: data10,
                };
                if (vErrors === null) {
                    vErrors = [err29];
                }
                else {
                    vErrors.push(err29);
                }
                errors++;
            }
        }
    }
    else {
        const err30 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema29.type,
            parentSchema: schema29,
            data,
        };
        if (vErrors === null) {
            vErrors = [err30];
        }
        else {
            vErrors.push(err30);
        }
        errors++;
    }
    validate16.errors = vErrors;
    return errors === 0;
}
const schema37 = {
    type: 'object',
    additionalProperties: false,
    required: ['type', 'size', 'color'],
    properties: {
        type: { const: 'cylinder' },
        size: {
            description: '[top radius, bottom radius, height], standing on the y axis',
            type: 'array',
            minItems: 3,
            maxItems: 3,
            items: { $ref: '#/definitions/shapeSize' },
        },
        pos: { $ref: '#/definitions/shapeOffset' },
        rot: { $ref: '#/definitions/shapeRotation' },
        color: { $ref: '#/definitions/shapeColour' },
        opacity: { $ref: '#/definitions/shapeOpacity' },
        stand: { $ref: '#/definitions/shapeStand' },
        finish: { $ref: '#/definitions/shapeFinish' },
    },
};
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema37.required,
                parentSchema: schema37,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.size === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'size' },
                message: "must have required property '" + 'size' + "'",
                schema: schema37.required,
                parentSchema: schema37,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.color === undefined) {
            const err2 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'color' },
                message: "must have required property '" + 'color' + "'",
                schema: schema37.required,
                parentSchema: schema37,
                data,
            };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'type' ||
                key0 === 'size' ||
                key0 === 'pos' ||
                key0 === 'rot' ||
                key0 === 'color' ||
                key0 === 'opacity' ||
                key0 === 'stand' ||
                key0 === 'finish')) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema37,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.type !== undefined) {
            let data0 = data.type;
            if ('cylinder' !== data0) {
                const err4 = {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'cylinder' },
                    message: 'must be equal to constant',
                    schema: 'cylinder',
                    parentSchema: schema37.properties.type,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.size !== undefined) {
            let data1 = data.size;
            if (Array.isArray(data1)) {
                if (data1.length > 3) {
                    const err5 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema37.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (data1.length < 3) {
                    const err6 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema37.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (typeof data2 == 'number' && isFinite(data2)) {
                        if (data2 > 10 || isNaN(data2)) {
                            const err7 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        if (data2 < 0.005 || isNaN(data2)) {
                            const err8 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: 0.005 },
                                message: 'must be >= 0.005',
                                schema: 0.005,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err9 = {
                            instancePath: instancePath + '/size/' + i0,
                            schemaPath: '#/definitions/shapeSize/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema22.type,
                            parentSchema: schema22,
                            data: data2,
                        };
                        if (vErrors === null) {
                            vErrors = [err9];
                        }
                        else {
                            vErrors.push(err9);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err10 = {
                    instancePath: instancePath + '/size',
                    schemaPath: '#/properties/size/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema37.properties.size.type,
                    parentSchema: schema37.properties.size,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data3 = data.pos;
            if (Array.isArray(data3)) {
                if (data3.length > 3) {
                    const err11 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
                if (data3.length < 3) {
                    const err12 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
                const len1 = data3.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    let data4 = data3[i1];
                    if (typeof data4 == 'number' && isFinite(data4)) {
                        if (data4 > 10 || isNaN(data4)) {
                            const err13 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err13];
                            }
                            else {
                                vErrors.push(err13);
                            }
                            errors++;
                        }
                        if (data4 < -10 || isNaN(data4)) {
                            const err14 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -10 },
                                message: 'must be >= -10',
                                schema: -10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err14];
                            }
                            else {
                                vErrors.push(err14);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err15 = {
                            instancePath: instancePath + '/pos/' + i1,
                            schemaPath: '#/definitions/shapeOffset/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema23.items.type,
                            parentSchema: schema23.items,
                            data: data4,
                        };
                        if (vErrors === null) {
                            vErrors = [err15];
                        }
                        else {
                            vErrors.push(err15);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err16 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/shapeOffset/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema23.type,
                    parentSchema: schema23,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.rot !== undefined) {
            let data5 = data.rot;
            if (Array.isArray(data5)) {
                if (data5.length > 3) {
                    const err17 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
                if (data5.length < 3) {
                    const err18 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                const len2 = data5.length;
                for (let i2 = 0; i2 < len2; i2++) {
                    let data6 = data5[i2];
                    if (typeof data6 == 'number' && isFinite(data6)) {
                        if (data6 > 360 || isNaN(data6)) {
                            const err19 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 360 },
                                message: 'must be <= 360',
                                schema: 360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err19];
                            }
                            else {
                                vErrors.push(err19);
                            }
                            errors++;
                        }
                        if (data6 < -360 || isNaN(data6)) {
                            const err20 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -360 },
                                message: 'must be >= -360',
                                schema: -360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err20];
                            }
                            else {
                                vErrors.push(err20);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err21 = {
                            instancePath: instancePath + '/rot/' + i2,
                            schemaPath: '#/definitions/shapeRotation/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema24.items.type,
                            parentSchema: schema24.items,
                            data: data6,
                        };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err22 = {
                    instancePath: instancePath + '/rot',
                    schemaPath: '#/definitions/shapeRotation/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema24.type,
                    parentSchema: schema24,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err22];
                }
                else {
                    vErrors.push(err22);
                }
                errors++;
            }
        }
        if (data.color !== undefined) {
            let data7 = data.color;
            if (typeof data7 === 'string') {
                if (!pattern7.test(data7)) {
                    const err23 = {
                        instancePath: instancePath + '/color',
                        schemaPath: '#/definitions/shapeColour/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^#[0-9a-fA-F]{6}$' },
                        message: 'must match pattern "' + '^#[0-9a-fA-F]{6}$' + '"',
                        schema: '^#[0-9a-fA-F]{6}$',
                        parentSchema: schema25,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            else {
                const err24 = {
                    instancePath: instancePath + '/color',
                    schemaPath: '#/definitions/shapeColour/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema25.type,
                    parentSchema: schema25,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err24];
                }
                else {
                    vErrors.push(err24);
                }
                errors++;
            }
        }
        if (data.opacity !== undefined) {
            let data8 = data.opacity;
            if (typeof data8 == 'number' && isFinite(data8)) {
                if (data8 > 1 || isNaN(data8)) {
                    const err25 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 1 },
                        message: 'must be <= 1',
                        schema: 1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
                if (data8 < 0.1 || isNaN(data8)) {
                    const err26 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.1 },
                        message: 'must be >= 0.1',
                        schema: 0.1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            else {
                const err27 = {
                    instancePath: instancePath + '/opacity',
                    schemaPath: '#/definitions/shapeOpacity/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema26.type,
                    parentSchema: schema26,
                    data: data8,
                };
                if (vErrors === null) {
                    vErrors = [err27];
                }
                else {
                    vErrors.push(err27);
                }
                errors++;
            }
        }
        if (data.stand !== undefined) {
            let data9 = data.stand;
            if (typeof data9 !== 'boolean') {
                const err28 = {
                    instancePath: instancePath + '/stand',
                    schemaPath: '#/definitions/shapeStand/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema27.type,
                    parentSchema: schema27,
                    data: data9,
                };
                if (vErrors === null) {
                    vErrors = [err28];
                }
                else {
                    vErrors.push(err28);
                }
                errors++;
            }
        }
        if (data.finish !== undefined) {
            let data10 = data.finish;
            if (!(data10 === 'matte' || data10 === 'gloss' || data10 === 'glow')) {
                const err29 = {
                    instancePath: instancePath + '/finish',
                    schemaPath: '#/definitions/shapeFinish/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema28.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema28.enum,
                    parentSchema: schema28,
                    data: data10,
                };
                if (vErrors === null) {
                    vErrors = [err29];
                }
                else {
                    vErrors.push(err29);
                }
                errors++;
            }
        }
    }
    else {
        const err30 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema37.type,
            parentSchema: schema37,
            data,
        };
        if (vErrors === null) {
            vErrors = [err30];
        }
        else {
            vErrors.push(err30);
        }
        errors++;
    }
    validate17.errors = vErrors;
    return errors === 0;
}
const schema45 = {
    type: 'object',
    additionalProperties: false,
    required: ['type', 'size', 'color'],
    properties: {
        type: { const: 'cone' },
        size: {
            description: '[radius, height], point up',
            type: 'array',
            minItems: 2,
            maxItems: 2,
            items: { $ref: '#/definitions/shapeSize' },
        },
        pos: { $ref: '#/definitions/shapeOffset' },
        rot: { $ref: '#/definitions/shapeRotation' },
        color: { $ref: '#/definitions/shapeColour' },
        opacity: { $ref: '#/definitions/shapeOpacity' },
        stand: { $ref: '#/definitions/shapeStand' },
        finish: { $ref: '#/definitions/shapeFinish' },
    },
};
function validate18(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema45.required,
                parentSchema: schema45,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.size === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'size' },
                message: "must have required property '" + 'size' + "'",
                schema: schema45.required,
                parentSchema: schema45,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.color === undefined) {
            const err2 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'color' },
                message: "must have required property '" + 'color' + "'",
                schema: schema45.required,
                parentSchema: schema45,
                data,
            };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'type' ||
                key0 === 'size' ||
                key0 === 'pos' ||
                key0 === 'rot' ||
                key0 === 'color' ||
                key0 === 'opacity' ||
                key0 === 'stand' ||
                key0 === 'finish')) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema45,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.type !== undefined) {
            let data0 = data.type;
            if ('cone' !== data0) {
                const err4 = {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'cone' },
                    message: 'must be equal to constant',
                    schema: 'cone',
                    parentSchema: schema45.properties.type,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.size !== undefined) {
            let data1 = data.size;
            if (Array.isArray(data1)) {
                if (data1.length > 2) {
                    const err5 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 2 },
                        message: 'must NOT have more than 2 items',
                        schema: 2,
                        parentSchema: schema45.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (data1.length < 2) {
                    const err6 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/minItems',
                        keyword: 'minItems',
                        params: { limit: 2 },
                        message: 'must NOT have fewer than 2 items',
                        schema: 2,
                        parentSchema: schema45.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (typeof data2 == 'number' && isFinite(data2)) {
                        if (data2 > 10 || isNaN(data2)) {
                            const err7 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        if (data2 < 0.005 || isNaN(data2)) {
                            const err8 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: 0.005 },
                                message: 'must be >= 0.005',
                                schema: 0.005,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err9 = {
                            instancePath: instancePath + '/size/' + i0,
                            schemaPath: '#/definitions/shapeSize/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema22.type,
                            parentSchema: schema22,
                            data: data2,
                        };
                        if (vErrors === null) {
                            vErrors = [err9];
                        }
                        else {
                            vErrors.push(err9);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err10 = {
                    instancePath: instancePath + '/size',
                    schemaPath: '#/properties/size/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema45.properties.size.type,
                    parentSchema: schema45.properties.size,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data3 = data.pos;
            if (Array.isArray(data3)) {
                if (data3.length > 3) {
                    const err11 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
                if (data3.length < 3) {
                    const err12 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
                const len1 = data3.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    let data4 = data3[i1];
                    if (typeof data4 == 'number' && isFinite(data4)) {
                        if (data4 > 10 || isNaN(data4)) {
                            const err13 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err13];
                            }
                            else {
                                vErrors.push(err13);
                            }
                            errors++;
                        }
                        if (data4 < -10 || isNaN(data4)) {
                            const err14 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -10 },
                                message: 'must be >= -10',
                                schema: -10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err14];
                            }
                            else {
                                vErrors.push(err14);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err15 = {
                            instancePath: instancePath + '/pos/' + i1,
                            schemaPath: '#/definitions/shapeOffset/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema23.items.type,
                            parentSchema: schema23.items,
                            data: data4,
                        };
                        if (vErrors === null) {
                            vErrors = [err15];
                        }
                        else {
                            vErrors.push(err15);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err16 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/shapeOffset/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema23.type,
                    parentSchema: schema23,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.rot !== undefined) {
            let data5 = data.rot;
            if (Array.isArray(data5)) {
                if (data5.length > 3) {
                    const err17 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
                if (data5.length < 3) {
                    const err18 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                const len2 = data5.length;
                for (let i2 = 0; i2 < len2; i2++) {
                    let data6 = data5[i2];
                    if (typeof data6 == 'number' && isFinite(data6)) {
                        if (data6 > 360 || isNaN(data6)) {
                            const err19 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 360 },
                                message: 'must be <= 360',
                                schema: 360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err19];
                            }
                            else {
                                vErrors.push(err19);
                            }
                            errors++;
                        }
                        if (data6 < -360 || isNaN(data6)) {
                            const err20 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -360 },
                                message: 'must be >= -360',
                                schema: -360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err20];
                            }
                            else {
                                vErrors.push(err20);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err21 = {
                            instancePath: instancePath + '/rot/' + i2,
                            schemaPath: '#/definitions/shapeRotation/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema24.items.type,
                            parentSchema: schema24.items,
                            data: data6,
                        };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err22 = {
                    instancePath: instancePath + '/rot',
                    schemaPath: '#/definitions/shapeRotation/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema24.type,
                    parentSchema: schema24,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err22];
                }
                else {
                    vErrors.push(err22);
                }
                errors++;
            }
        }
        if (data.color !== undefined) {
            let data7 = data.color;
            if (typeof data7 === 'string') {
                if (!pattern7.test(data7)) {
                    const err23 = {
                        instancePath: instancePath + '/color',
                        schemaPath: '#/definitions/shapeColour/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^#[0-9a-fA-F]{6}$' },
                        message: 'must match pattern "' + '^#[0-9a-fA-F]{6}$' + '"',
                        schema: '^#[0-9a-fA-F]{6}$',
                        parentSchema: schema25,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            else {
                const err24 = {
                    instancePath: instancePath + '/color',
                    schemaPath: '#/definitions/shapeColour/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema25.type,
                    parentSchema: schema25,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err24];
                }
                else {
                    vErrors.push(err24);
                }
                errors++;
            }
        }
        if (data.opacity !== undefined) {
            let data8 = data.opacity;
            if (typeof data8 == 'number' && isFinite(data8)) {
                if (data8 > 1 || isNaN(data8)) {
                    const err25 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 1 },
                        message: 'must be <= 1',
                        schema: 1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
                if (data8 < 0.1 || isNaN(data8)) {
                    const err26 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.1 },
                        message: 'must be >= 0.1',
                        schema: 0.1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            else {
                const err27 = {
                    instancePath: instancePath + '/opacity',
                    schemaPath: '#/definitions/shapeOpacity/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema26.type,
                    parentSchema: schema26,
                    data: data8,
                };
                if (vErrors === null) {
                    vErrors = [err27];
                }
                else {
                    vErrors.push(err27);
                }
                errors++;
            }
        }
        if (data.stand !== undefined) {
            let data9 = data.stand;
            if (typeof data9 !== 'boolean') {
                const err28 = {
                    instancePath: instancePath + '/stand',
                    schemaPath: '#/definitions/shapeStand/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema27.type,
                    parentSchema: schema27,
                    data: data9,
                };
                if (vErrors === null) {
                    vErrors = [err28];
                }
                else {
                    vErrors.push(err28);
                }
                errors++;
            }
        }
        if (data.finish !== undefined) {
            let data10 = data.finish;
            if (!(data10 === 'matte' || data10 === 'gloss' || data10 === 'glow')) {
                const err29 = {
                    instancePath: instancePath + '/finish',
                    schemaPath: '#/definitions/shapeFinish/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema28.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema28.enum,
                    parentSchema: schema28,
                    data: data10,
                };
                if (vErrors === null) {
                    vErrors = [err29];
                }
                else {
                    vErrors.push(err29);
                }
                errors++;
            }
        }
    }
    else {
        const err30 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema45.type,
            parentSchema: schema45,
            data,
        };
        if (vErrors === null) {
            vErrors = [err30];
        }
        else {
            vErrors.push(err30);
        }
        errors++;
    }
    validate18.errors = vErrors;
    return errors === 0;
}
const schema53 = {
    type: 'object',
    additionalProperties: false,
    required: ['type', 'size', 'color'],
    properties: {
        type: { const: 'torus' },
        size: {
            description: '[radius of the ring, radius of the tube], lying in the x-y plane',
            type: 'array',
            minItems: 2,
            maxItems: 2,
            items: { $ref: '#/definitions/shapeSize' },
        },
        pos: { $ref: '#/definitions/shapeOffset' },
        rot: { $ref: '#/definitions/shapeRotation' },
        color: { $ref: '#/definitions/shapeColour' },
        opacity: { $ref: '#/definitions/shapeOpacity' },
        stand: { $ref: '#/definitions/shapeStand' },
        finish: { $ref: '#/definitions/shapeFinish' },
    },
};
function validate19(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema53.required,
                parentSchema: schema53,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.size === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'size' },
                message: "must have required property '" + 'size' + "'",
                schema: schema53.required,
                parentSchema: schema53,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.color === undefined) {
            const err2 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'color' },
                message: "must have required property '" + 'color' + "'",
                schema: schema53.required,
                parentSchema: schema53,
                data,
            };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'type' ||
                key0 === 'size' ||
                key0 === 'pos' ||
                key0 === 'rot' ||
                key0 === 'color' ||
                key0 === 'opacity' ||
                key0 === 'stand' ||
                key0 === 'finish')) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema53,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.type !== undefined) {
            let data0 = data.type;
            if ('torus' !== data0) {
                const err4 = {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'torus' },
                    message: 'must be equal to constant',
                    schema: 'torus',
                    parentSchema: schema53.properties.type,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.size !== undefined) {
            let data1 = data.size;
            if (Array.isArray(data1)) {
                if (data1.length > 2) {
                    const err5 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 2 },
                        message: 'must NOT have more than 2 items',
                        schema: 2,
                        parentSchema: schema53.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (data1.length < 2) {
                    const err6 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/minItems',
                        keyword: 'minItems',
                        params: { limit: 2 },
                        message: 'must NOT have fewer than 2 items',
                        schema: 2,
                        parentSchema: schema53.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (typeof data2 == 'number' && isFinite(data2)) {
                        if (data2 > 10 || isNaN(data2)) {
                            const err7 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        if (data2 < 0.005 || isNaN(data2)) {
                            const err8 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: 0.005 },
                                message: 'must be >= 0.005',
                                schema: 0.005,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err9 = {
                            instancePath: instancePath + '/size/' + i0,
                            schemaPath: '#/definitions/shapeSize/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema22.type,
                            parentSchema: schema22,
                            data: data2,
                        };
                        if (vErrors === null) {
                            vErrors = [err9];
                        }
                        else {
                            vErrors.push(err9);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err10 = {
                    instancePath: instancePath + '/size',
                    schemaPath: '#/properties/size/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema53.properties.size.type,
                    parentSchema: schema53.properties.size,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data3 = data.pos;
            if (Array.isArray(data3)) {
                if (data3.length > 3) {
                    const err11 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
                if (data3.length < 3) {
                    const err12 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
                const len1 = data3.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    let data4 = data3[i1];
                    if (typeof data4 == 'number' && isFinite(data4)) {
                        if (data4 > 10 || isNaN(data4)) {
                            const err13 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err13];
                            }
                            else {
                                vErrors.push(err13);
                            }
                            errors++;
                        }
                        if (data4 < -10 || isNaN(data4)) {
                            const err14 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -10 },
                                message: 'must be >= -10',
                                schema: -10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err14];
                            }
                            else {
                                vErrors.push(err14);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err15 = {
                            instancePath: instancePath + '/pos/' + i1,
                            schemaPath: '#/definitions/shapeOffset/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema23.items.type,
                            parentSchema: schema23.items,
                            data: data4,
                        };
                        if (vErrors === null) {
                            vErrors = [err15];
                        }
                        else {
                            vErrors.push(err15);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err16 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/shapeOffset/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema23.type,
                    parentSchema: schema23,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.rot !== undefined) {
            let data5 = data.rot;
            if (Array.isArray(data5)) {
                if (data5.length > 3) {
                    const err17 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
                if (data5.length < 3) {
                    const err18 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                const len2 = data5.length;
                for (let i2 = 0; i2 < len2; i2++) {
                    let data6 = data5[i2];
                    if (typeof data6 == 'number' && isFinite(data6)) {
                        if (data6 > 360 || isNaN(data6)) {
                            const err19 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 360 },
                                message: 'must be <= 360',
                                schema: 360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err19];
                            }
                            else {
                                vErrors.push(err19);
                            }
                            errors++;
                        }
                        if (data6 < -360 || isNaN(data6)) {
                            const err20 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -360 },
                                message: 'must be >= -360',
                                schema: -360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err20];
                            }
                            else {
                                vErrors.push(err20);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err21 = {
                            instancePath: instancePath + '/rot/' + i2,
                            schemaPath: '#/definitions/shapeRotation/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema24.items.type,
                            parentSchema: schema24.items,
                            data: data6,
                        };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err22 = {
                    instancePath: instancePath + '/rot',
                    schemaPath: '#/definitions/shapeRotation/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema24.type,
                    parentSchema: schema24,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err22];
                }
                else {
                    vErrors.push(err22);
                }
                errors++;
            }
        }
        if (data.color !== undefined) {
            let data7 = data.color;
            if (typeof data7 === 'string') {
                if (!pattern7.test(data7)) {
                    const err23 = {
                        instancePath: instancePath + '/color',
                        schemaPath: '#/definitions/shapeColour/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^#[0-9a-fA-F]{6}$' },
                        message: 'must match pattern "' + '^#[0-9a-fA-F]{6}$' + '"',
                        schema: '^#[0-9a-fA-F]{6}$',
                        parentSchema: schema25,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            else {
                const err24 = {
                    instancePath: instancePath + '/color',
                    schemaPath: '#/definitions/shapeColour/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema25.type,
                    parentSchema: schema25,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err24];
                }
                else {
                    vErrors.push(err24);
                }
                errors++;
            }
        }
        if (data.opacity !== undefined) {
            let data8 = data.opacity;
            if (typeof data8 == 'number' && isFinite(data8)) {
                if (data8 > 1 || isNaN(data8)) {
                    const err25 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 1 },
                        message: 'must be <= 1',
                        schema: 1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
                if (data8 < 0.1 || isNaN(data8)) {
                    const err26 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.1 },
                        message: 'must be >= 0.1',
                        schema: 0.1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            else {
                const err27 = {
                    instancePath: instancePath + '/opacity',
                    schemaPath: '#/definitions/shapeOpacity/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema26.type,
                    parentSchema: schema26,
                    data: data8,
                };
                if (vErrors === null) {
                    vErrors = [err27];
                }
                else {
                    vErrors.push(err27);
                }
                errors++;
            }
        }
        if (data.stand !== undefined) {
            let data9 = data.stand;
            if (typeof data9 !== 'boolean') {
                const err28 = {
                    instancePath: instancePath + '/stand',
                    schemaPath: '#/definitions/shapeStand/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema27.type,
                    parentSchema: schema27,
                    data: data9,
                };
                if (vErrors === null) {
                    vErrors = [err28];
                }
                else {
                    vErrors.push(err28);
                }
                errors++;
            }
        }
        if (data.finish !== undefined) {
            let data10 = data.finish;
            if (!(data10 === 'matte' || data10 === 'gloss' || data10 === 'glow')) {
                const err29 = {
                    instancePath: instancePath + '/finish',
                    schemaPath: '#/definitions/shapeFinish/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema28.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema28.enum,
                    parentSchema: schema28,
                    data: data10,
                };
                if (vErrors === null) {
                    vErrors = [err29];
                }
                else {
                    vErrors.push(err29);
                }
                errors++;
            }
        }
    }
    else {
        const err30 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema53.type,
            parentSchema: schema53,
            data,
        };
        if (vErrors === null) {
            vErrors = [err30];
        }
        else {
            vErrors.push(err30);
        }
        errors++;
    }
    validate19.errors = vErrors;
    return errors === 0;
}
const schema61 = {
    type: 'object',
    additionalProperties: false,
    required: ['type', 'size', 'color'],
    properties: {
        type: { const: 'capsule' },
        size: {
            description: '[radius, length of the straight middle], standing on the y axis',
            type: 'array',
            minItems: 2,
            maxItems: 2,
            items: { $ref: '#/definitions/shapeSize' },
        },
        pos: { $ref: '#/definitions/shapeOffset' },
        rot: { $ref: '#/definitions/shapeRotation' },
        color: { $ref: '#/definitions/shapeColour' },
        opacity: { $ref: '#/definitions/shapeOpacity' },
        stand: { $ref: '#/definitions/shapeStand' },
        finish: { $ref: '#/definitions/shapeFinish' },
    },
};
function validate20(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema61.required,
                parentSchema: schema61,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.size === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'size' },
                message: "must have required property '" + 'size' + "'",
                schema: schema61.required,
                parentSchema: schema61,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.color === undefined) {
            const err2 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'color' },
                message: "must have required property '" + 'color' + "'",
                schema: schema61.required,
                parentSchema: schema61,
                data,
            };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'type' ||
                key0 === 'size' ||
                key0 === 'pos' ||
                key0 === 'rot' ||
                key0 === 'color' ||
                key0 === 'opacity' ||
                key0 === 'stand' ||
                key0 === 'finish')) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema61,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.type !== undefined) {
            let data0 = data.type;
            if ('capsule' !== data0) {
                const err4 = {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'capsule' },
                    message: 'must be equal to constant',
                    schema: 'capsule',
                    parentSchema: schema61.properties.type,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.size !== undefined) {
            let data1 = data.size;
            if (Array.isArray(data1)) {
                if (data1.length > 2) {
                    const err5 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 2 },
                        message: 'must NOT have more than 2 items',
                        schema: 2,
                        parentSchema: schema61.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (data1.length < 2) {
                    const err6 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/minItems',
                        keyword: 'minItems',
                        params: { limit: 2 },
                        message: 'must NOT have fewer than 2 items',
                        schema: 2,
                        parentSchema: schema61.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (typeof data2 == 'number' && isFinite(data2)) {
                        if (data2 > 10 || isNaN(data2)) {
                            const err7 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        if (data2 < 0.005 || isNaN(data2)) {
                            const err8 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: 0.005 },
                                message: 'must be >= 0.005',
                                schema: 0.005,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err9 = {
                            instancePath: instancePath + '/size/' + i0,
                            schemaPath: '#/definitions/shapeSize/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema22.type,
                            parentSchema: schema22,
                            data: data2,
                        };
                        if (vErrors === null) {
                            vErrors = [err9];
                        }
                        else {
                            vErrors.push(err9);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err10 = {
                    instancePath: instancePath + '/size',
                    schemaPath: '#/properties/size/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema61.properties.size.type,
                    parentSchema: schema61.properties.size,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data3 = data.pos;
            if (Array.isArray(data3)) {
                if (data3.length > 3) {
                    const err11 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
                if (data3.length < 3) {
                    const err12 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
                const len1 = data3.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    let data4 = data3[i1];
                    if (typeof data4 == 'number' && isFinite(data4)) {
                        if (data4 > 10 || isNaN(data4)) {
                            const err13 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err13];
                            }
                            else {
                                vErrors.push(err13);
                            }
                            errors++;
                        }
                        if (data4 < -10 || isNaN(data4)) {
                            const err14 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -10 },
                                message: 'must be >= -10',
                                schema: -10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err14];
                            }
                            else {
                                vErrors.push(err14);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err15 = {
                            instancePath: instancePath + '/pos/' + i1,
                            schemaPath: '#/definitions/shapeOffset/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema23.items.type,
                            parentSchema: schema23.items,
                            data: data4,
                        };
                        if (vErrors === null) {
                            vErrors = [err15];
                        }
                        else {
                            vErrors.push(err15);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err16 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/shapeOffset/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema23.type,
                    parentSchema: schema23,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.rot !== undefined) {
            let data5 = data.rot;
            if (Array.isArray(data5)) {
                if (data5.length > 3) {
                    const err17 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
                if (data5.length < 3) {
                    const err18 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                const len2 = data5.length;
                for (let i2 = 0; i2 < len2; i2++) {
                    let data6 = data5[i2];
                    if (typeof data6 == 'number' && isFinite(data6)) {
                        if (data6 > 360 || isNaN(data6)) {
                            const err19 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 360 },
                                message: 'must be <= 360',
                                schema: 360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err19];
                            }
                            else {
                                vErrors.push(err19);
                            }
                            errors++;
                        }
                        if (data6 < -360 || isNaN(data6)) {
                            const err20 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -360 },
                                message: 'must be >= -360',
                                schema: -360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err20];
                            }
                            else {
                                vErrors.push(err20);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err21 = {
                            instancePath: instancePath + '/rot/' + i2,
                            schemaPath: '#/definitions/shapeRotation/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema24.items.type,
                            parentSchema: schema24.items,
                            data: data6,
                        };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err22 = {
                    instancePath: instancePath + '/rot',
                    schemaPath: '#/definitions/shapeRotation/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema24.type,
                    parentSchema: schema24,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err22];
                }
                else {
                    vErrors.push(err22);
                }
                errors++;
            }
        }
        if (data.color !== undefined) {
            let data7 = data.color;
            if (typeof data7 === 'string') {
                if (!pattern7.test(data7)) {
                    const err23 = {
                        instancePath: instancePath + '/color',
                        schemaPath: '#/definitions/shapeColour/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^#[0-9a-fA-F]{6}$' },
                        message: 'must match pattern "' + '^#[0-9a-fA-F]{6}$' + '"',
                        schema: '^#[0-9a-fA-F]{6}$',
                        parentSchema: schema25,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            else {
                const err24 = {
                    instancePath: instancePath + '/color',
                    schemaPath: '#/definitions/shapeColour/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema25.type,
                    parentSchema: schema25,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err24];
                }
                else {
                    vErrors.push(err24);
                }
                errors++;
            }
        }
        if (data.opacity !== undefined) {
            let data8 = data.opacity;
            if (typeof data8 == 'number' && isFinite(data8)) {
                if (data8 > 1 || isNaN(data8)) {
                    const err25 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 1 },
                        message: 'must be <= 1',
                        schema: 1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
                if (data8 < 0.1 || isNaN(data8)) {
                    const err26 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.1 },
                        message: 'must be >= 0.1',
                        schema: 0.1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            else {
                const err27 = {
                    instancePath: instancePath + '/opacity',
                    schemaPath: '#/definitions/shapeOpacity/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema26.type,
                    parentSchema: schema26,
                    data: data8,
                };
                if (vErrors === null) {
                    vErrors = [err27];
                }
                else {
                    vErrors.push(err27);
                }
                errors++;
            }
        }
        if (data.stand !== undefined) {
            let data9 = data.stand;
            if (typeof data9 !== 'boolean') {
                const err28 = {
                    instancePath: instancePath + '/stand',
                    schemaPath: '#/definitions/shapeStand/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema27.type,
                    parentSchema: schema27,
                    data: data9,
                };
                if (vErrors === null) {
                    vErrors = [err28];
                }
                else {
                    vErrors.push(err28);
                }
                errors++;
            }
        }
        if (data.finish !== undefined) {
            let data10 = data.finish;
            if (!(data10 === 'matte' || data10 === 'gloss' || data10 === 'glow')) {
                const err29 = {
                    instancePath: instancePath + '/finish',
                    schemaPath: '#/definitions/shapeFinish/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema28.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema28.enum,
                    parentSchema: schema28,
                    data: data10,
                };
                if (vErrors === null) {
                    vErrors = [err29];
                }
                else {
                    vErrors.push(err29);
                }
                errors++;
            }
        }
    }
    else {
        const err30 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema61.type,
            parentSchema: schema61,
            data,
        };
        if (vErrors === null) {
            vErrors = [err30];
        }
        else {
            vErrors.push(err30);
        }
        errors++;
    }
    validate20.errors = vErrors;
    return errors === 0;
}
const schema69 = {
    type: 'object',
    additionalProperties: false,
    required: ['type', 'size', 'color'],
    properties: {
        type: { const: 'plane' },
        size: {
            description: '[width, height], facing +z; seen from both sides',
            type: 'array',
            minItems: 2,
            maxItems: 2,
            items: { $ref: '#/definitions/shapeSize' },
        },
        pos: { $ref: '#/definitions/shapeOffset' },
        rot: { $ref: '#/definitions/shapeRotation' },
        color: { $ref: '#/definitions/shapeColour' },
        opacity: { $ref: '#/definitions/shapeOpacity' },
        stand: { $ref: '#/definitions/shapeStand' },
        finish: { $ref: '#/definitions/shapeFinish' },
    },
};
function validate21(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema69.required,
                parentSchema: schema69,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.size === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'size' },
                message: "must have required property '" + 'size' + "'",
                schema: schema69.required,
                parentSchema: schema69,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.color === undefined) {
            const err2 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'color' },
                message: "must have required property '" + 'color' + "'",
                schema: schema69.required,
                parentSchema: schema69,
                data,
            };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'type' ||
                key0 === 'size' ||
                key0 === 'pos' ||
                key0 === 'rot' ||
                key0 === 'color' ||
                key0 === 'opacity' ||
                key0 === 'stand' ||
                key0 === 'finish')) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema69,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.type !== undefined) {
            let data0 = data.type;
            if ('plane' !== data0) {
                const err4 = {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'plane' },
                    message: 'must be equal to constant',
                    schema: 'plane',
                    parentSchema: schema69.properties.type,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.size !== undefined) {
            let data1 = data.size;
            if (Array.isArray(data1)) {
                if (data1.length > 2) {
                    const err5 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 2 },
                        message: 'must NOT have more than 2 items',
                        schema: 2,
                        parentSchema: schema69.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (data1.length < 2) {
                    const err6 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/minItems',
                        keyword: 'minItems',
                        params: { limit: 2 },
                        message: 'must NOT have fewer than 2 items',
                        schema: 2,
                        parentSchema: schema69.properties.size,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (typeof data2 == 'number' && isFinite(data2)) {
                        if (data2 > 10 || isNaN(data2)) {
                            const err7 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        if (data2 < 0.005 || isNaN(data2)) {
                            const err8 = {
                                instancePath: instancePath + '/size/' + i0,
                                schemaPath: '#/definitions/shapeSize/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: 0.005 },
                                message: 'must be >= 0.005',
                                schema: 0.005,
                                parentSchema: schema22,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err9 = {
                            instancePath: instancePath + '/size/' + i0,
                            schemaPath: '#/definitions/shapeSize/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema22.type,
                            parentSchema: schema22,
                            data: data2,
                        };
                        if (vErrors === null) {
                            vErrors = [err9];
                        }
                        else {
                            vErrors.push(err9);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err10 = {
                    instancePath: instancePath + '/size',
                    schemaPath: '#/properties/size/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema69.properties.size.type,
                    parentSchema: schema69.properties.size,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data3 = data.pos;
            if (Array.isArray(data3)) {
                if (data3.length > 3) {
                    const err11 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
                if (data3.length < 3) {
                    const err12 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
                const len1 = data3.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    let data4 = data3[i1];
                    if (typeof data4 == 'number' && isFinite(data4)) {
                        if (data4 > 10 || isNaN(data4)) {
                            const err13 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err13];
                            }
                            else {
                                vErrors.push(err13);
                            }
                            errors++;
                        }
                        if (data4 < -10 || isNaN(data4)) {
                            const err14 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -10 },
                                message: 'must be >= -10',
                                schema: -10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err14];
                            }
                            else {
                                vErrors.push(err14);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err15 = {
                            instancePath: instancePath + '/pos/' + i1,
                            schemaPath: '#/definitions/shapeOffset/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema23.items.type,
                            parentSchema: schema23.items,
                            data: data4,
                        };
                        if (vErrors === null) {
                            vErrors = [err15];
                        }
                        else {
                            vErrors.push(err15);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err16 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/shapeOffset/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema23.type,
                    parentSchema: schema23,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.rot !== undefined) {
            let data5 = data.rot;
            if (Array.isArray(data5)) {
                if (data5.length > 3) {
                    const err17 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
                if (data5.length < 3) {
                    const err18 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                const len2 = data5.length;
                for (let i2 = 0; i2 < len2; i2++) {
                    let data6 = data5[i2];
                    if (typeof data6 == 'number' && isFinite(data6)) {
                        if (data6 > 360 || isNaN(data6)) {
                            const err19 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 360 },
                                message: 'must be <= 360',
                                schema: 360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err19];
                            }
                            else {
                                vErrors.push(err19);
                            }
                            errors++;
                        }
                        if (data6 < -360 || isNaN(data6)) {
                            const err20 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -360 },
                                message: 'must be >= -360',
                                schema: -360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err20];
                            }
                            else {
                                vErrors.push(err20);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err21 = {
                            instancePath: instancePath + '/rot/' + i2,
                            schemaPath: '#/definitions/shapeRotation/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema24.items.type,
                            parentSchema: schema24.items,
                            data: data6,
                        };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err22 = {
                    instancePath: instancePath + '/rot',
                    schemaPath: '#/definitions/shapeRotation/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema24.type,
                    parentSchema: schema24,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err22];
                }
                else {
                    vErrors.push(err22);
                }
                errors++;
            }
        }
        if (data.color !== undefined) {
            let data7 = data.color;
            if (typeof data7 === 'string') {
                if (!pattern7.test(data7)) {
                    const err23 = {
                        instancePath: instancePath + '/color',
                        schemaPath: '#/definitions/shapeColour/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^#[0-9a-fA-F]{6}$' },
                        message: 'must match pattern "' + '^#[0-9a-fA-F]{6}$' + '"',
                        schema: '^#[0-9a-fA-F]{6}$',
                        parentSchema: schema25,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            else {
                const err24 = {
                    instancePath: instancePath + '/color',
                    schemaPath: '#/definitions/shapeColour/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema25.type,
                    parentSchema: schema25,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err24];
                }
                else {
                    vErrors.push(err24);
                }
                errors++;
            }
        }
        if (data.opacity !== undefined) {
            let data8 = data.opacity;
            if (typeof data8 == 'number' && isFinite(data8)) {
                if (data8 > 1 || isNaN(data8)) {
                    const err25 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 1 },
                        message: 'must be <= 1',
                        schema: 1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
                if (data8 < 0.1 || isNaN(data8)) {
                    const err26 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.1 },
                        message: 'must be >= 0.1',
                        schema: 0.1,
                        parentSchema: schema26,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            else {
                const err27 = {
                    instancePath: instancePath + '/opacity',
                    schemaPath: '#/definitions/shapeOpacity/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema26.type,
                    parentSchema: schema26,
                    data: data8,
                };
                if (vErrors === null) {
                    vErrors = [err27];
                }
                else {
                    vErrors.push(err27);
                }
                errors++;
            }
        }
        if (data.stand !== undefined) {
            let data9 = data.stand;
            if (typeof data9 !== 'boolean') {
                const err28 = {
                    instancePath: instancePath + '/stand',
                    schemaPath: '#/definitions/shapeStand/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema27.type,
                    parentSchema: schema27,
                    data: data9,
                };
                if (vErrors === null) {
                    vErrors = [err28];
                }
                else {
                    vErrors.push(err28);
                }
                errors++;
            }
        }
        if (data.finish !== undefined) {
            let data10 = data.finish;
            if (!(data10 === 'matte' || data10 === 'gloss' || data10 === 'glow')) {
                const err29 = {
                    instancePath: instancePath + '/finish',
                    schemaPath: '#/definitions/shapeFinish/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema28.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema28.enum,
                    parentSchema: schema28,
                    data: data10,
                };
                if (vErrors === null) {
                    vErrors = [err29];
                }
                else {
                    vErrors.push(err29);
                }
                errors++;
            }
        }
    }
    else {
        const err30 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema69.type,
            parentSchema: schema69,
            data,
        };
        if (vErrors === null) {
            vErrors = [err30];
        }
        else {
            vErrors.push(err30);
        }
        errors++;
    }
    validate21.errors = vErrors;
    return errors === 0;
}
const schema77 = {
    description: "An outline turned about the y axis, as on a potter's wheel: a vase, a volcano, a flask.",
    type: 'object',
    additionalProperties: false,
    required: ['type', 'points', 'color'],
    properties: {
        type: { const: 'lathe' },
        points: {
            description: '[distance from the axis, height] from bottom to top. A negative distance is drawn as 0.',
            type: 'array',
            minItems: 2,
            maxItems: 64,
            items: { $ref: '#/definitions/profilePoint' },
        },
        pos: { $ref: '#/definitions/shapeOffset' },
        rot: { $ref: '#/definitions/shapeRotation' },
        color: { $ref: '#/definitions/shapeColour' },
        opacity: { $ref: '#/definitions/shapeOpacity' },
        stand: { $ref: '#/definitions/shapeStand' },
        finish: { $ref: '#/definitions/shapeFinish' },
    },
};
const schema78 = {
    description: 'A point of a flat outline in metres, [x, y]. For a lathe, x is the distance from the axis.',
    type: 'array',
    minItems: 2,
    maxItems: 2,
    items: { type: 'number', minimum: -10, maximum: 10 },
};
function validate22(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema77.required,
                parentSchema: schema77,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.points === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'points' },
                message: "must have required property '" + 'points' + "'",
                schema: schema77.required,
                parentSchema: schema77,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.color === undefined) {
            const err2 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'color' },
                message: "must have required property '" + 'color' + "'",
                schema: schema77.required,
                parentSchema: schema77,
                data,
            };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'type' ||
                key0 === 'points' ||
                key0 === 'pos' ||
                key0 === 'rot' ||
                key0 === 'color' ||
                key0 === 'opacity' ||
                key0 === 'stand' ||
                key0 === 'finish')) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema77,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.type !== undefined) {
            let data0 = data.type;
            if ('lathe' !== data0) {
                const err4 = {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'lathe' },
                    message: 'must be equal to constant',
                    schema: 'lathe',
                    parentSchema: schema77.properties.type,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.points !== undefined) {
            let data1 = data.points;
            if (Array.isArray(data1)) {
                if (data1.length > 64) {
                    const err5 = {
                        instancePath: instancePath + '/points',
                        schemaPath: '#/properties/points/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 items',
                        schema: 64,
                        parentSchema: schema77.properties.points,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (data1.length < 2) {
                    const err6 = {
                        instancePath: instancePath + '/points',
                        schemaPath: '#/properties/points/minItems',
                        keyword: 'minItems',
                        params: { limit: 2 },
                        message: 'must NOT have fewer than 2 items',
                        schema: 2,
                        parentSchema: schema77.properties.points,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (Array.isArray(data2)) {
                        if (data2.length > 2) {
                            const err7 = {
                                instancePath: instancePath + '/points/' + i0,
                                schemaPath: '#/definitions/profilePoint/maxItems',
                                keyword: 'maxItems',
                                params: { limit: 2 },
                                message: 'must NOT have more than 2 items',
                                schema: 2,
                                parentSchema: schema78,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                        if (data2.length < 2) {
                            const err8 = {
                                instancePath: instancePath + '/points/' + i0,
                                schemaPath: '#/definitions/profilePoint/minItems',
                                keyword: 'minItems',
                                params: { limit: 2 },
                                message: 'must NOT have fewer than 2 items',
                                schema: 2,
                                parentSchema: schema78,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                        const len1 = data2.length;
                        for (let i1 = 0; i1 < len1; i1++) {
                            let data3 = data2[i1];
                            if (typeof data3 == 'number' && isFinite(data3)) {
                                if (data3 > 10 || isNaN(data3)) {
                                    const err9 = {
                                        instancePath: instancePath + '/points/' + i0 + '/' + i1,
                                        schemaPath: '#/definitions/profilePoint/items/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 10 },
                                        message: 'must be <= 10',
                                        schema: 10,
                                        parentSchema: schema78.items,
                                        data: data3,
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err9];
                                    }
                                    else {
                                        vErrors.push(err9);
                                    }
                                    errors++;
                                }
                                if (data3 < -10 || isNaN(data3)) {
                                    const err10 = {
                                        instancePath: instancePath + '/points/' + i0 + '/' + i1,
                                        schemaPath: '#/definitions/profilePoint/items/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: -10 },
                                        message: 'must be >= -10',
                                        schema: -10,
                                        parentSchema: schema78.items,
                                        data: data3,
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err10];
                                    }
                                    else {
                                        vErrors.push(err10);
                                    }
                                    errors++;
                                }
                            }
                            else {
                                const err11 = {
                                    instancePath: instancePath + '/points/' + i0 + '/' + i1,
                                    schemaPath: '#/definitions/profilePoint/items/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number',
                                    schema: schema78.items.type,
                                    parentSchema: schema78.items,
                                    data: data3,
                                };
                                if (vErrors === null) {
                                    vErrors = [err11];
                                }
                                else {
                                    vErrors.push(err11);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        const err12 = {
                            instancePath: instancePath + '/points/' + i0,
                            schemaPath: '#/definitions/profilePoint/type',
                            keyword: 'type',
                            params: { type: 'array' },
                            message: 'must be array',
                            schema: schema78.type,
                            parentSchema: schema78,
                            data: data2,
                        };
                        if (vErrors === null) {
                            vErrors = [err12];
                        }
                        else {
                            vErrors.push(err12);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err13 = {
                    instancePath: instancePath + '/points',
                    schemaPath: '#/properties/points/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema77.properties.points.type,
                    parentSchema: schema77.properties.points,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err13];
                }
                else {
                    vErrors.push(err13);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data4 = data.pos;
            if (Array.isArray(data4)) {
                if (data4.length > 3) {
                    const err14 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data4,
                    };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
                if (data4.length < 3) {
                    const err15 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data4,
                    };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
                const len2 = data4.length;
                for (let i2 = 0; i2 < len2; i2++) {
                    let data5 = data4[i2];
                    if (typeof data5 == 'number' && isFinite(data5)) {
                        if (data5 > 10 || isNaN(data5)) {
                            const err16 = {
                                instancePath: instancePath + '/pos/' + i2,
                                schemaPath: '#/definitions/shapeOffset/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema23.items,
                                data: data5,
                            };
                            if (vErrors === null) {
                                vErrors = [err16];
                            }
                            else {
                                vErrors.push(err16);
                            }
                            errors++;
                        }
                        if (data5 < -10 || isNaN(data5)) {
                            const err17 = {
                                instancePath: instancePath + '/pos/' + i2,
                                schemaPath: '#/definitions/shapeOffset/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -10 },
                                message: 'must be >= -10',
                                schema: -10,
                                parentSchema: schema23.items,
                                data: data5,
                            };
                            if (vErrors === null) {
                                vErrors = [err17];
                            }
                            else {
                                vErrors.push(err17);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err18 = {
                            instancePath: instancePath + '/pos/' + i2,
                            schemaPath: '#/definitions/shapeOffset/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema23.items.type,
                            parentSchema: schema23.items,
                            data: data5,
                        };
                        if (vErrors === null) {
                            vErrors = [err18];
                        }
                        else {
                            vErrors.push(err18);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err19 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/shapeOffset/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema23.type,
                    parentSchema: schema23,
                    data: data4,
                };
                if (vErrors === null) {
                    vErrors = [err19];
                }
                else {
                    vErrors.push(err19);
                }
                errors++;
            }
        }
        if (data.rot !== undefined) {
            let data6 = data.rot;
            if (Array.isArray(data6)) {
                if (data6.length > 3) {
                    const err20 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data6,
                    };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
                if (data6.length < 3) {
                    const err21 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data6,
                    };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
                const len3 = data6.length;
                for (let i3 = 0; i3 < len3; i3++) {
                    let data7 = data6[i3];
                    if (typeof data7 == 'number' && isFinite(data7)) {
                        if (data7 > 360 || isNaN(data7)) {
                            const err22 = {
                                instancePath: instancePath + '/rot/' + i3,
                                schemaPath: '#/definitions/shapeRotation/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 360 },
                                message: 'must be <= 360',
                                schema: 360,
                                parentSchema: schema24.items,
                                data: data7,
                            };
                            if (vErrors === null) {
                                vErrors = [err22];
                            }
                            else {
                                vErrors.push(err22);
                            }
                            errors++;
                        }
                        if (data7 < -360 || isNaN(data7)) {
                            const err23 = {
                                instancePath: instancePath + '/rot/' + i3,
                                schemaPath: '#/definitions/shapeRotation/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -360 },
                                message: 'must be >= -360',
                                schema: -360,
                                parentSchema: schema24.items,
                                data: data7,
                            };
                            if (vErrors === null) {
                                vErrors = [err23];
                            }
                            else {
                                vErrors.push(err23);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err24 = {
                            instancePath: instancePath + '/rot/' + i3,
                            schemaPath: '#/definitions/shapeRotation/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema24.items.type,
                            parentSchema: schema24.items,
                            data: data7,
                        };
                        if (vErrors === null) {
                            vErrors = [err24];
                        }
                        else {
                            vErrors.push(err24);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err25 = {
                    instancePath: instancePath + '/rot',
                    schemaPath: '#/definitions/shapeRotation/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema24.type,
                    parentSchema: schema24,
                    data: data6,
                };
                if (vErrors === null) {
                    vErrors = [err25];
                }
                else {
                    vErrors.push(err25);
                }
                errors++;
            }
        }
        if (data.color !== undefined) {
            let data8 = data.color;
            if (typeof data8 === 'string') {
                if (!pattern7.test(data8)) {
                    const err26 = {
                        instancePath: instancePath + '/color',
                        schemaPath: '#/definitions/shapeColour/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^#[0-9a-fA-F]{6}$' },
                        message: 'must match pattern "' + '^#[0-9a-fA-F]{6}$' + '"',
                        schema: '^#[0-9a-fA-F]{6}$',
                        parentSchema: schema25,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            else {
                const err27 = {
                    instancePath: instancePath + '/color',
                    schemaPath: '#/definitions/shapeColour/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema25.type,
                    parentSchema: schema25,
                    data: data8,
                };
                if (vErrors === null) {
                    vErrors = [err27];
                }
                else {
                    vErrors.push(err27);
                }
                errors++;
            }
        }
        if (data.opacity !== undefined) {
            let data9 = data.opacity;
            if (typeof data9 == 'number' && isFinite(data9)) {
                if (data9 > 1 || isNaN(data9)) {
                    const err28 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 1 },
                        message: 'must be <= 1',
                        schema: 1,
                        parentSchema: schema26,
                        data: data9,
                    };
                    if (vErrors === null) {
                        vErrors = [err28];
                    }
                    else {
                        vErrors.push(err28);
                    }
                    errors++;
                }
                if (data9 < 0.1 || isNaN(data9)) {
                    const err29 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.1 },
                        message: 'must be >= 0.1',
                        schema: 0.1,
                        parentSchema: schema26,
                        data: data9,
                    };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
            }
            else {
                const err30 = {
                    instancePath: instancePath + '/opacity',
                    schemaPath: '#/definitions/shapeOpacity/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema26.type,
                    parentSchema: schema26,
                    data: data9,
                };
                if (vErrors === null) {
                    vErrors = [err30];
                }
                else {
                    vErrors.push(err30);
                }
                errors++;
            }
        }
        if (data.stand !== undefined) {
            let data10 = data.stand;
            if (typeof data10 !== 'boolean') {
                const err31 = {
                    instancePath: instancePath + '/stand',
                    schemaPath: '#/definitions/shapeStand/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema27.type,
                    parentSchema: schema27,
                    data: data10,
                };
                if (vErrors === null) {
                    vErrors = [err31];
                }
                else {
                    vErrors.push(err31);
                }
                errors++;
            }
        }
        if (data.finish !== undefined) {
            let data11 = data.finish;
            if (!(data11 === 'matte' || data11 === 'gloss' || data11 === 'glow')) {
                const err32 = {
                    instancePath: instancePath + '/finish',
                    schemaPath: '#/definitions/shapeFinish/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema28.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema28.enum,
                    parentSchema: schema28,
                    data: data11,
                };
                if (vErrors === null) {
                    vErrors = [err32];
                }
                else {
                    vErrors.push(err32);
                }
                errors++;
            }
        }
    }
    else {
        const err33 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema77.type,
            parentSchema: schema77,
            data,
        };
        if (vErrors === null) {
            vErrors = [err33];
        }
        else {
            vErrors.push(err33);
        }
        errors++;
    }
    validate22.errors = vErrors;
    return errors === 0;
}
const schema85 = {
    description: 'A flat outline pushed out along z, as a biscuit cutter through dough, centred on its pos: a cross-section, an arrow, a leaf.',
    type: 'object',
    additionalProperties: false,
    required: ['type', 'outline', 'depth', 'color'],
    properties: {
        type: { const: 'extrude' },
        outline: {
            description: '[x, y] corners in order, in metres. The outline closes itself and must not cross itself.',
            type: 'array',
            minItems: 3,
            maxItems: 64,
            items: { $ref: '#/definitions/profilePoint' },
        },
        depth: { $ref: '#/definitions/shapeSize' },
        pos: { $ref: '#/definitions/shapeOffset' },
        rot: { $ref: '#/definitions/shapeRotation' },
        color: { $ref: '#/definitions/shapeColour' },
        opacity: { $ref: '#/definitions/shapeOpacity' },
        stand: { $ref: '#/definitions/shapeStand' },
        finish: { $ref: '#/definitions/shapeFinish' },
    },
};
function validate23(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema85.required,
                parentSchema: schema85,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.outline === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'outline' },
                message: "must have required property '" + 'outline' + "'",
                schema: schema85.required,
                parentSchema: schema85,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.depth === undefined) {
            const err2 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'depth' },
                message: "must have required property '" + 'depth' + "'",
                schema: schema85.required,
                parentSchema: schema85,
                data,
            };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        if (data.color === undefined) {
            const err3 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'color' },
                message: "must have required property '" + 'color' + "'",
                schema: schema85.required,
                parentSchema: schema85,
                data,
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!func2.call(schema85.properties, key0)) {
                const err4 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema85,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.type !== undefined) {
            let data0 = data.type;
            if ('extrude' !== data0) {
                const err5 = {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'extrude' },
                    message: 'must be equal to constant',
                    schema: 'extrude',
                    parentSchema: schema85.properties.type,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
        }
        if (data.outline !== undefined) {
            let data1 = data.outline;
            if (Array.isArray(data1)) {
                if (data1.length > 64) {
                    const err6 = {
                        instancePath: instancePath + '/outline',
                        schemaPath: '#/properties/outline/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 items',
                        schema: 64,
                        parentSchema: schema85.properties.outline,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                if (data1.length < 3) {
                    const err7 = {
                        instancePath: instancePath + '/outline',
                        schemaPath: '#/properties/outline/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema85.properties.outline,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (Array.isArray(data2)) {
                        if (data2.length > 2) {
                            const err8 = {
                                instancePath: instancePath + '/outline/' + i0,
                                schemaPath: '#/definitions/profilePoint/maxItems',
                                keyword: 'maxItems',
                                params: { limit: 2 },
                                message: 'must NOT have more than 2 items',
                                schema: 2,
                                parentSchema: schema78,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                        if (data2.length < 2) {
                            const err9 = {
                                instancePath: instancePath + '/outline/' + i0,
                                schemaPath: '#/definitions/profilePoint/minItems',
                                keyword: 'minItems',
                                params: { limit: 2 },
                                message: 'must NOT have fewer than 2 items',
                                schema: 2,
                                parentSchema: schema78,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err9];
                            }
                            else {
                                vErrors.push(err9);
                            }
                            errors++;
                        }
                        const len1 = data2.length;
                        for (let i1 = 0; i1 < len1; i1++) {
                            let data3 = data2[i1];
                            if (typeof data3 == 'number' && isFinite(data3)) {
                                if (data3 > 10 || isNaN(data3)) {
                                    const err10 = {
                                        instancePath: instancePath + '/outline/' + i0 + '/' + i1,
                                        schemaPath: '#/definitions/profilePoint/items/maximum',
                                        keyword: 'maximum',
                                        params: { comparison: '<=', limit: 10 },
                                        message: 'must be <= 10',
                                        schema: 10,
                                        parentSchema: schema78.items,
                                        data: data3,
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err10];
                                    }
                                    else {
                                        vErrors.push(err10);
                                    }
                                    errors++;
                                }
                                if (data3 < -10 || isNaN(data3)) {
                                    const err11 = {
                                        instancePath: instancePath + '/outline/' + i0 + '/' + i1,
                                        schemaPath: '#/definitions/profilePoint/items/minimum',
                                        keyword: 'minimum',
                                        params: { comparison: '>=', limit: -10 },
                                        message: 'must be >= -10',
                                        schema: -10,
                                        parentSchema: schema78.items,
                                        data: data3,
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err11];
                                    }
                                    else {
                                        vErrors.push(err11);
                                    }
                                    errors++;
                                }
                            }
                            else {
                                const err12 = {
                                    instancePath: instancePath + '/outline/' + i0 + '/' + i1,
                                    schemaPath: '#/definitions/profilePoint/items/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number',
                                    schema: schema78.items.type,
                                    parentSchema: schema78.items,
                                    data: data3,
                                };
                                if (vErrors === null) {
                                    vErrors = [err12];
                                }
                                else {
                                    vErrors.push(err12);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        const err13 = {
                            instancePath: instancePath + '/outline/' + i0,
                            schemaPath: '#/definitions/profilePoint/type',
                            keyword: 'type',
                            params: { type: 'array' },
                            message: 'must be array',
                            schema: schema78.type,
                            parentSchema: schema78,
                            data: data2,
                        };
                        if (vErrors === null) {
                            vErrors = [err13];
                        }
                        else {
                            vErrors.push(err13);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err14 = {
                    instancePath: instancePath + '/outline',
                    schemaPath: '#/properties/outline/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema85.properties.outline.type,
                    parentSchema: schema85.properties.outline,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err14];
                }
                else {
                    vErrors.push(err14);
                }
                errors++;
            }
        }
        if (data.depth !== undefined) {
            let data4 = data.depth;
            if (typeof data4 == 'number' && isFinite(data4)) {
                if (data4 > 10 || isNaN(data4)) {
                    const err15 = {
                        instancePath: instancePath + '/depth',
                        schemaPath: '#/definitions/shapeSize/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 10 },
                        message: 'must be <= 10',
                        schema: 10,
                        parentSchema: schema22,
                        data: data4,
                    };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
                if (data4 < 0.005 || isNaN(data4)) {
                    const err16 = {
                        instancePath: instancePath + '/depth',
                        schemaPath: '#/definitions/shapeSize/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.005 },
                        message: 'must be >= 0.005',
                        schema: 0.005,
                        parentSchema: schema22,
                        data: data4,
                    };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
            }
            else {
                const err17 = {
                    instancePath: instancePath + '/depth',
                    schemaPath: '#/definitions/shapeSize/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema22.type,
                    parentSchema: schema22,
                    data: data4,
                };
                if (vErrors === null) {
                    vErrors = [err17];
                }
                else {
                    vErrors.push(err17);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data5 = data.pos;
            if (Array.isArray(data5)) {
                if (data5.length > 3) {
                    const err18 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                if (data5.length < 3) {
                    const err19 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
                const len2 = data5.length;
                for (let i2 = 0; i2 < len2; i2++) {
                    let data6 = data5[i2];
                    if (typeof data6 == 'number' && isFinite(data6)) {
                        if (data6 > 10 || isNaN(data6)) {
                            const err20 = {
                                instancePath: instancePath + '/pos/' + i2,
                                schemaPath: '#/definitions/shapeOffset/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema23.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err20];
                            }
                            else {
                                vErrors.push(err20);
                            }
                            errors++;
                        }
                        if (data6 < -10 || isNaN(data6)) {
                            const err21 = {
                                instancePath: instancePath + '/pos/' + i2,
                                schemaPath: '#/definitions/shapeOffset/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -10 },
                                message: 'must be >= -10',
                                schema: -10,
                                parentSchema: schema23.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err21];
                            }
                            else {
                                vErrors.push(err21);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err22 = {
                            instancePath: instancePath + '/pos/' + i2,
                            schemaPath: '#/definitions/shapeOffset/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema23.items.type,
                            parentSchema: schema23.items,
                            data: data6,
                        };
                        if (vErrors === null) {
                            vErrors = [err22];
                        }
                        else {
                            vErrors.push(err22);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err23 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/shapeOffset/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema23.type,
                    parentSchema: schema23,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err23];
                }
                else {
                    vErrors.push(err23);
                }
                errors++;
            }
        }
        if (data.rot !== undefined) {
            let data7 = data.rot;
            if (Array.isArray(data7)) {
                if (data7.length > 3) {
                    const err24 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err24];
                    }
                    else {
                        vErrors.push(err24);
                    }
                    errors++;
                }
                if (data7.length < 3) {
                    const err25 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
                const len3 = data7.length;
                for (let i3 = 0; i3 < len3; i3++) {
                    let data8 = data7[i3];
                    if (typeof data8 == 'number' && isFinite(data8)) {
                        if (data8 > 360 || isNaN(data8)) {
                            const err26 = {
                                instancePath: instancePath + '/rot/' + i3,
                                schemaPath: '#/definitions/shapeRotation/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 360 },
                                message: 'must be <= 360',
                                schema: 360,
                                parentSchema: schema24.items,
                                data: data8,
                            };
                            if (vErrors === null) {
                                vErrors = [err26];
                            }
                            else {
                                vErrors.push(err26);
                            }
                            errors++;
                        }
                        if (data8 < -360 || isNaN(data8)) {
                            const err27 = {
                                instancePath: instancePath + '/rot/' + i3,
                                schemaPath: '#/definitions/shapeRotation/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -360 },
                                message: 'must be >= -360',
                                schema: -360,
                                parentSchema: schema24.items,
                                data: data8,
                            };
                            if (vErrors === null) {
                                vErrors = [err27];
                            }
                            else {
                                vErrors.push(err27);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err28 = {
                            instancePath: instancePath + '/rot/' + i3,
                            schemaPath: '#/definitions/shapeRotation/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema24.items.type,
                            parentSchema: schema24.items,
                            data: data8,
                        };
                        if (vErrors === null) {
                            vErrors = [err28];
                        }
                        else {
                            vErrors.push(err28);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err29 = {
                    instancePath: instancePath + '/rot',
                    schemaPath: '#/definitions/shapeRotation/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema24.type,
                    parentSchema: schema24,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err29];
                }
                else {
                    vErrors.push(err29);
                }
                errors++;
            }
        }
        if (data.color !== undefined) {
            let data9 = data.color;
            if (typeof data9 === 'string') {
                if (!pattern7.test(data9)) {
                    const err30 = {
                        instancePath: instancePath + '/color',
                        schemaPath: '#/definitions/shapeColour/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^#[0-9a-fA-F]{6}$' },
                        message: 'must match pattern "' + '^#[0-9a-fA-F]{6}$' + '"',
                        schema: '^#[0-9a-fA-F]{6}$',
                        parentSchema: schema25,
                        data: data9,
                    };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
            }
            else {
                const err31 = {
                    instancePath: instancePath + '/color',
                    schemaPath: '#/definitions/shapeColour/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema25.type,
                    parentSchema: schema25,
                    data: data9,
                };
                if (vErrors === null) {
                    vErrors = [err31];
                }
                else {
                    vErrors.push(err31);
                }
                errors++;
            }
        }
        if (data.opacity !== undefined) {
            let data10 = data.opacity;
            if (typeof data10 == 'number' && isFinite(data10)) {
                if (data10 > 1 || isNaN(data10)) {
                    const err32 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 1 },
                        message: 'must be <= 1',
                        schema: 1,
                        parentSchema: schema26,
                        data: data10,
                    };
                    if (vErrors === null) {
                        vErrors = [err32];
                    }
                    else {
                        vErrors.push(err32);
                    }
                    errors++;
                }
                if (data10 < 0.1 || isNaN(data10)) {
                    const err33 = {
                        instancePath: instancePath + '/opacity',
                        schemaPath: '#/definitions/shapeOpacity/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.1 },
                        message: 'must be >= 0.1',
                        schema: 0.1,
                        parentSchema: schema26,
                        data: data10,
                    };
                    if (vErrors === null) {
                        vErrors = [err33];
                    }
                    else {
                        vErrors.push(err33);
                    }
                    errors++;
                }
            }
            else {
                const err34 = {
                    instancePath: instancePath + '/opacity',
                    schemaPath: '#/definitions/shapeOpacity/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema26.type,
                    parentSchema: schema26,
                    data: data10,
                };
                if (vErrors === null) {
                    vErrors = [err34];
                }
                else {
                    vErrors.push(err34);
                }
                errors++;
            }
        }
        if (data.stand !== undefined) {
            let data11 = data.stand;
            if (typeof data11 !== 'boolean') {
                const err35 = {
                    instancePath: instancePath + '/stand',
                    schemaPath: '#/definitions/shapeStand/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema27.type,
                    parentSchema: schema27,
                    data: data11,
                };
                if (vErrors === null) {
                    vErrors = [err35];
                }
                else {
                    vErrors.push(err35);
                }
                errors++;
            }
        }
        if (data.finish !== undefined) {
            let data12 = data.finish;
            if (!(data12 === 'matte' || data12 === 'gloss' || data12 === 'glow')) {
                const err36 = {
                    instancePath: instancePath + '/finish',
                    schemaPath: '#/definitions/shapeFinish/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema28.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema28.enum,
                    parentSchema: schema28,
                    data: data12,
                };
                if (vErrors === null) {
                    vErrors = [err36];
                }
                else {
                    vErrors.push(err36);
                }
                errors++;
            }
        }
    }
    else {
        const err37 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema85.type,
            parentSchema: schema85,
            data,
        };
        if (vErrors === null) {
            vErrors = [err37];
        }
        else {
            vErrors.push(err37);
        }
        errors++;
    }
    validate23.errors = vErrors;
    return errors === 0;
}
const schema94 = {
    description: 'Parts moved, turned and scaled together. May hold one more level of groups.',
    type: 'object',
    additionalProperties: false,
    required: ['type', 'parts'],
    properties: {
        type: { const: 'group' },
        parts: {
            type: 'array',
            minItems: 1,
            maxItems: 64,
            items: {
                type: 'object',
                discriminator: { propertyName: 'type' },
                oneOf: [
                    { $ref: '#/definitions/shapeBox' },
                    { $ref: '#/definitions/shapeSphere' },
                    { $ref: '#/definitions/shapeCylinder' },
                    { $ref: '#/definitions/shapeCone' },
                    { $ref: '#/definitions/shapeTorus' },
                    { $ref: '#/definitions/shapeCapsule' },
                    { $ref: '#/definitions/shapePlane' },
                    { $ref: '#/definitions/shapeLathe' },
                    { $ref: '#/definitions/shapeExtrude' },
                    { $ref: '#/definitions/shapeGroupInner' },
                ],
            },
        },
        pos: { $ref: '#/definitions/shapeOffset' },
        rot: { $ref: '#/definitions/shapeRotation' },
        scale: { $ref: '#/definitions/shapeScale' },
    },
};
const schema99 = {
    description: 'Makes everything in the group bigger or smaller alike.',
    type: 'number',
    minimum: 0.1,
    maximum: 10,
};
const schema95 = {
    description: 'A group inside a group: the third and deepest level, so it holds drawn parts only.',
    type: 'object',
    additionalProperties: false,
    required: ['type', 'parts'],
    properties: {
        type: { const: 'group' },
        parts: { type: 'array', minItems: 1, maxItems: 64, items: { $ref: '#/definitions/shapeLeaf' } },
        pos: { $ref: '#/definitions/shapeOffset' },
        rot: { $ref: '#/definitions/shapeRotation' },
        scale: { $ref: '#/definitions/shapeScale' },
    },
};
const schema96 = {
    description: 'One part that is drawn: a primitive, a lathe or an extrusion. `type` says which, and picks the rules the rest of the part is checked against.',
    type: 'object',
    discriminator: { propertyName: 'type' },
    oneOf: [
        { $ref: '#/definitions/shapeBox' },
        { $ref: '#/definitions/shapeSphere' },
        { $ref: '#/definitions/shapeCylinder' },
        { $ref: '#/definitions/shapeCone' },
        { $ref: '#/definitions/shapeTorus' },
        { $ref: '#/definitions/shapeCapsule' },
        { $ref: '#/definitions/shapePlane' },
        { $ref: '#/definitions/shapeLathe' },
        { $ref: '#/definitions/shapeExtrude' },
    ],
};
function validate26(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        const tag0 = data.type;
        if (typeof tag0 == 'string') {
            if (tag0 === 'box') {
                if (!validate15(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate15.errors : vErrors.concat(validate15.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'sphere') {
                if (!validate16(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate16.errors : vErrors.concat(validate16.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'cylinder') {
                if (!validate17(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate17.errors : vErrors.concat(validate17.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'cone') {
                if (!validate18(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate18.errors : vErrors.concat(validate18.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'torus') {
                if (!validate19(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate19.errors : vErrors.concat(validate19.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'capsule') {
                if (!validate20(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate20.errors : vErrors.concat(validate20.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'plane') {
                if (!validate21(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'lathe') {
                if (!validate22(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'extrude') {
                if (!validate23(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
                    errors = vErrors.length;
                }
            }
            else {
                const err0 = {
                    instancePath,
                    schemaPath: '#/discriminator',
                    keyword: 'discriminator',
                    params: { error: 'mapping', tag: 'type', tagValue: tag0 },
                    message: 'value of tag "type" must be in oneOf',
                    schema: schema96.discriminator,
                    parentSchema: schema96,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
        else {
            const err1 = {
                instancePath,
                schemaPath: '#/discriminator',
                keyword: 'discriminator',
                params: { error: 'tag', tag: 'type', tagValue: tag0 },
                message: 'tag "type" must be string',
                schema: schema96.discriminator,
                parentSchema: schema96,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
    }
    else {
        const err2 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema96.type,
            parentSchema: schema96,
            data,
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
    }
    validate26.errors = vErrors;
    return errors === 0;
}
function validate25(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema95.required,
                parentSchema: schema95,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.parts === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'parts' },
                message: "must have required property '" + 'parts' + "'",
                schema: schema95.required,
                parentSchema: schema95,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'type' ||
                key0 === 'parts' ||
                key0 === 'pos' ||
                key0 === 'rot' ||
                key0 === 'scale')) {
                const err2 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema95,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.type !== undefined) {
            let data0 = data.type;
            if ('group' !== data0) {
                const err3 = {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'group' },
                    message: 'must be equal to constant',
                    schema: 'group',
                    parentSchema: schema95.properties.type,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.parts !== undefined) {
            let data1 = data.parts;
            if (Array.isArray(data1)) {
                if (data1.length > 64) {
                    const err4 = {
                        instancePath: instancePath + '/parts',
                        schemaPath: '#/properties/parts/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 items',
                        schema: 64,
                        parentSchema: schema95.properties.parts,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
                if (data1.length < 1) {
                    const err5 = {
                        instancePath: instancePath + '/parts',
                        schemaPath: '#/properties/parts/minItems',
                        keyword: 'minItems',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 items',
                        schema: 1,
                        parentSchema: schema95.properties.parts,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    if (!validate26(data1[i0], {
                        instancePath: instancePath + '/parts/' + i0,
                        parentData: data1,
                        parentDataProperty: i0,
                        rootData,
                    })) {
                        vErrors = vErrors === null ? validate26.errors : vErrors.concat(validate26.errors);
                        errors = vErrors.length;
                    }
                }
            }
            else {
                const err6 = {
                    instancePath: instancePath + '/parts',
                    schemaPath: '#/properties/parts/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema95.properties.parts.type,
                    parentSchema: schema95.properties.parts,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data3 = data.pos;
            if (Array.isArray(data3)) {
                if (data3.length > 3) {
                    const err7 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                }
                if (data3.length < 3) {
                    const err8 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err8];
                    }
                    else {
                        vErrors.push(err8);
                    }
                    errors++;
                }
                const len1 = data3.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    let data4 = data3[i1];
                    if (typeof data4 == 'number' && isFinite(data4)) {
                        if (data4 > 10 || isNaN(data4)) {
                            const err9 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err9];
                            }
                            else {
                                vErrors.push(err9);
                            }
                            errors++;
                        }
                        if (data4 < -10 || isNaN(data4)) {
                            const err10 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -10 },
                                message: 'must be >= -10',
                                schema: -10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err10];
                            }
                            else {
                                vErrors.push(err10);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err11 = {
                            instancePath: instancePath + '/pos/' + i1,
                            schemaPath: '#/definitions/shapeOffset/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema23.items.type,
                            parentSchema: schema23.items,
                            data: data4,
                        };
                        if (vErrors === null) {
                            vErrors = [err11];
                        }
                        else {
                            vErrors.push(err11);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err12 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/shapeOffset/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema23.type,
                    parentSchema: schema23,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err12];
                }
                else {
                    vErrors.push(err12);
                }
                errors++;
            }
        }
        if (data.rot !== undefined) {
            let data5 = data.rot;
            if (Array.isArray(data5)) {
                if (data5.length > 3) {
                    const err13 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err13];
                    }
                    else {
                        vErrors.push(err13);
                    }
                    errors++;
                }
                if (data5.length < 3) {
                    const err14 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
                const len2 = data5.length;
                for (let i2 = 0; i2 < len2; i2++) {
                    let data6 = data5[i2];
                    if (typeof data6 == 'number' && isFinite(data6)) {
                        if (data6 > 360 || isNaN(data6)) {
                            const err15 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 360 },
                                message: 'must be <= 360',
                                schema: 360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err15];
                            }
                            else {
                                vErrors.push(err15);
                            }
                            errors++;
                        }
                        if (data6 < -360 || isNaN(data6)) {
                            const err16 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -360 },
                                message: 'must be >= -360',
                                schema: -360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err16];
                            }
                            else {
                                vErrors.push(err16);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err17 = {
                            instancePath: instancePath + '/rot/' + i2,
                            schemaPath: '#/definitions/shapeRotation/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema24.items.type,
                            parentSchema: schema24.items,
                            data: data6,
                        };
                        if (vErrors === null) {
                            vErrors = [err17];
                        }
                        else {
                            vErrors.push(err17);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err18 = {
                    instancePath: instancePath + '/rot',
                    schemaPath: '#/definitions/shapeRotation/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema24.type,
                    parentSchema: schema24,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err18];
                }
                else {
                    vErrors.push(err18);
                }
                errors++;
            }
        }
        if (data.scale !== undefined) {
            let data7 = data.scale;
            if (typeof data7 == 'number' && isFinite(data7)) {
                if (data7 > 10 || isNaN(data7)) {
                    const err19 = {
                        instancePath: instancePath + '/scale',
                        schemaPath: '#/definitions/shapeScale/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 10 },
                        message: 'must be <= 10',
                        schema: 10,
                        parentSchema: schema99,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
                if (data7 < 0.1 || isNaN(data7)) {
                    const err20 = {
                        instancePath: instancePath + '/scale',
                        schemaPath: '#/definitions/shapeScale/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.1 },
                        message: 'must be >= 0.1',
                        schema: 0.1,
                        parentSchema: schema99,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
            }
            else {
                const err21 = {
                    instancePath: instancePath + '/scale',
                    schemaPath: '#/definitions/shapeScale/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema99.type,
                    parentSchema: schema99,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err21];
                }
                else {
                    vErrors.push(err21);
                }
                errors++;
            }
        }
    }
    else {
        const err22 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema95.type,
            parentSchema: schema95,
            data,
        };
        if (vErrors === null) {
            vErrors = [err22];
        }
        else {
            vErrors.push(err22);
        }
        errors++;
    }
    validate25.errors = vErrors;
    return errors === 0;
}
function validate24(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema94.required,
                parentSchema: schema94,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.parts === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'parts' },
                message: "must have required property '" + 'parts' + "'",
                schema: schema94.required,
                parentSchema: schema94,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'type' ||
                key0 === 'parts' ||
                key0 === 'pos' ||
                key0 === 'rot' ||
                key0 === 'scale')) {
                const err2 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema94,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.type !== undefined) {
            let data0 = data.type;
            if ('group' !== data0) {
                const err3 = {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'group' },
                    message: 'must be equal to constant',
                    schema: 'group',
                    parentSchema: schema94.properties.type,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.parts !== undefined) {
            let data1 = data.parts;
            if (Array.isArray(data1)) {
                if (data1.length > 64) {
                    const err4 = {
                        instancePath: instancePath + '/parts',
                        schemaPath: '#/properties/parts/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 items',
                        schema: 64,
                        parentSchema: schema94.properties.parts,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
                if (data1.length < 1) {
                    const err5 = {
                        instancePath: instancePath + '/parts',
                        schemaPath: '#/properties/parts/minItems',
                        keyword: 'minItems',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 items',
                        schema: 1,
                        parentSchema: schema94.properties.parts,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (data2 && typeof data2 == 'object' && !Array.isArray(data2)) {
                        const tag0 = data2.type;
                        if (typeof tag0 == 'string') {
                            if (tag0 === 'box') {
                                if (!validate15(data2, {
                                    instancePath: instancePath + '/parts/' + i0,
                                    parentData: data1,
                                    parentDataProperty: i0,
                                    rootData,
                                })) {
                                    vErrors =
                                        vErrors === null ? validate15.errors : vErrors.concat(validate15.errors);
                                    errors = vErrors.length;
                                }
                            }
                            else if (tag0 === 'sphere') {
                                if (!validate16(data2, {
                                    instancePath: instancePath + '/parts/' + i0,
                                    parentData: data1,
                                    parentDataProperty: i0,
                                    rootData,
                                })) {
                                    vErrors =
                                        vErrors === null ? validate16.errors : vErrors.concat(validate16.errors);
                                    errors = vErrors.length;
                                }
                            }
                            else if (tag0 === 'cylinder') {
                                if (!validate17(data2, {
                                    instancePath: instancePath + '/parts/' + i0,
                                    parentData: data1,
                                    parentDataProperty: i0,
                                    rootData,
                                })) {
                                    vErrors =
                                        vErrors === null ? validate17.errors : vErrors.concat(validate17.errors);
                                    errors = vErrors.length;
                                }
                            }
                            else if (tag0 === 'cone') {
                                if (!validate18(data2, {
                                    instancePath: instancePath + '/parts/' + i0,
                                    parentData: data1,
                                    parentDataProperty: i0,
                                    rootData,
                                })) {
                                    vErrors =
                                        vErrors === null ? validate18.errors : vErrors.concat(validate18.errors);
                                    errors = vErrors.length;
                                }
                            }
                            else if (tag0 === 'torus') {
                                if (!validate19(data2, {
                                    instancePath: instancePath + '/parts/' + i0,
                                    parentData: data1,
                                    parentDataProperty: i0,
                                    rootData,
                                })) {
                                    vErrors =
                                        vErrors === null ? validate19.errors : vErrors.concat(validate19.errors);
                                    errors = vErrors.length;
                                }
                            }
                            else if (tag0 === 'capsule') {
                                if (!validate20(data2, {
                                    instancePath: instancePath + '/parts/' + i0,
                                    parentData: data1,
                                    parentDataProperty: i0,
                                    rootData,
                                })) {
                                    vErrors =
                                        vErrors === null ? validate20.errors : vErrors.concat(validate20.errors);
                                    errors = vErrors.length;
                                }
                            }
                            else if (tag0 === 'plane') {
                                if (!validate21(data2, {
                                    instancePath: instancePath + '/parts/' + i0,
                                    parentData: data1,
                                    parentDataProperty: i0,
                                    rootData,
                                })) {
                                    vErrors =
                                        vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
                                    errors = vErrors.length;
                                }
                            }
                            else if (tag0 === 'lathe') {
                                if (!validate22(data2, {
                                    instancePath: instancePath + '/parts/' + i0,
                                    parentData: data1,
                                    parentDataProperty: i0,
                                    rootData,
                                })) {
                                    vErrors =
                                        vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
                                    errors = vErrors.length;
                                }
                            }
                            else if (tag0 === 'extrude') {
                                if (!validate23(data2, {
                                    instancePath: instancePath + '/parts/' + i0,
                                    parentData: data1,
                                    parentDataProperty: i0,
                                    rootData,
                                })) {
                                    vErrors =
                                        vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
                                    errors = vErrors.length;
                                }
                            }
                            else if (tag0 === 'group') {
                                if (!validate25(data2, {
                                    instancePath: instancePath + '/parts/' + i0,
                                    parentData: data1,
                                    parentDataProperty: i0,
                                    rootData,
                                })) {
                                    vErrors =
                                        vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
                                    errors = vErrors.length;
                                }
                            }
                            else {
                                const err6 = {
                                    instancePath: instancePath + '/parts/' + i0,
                                    schemaPath: '#/properties/parts/items/discriminator',
                                    keyword: 'discriminator',
                                    params: { error: 'mapping', tag: 'type', tagValue: tag0 },
                                    message: 'value of tag "type" must be in oneOf',
                                    schema: schema94.properties.parts.items.discriminator,
                                    parentSchema: schema94.properties.parts.items,
                                    data: data2,
                                };
                                if (vErrors === null) {
                                    vErrors = [err6];
                                }
                                else {
                                    vErrors.push(err6);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err7 = {
                                instancePath: instancePath + '/parts/' + i0,
                                schemaPath: '#/properties/parts/items/discriminator',
                                keyword: 'discriminator',
                                params: { error: 'tag', tag: 'type', tagValue: tag0 },
                                message: 'tag "type" must be string',
                                schema: schema94.properties.parts.items.discriminator,
                                parentSchema: schema94.properties.parts.items,
                                data: data2,
                            };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err8 = {
                            instancePath: instancePath + '/parts/' + i0,
                            schemaPath: '#/properties/parts/items/type',
                            keyword: 'type',
                            params: { type: 'object' },
                            message: 'must be object',
                            schema: schema94.properties.parts.items.type,
                            parentSchema: schema94.properties.parts.items,
                            data: data2,
                        };
                        if (vErrors === null) {
                            vErrors = [err8];
                        }
                        else {
                            vErrors.push(err8);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err9 = {
                    instancePath: instancePath + '/parts',
                    schemaPath: '#/properties/parts/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema94.properties.parts.type,
                    parentSchema: schema94.properties.parts,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data3 = data.pos;
            if (Array.isArray(data3)) {
                if (data3.length > 3) {
                    const err10 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err10];
                    }
                    else {
                        vErrors.push(err10);
                    }
                    errors++;
                }
                if (data3.length < 3) {
                    const err11 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/shapeOffset/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema23,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
                const len1 = data3.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    let data4 = data3[i1];
                    if (typeof data4 == 'number' && isFinite(data4)) {
                        if (data4 > 10 || isNaN(data4)) {
                            const err12 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 10 },
                                message: 'must be <= 10',
                                schema: 10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err12];
                            }
                            else {
                                vErrors.push(err12);
                            }
                            errors++;
                        }
                        if (data4 < -10 || isNaN(data4)) {
                            const err13 = {
                                instancePath: instancePath + '/pos/' + i1,
                                schemaPath: '#/definitions/shapeOffset/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -10 },
                                message: 'must be >= -10',
                                schema: -10,
                                parentSchema: schema23.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err13];
                            }
                            else {
                                vErrors.push(err13);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err14 = {
                            instancePath: instancePath + '/pos/' + i1,
                            schemaPath: '#/definitions/shapeOffset/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema23.items.type,
                            parentSchema: schema23.items,
                            data: data4,
                        };
                        if (vErrors === null) {
                            vErrors = [err14];
                        }
                        else {
                            vErrors.push(err14);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err15 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/shapeOffset/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema23.type,
                    parentSchema: schema23,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err15];
                }
                else {
                    vErrors.push(err15);
                }
                errors++;
            }
        }
        if (data.rot !== undefined) {
            let data5 = data.rot;
            if (Array.isArray(data5)) {
                if (data5.length > 3) {
                    const err16 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
                if (data5.length < 3) {
                    const err17 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
                const len2 = data5.length;
                for (let i2 = 0; i2 < len2; i2++) {
                    let data6 = data5[i2];
                    if (typeof data6 == 'number' && isFinite(data6)) {
                        if (data6 > 360 || isNaN(data6)) {
                            const err18 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 360 },
                                message: 'must be <= 360',
                                schema: 360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err18];
                            }
                            else {
                                vErrors.push(err18);
                            }
                            errors++;
                        }
                        if (data6 < -360 || isNaN(data6)) {
                            const err19 = {
                                instancePath: instancePath + '/rot/' + i2,
                                schemaPath: '#/definitions/shapeRotation/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -360 },
                                message: 'must be >= -360',
                                schema: -360,
                                parentSchema: schema24.items,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err19];
                            }
                            else {
                                vErrors.push(err19);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err20 = {
                            instancePath: instancePath + '/rot/' + i2,
                            schemaPath: '#/definitions/shapeRotation/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema24.items.type,
                            parentSchema: schema24.items,
                            data: data6,
                        };
                        if (vErrors === null) {
                            vErrors = [err20];
                        }
                        else {
                            vErrors.push(err20);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err21 = {
                    instancePath: instancePath + '/rot',
                    schemaPath: '#/definitions/shapeRotation/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema24.type,
                    parentSchema: schema24,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err21];
                }
                else {
                    vErrors.push(err21);
                }
                errors++;
            }
        }
        if (data.scale !== undefined) {
            let data7 = data.scale;
            if (typeof data7 == 'number' && isFinite(data7)) {
                if (data7 > 10 || isNaN(data7)) {
                    const err22 = {
                        instancePath: instancePath + '/scale',
                        schemaPath: '#/definitions/shapeScale/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 10 },
                        message: 'must be <= 10',
                        schema: 10,
                        parentSchema: schema99,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err22];
                    }
                    else {
                        vErrors.push(err22);
                    }
                    errors++;
                }
                if (data7 < 0.1 || isNaN(data7)) {
                    const err23 = {
                        instancePath: instancePath + '/scale',
                        schemaPath: '#/definitions/shapeScale/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.1 },
                        message: 'must be >= 0.1',
                        schema: 0.1,
                        parentSchema: schema99,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            else {
                const err24 = {
                    instancePath: instancePath + '/scale',
                    schemaPath: '#/definitions/shapeScale/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema99.type,
                    parentSchema: schema99,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err24];
                }
                else {
                    vErrors.push(err24);
                }
                errors++;
            }
        }
    }
    else {
        const err25 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema94.type,
            parentSchema: schema94,
            data,
        };
        if (vErrors === null) {
            vErrors = [err25];
        }
        else {
            vErrors.push(err25);
        }
        errors++;
    }
    validate24.errors = vErrors;
    return errors === 0;
}
function validate14(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        const tag0 = data.type;
        if (typeof tag0 == 'string') {
            if (tag0 === 'box') {
                if (!validate15(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate15.errors : vErrors.concat(validate15.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'sphere') {
                if (!validate16(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate16.errors : vErrors.concat(validate16.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'cylinder') {
                if (!validate17(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate17.errors : vErrors.concat(validate17.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'cone') {
                if (!validate18(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate18.errors : vErrors.concat(validate18.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'torus') {
                if (!validate19(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate19.errors : vErrors.concat(validate19.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'capsule') {
                if (!validate20(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate20.errors : vErrors.concat(validate20.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'plane') {
                if (!validate21(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'lathe') {
                if (!validate22(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'extrude') {
                if (!validate23(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate23.errors : vErrors.concat(validate23.errors);
                    errors = vErrors.length;
                }
            }
            else if (tag0 === 'group') {
                if (!validate24(data, { instancePath, parentData, parentDataProperty, rootData })) {
                    vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
                    errors = vErrors.length;
                }
            }
            else {
                const err0 = {
                    instancePath,
                    schemaPath: '#/discriminator',
                    keyword: 'discriminator',
                    params: { error: 'mapping', tag: 'type', tagValue: tag0 },
                    message: 'value of tag "type" must be in oneOf',
                    schema: schema20.discriminator,
                    parentSchema: schema20,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
        else {
            const err1 = {
                instancePath,
                schemaPath: '#/discriminator',
                keyword: 'discriminator',
                params: { error: 'tag', tag: 'type', tagValue: tag0 },
                message: 'tag "type" must be string',
                schema: schema20.discriminator,
                parentSchema: schema20,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
    }
    else {
        const err2 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema20.type,
            parentSchema: schema20,
            data,
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
    }
    validate14.errors = vErrors;
    return errors === 0;
}
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.kind === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'kind' },
                message: "must have required property '" + 'kind' + "'",
                schema: schema17.required,
                parentSchema: schema17,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.label === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'label' },
                message: "must have required property '" + 'label' + "'",
                schema: schema17.required,
                parentSchema: schema17,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!func2.call(schema17.properties, key0)) {
                const err2 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema17,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.kind !== undefined) {
            let data0 = data.kind;
            if (typeof data0 === 'string') {
                if (!pattern5.test(data0)) {
                    const err3 = {
                        instancePath: instancePath + '/kind',
                        schemaPath: '#/properties/kind/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^(model:[a-z0-9-]{2,40}|[a-z][a-z0-9-]*:[a-z][a-z0-9-]*)$' },
                        message: 'must match pattern "' +
                            '^(model:[a-z0-9-]{2,40}|[a-z][a-z0-9-]*:[a-z][a-z0-9-]*)$' +
                            '"',
                        schema: '^(model:[a-z0-9-]{2,40}|[a-z][a-z0-9-]*:[a-z][a-z0-9-]*)$',
                        parentSchema: schema17.properties.kind,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
            }
            else {
                const err4 = {
                    instancePath: instancePath + '/kind',
                    schemaPath: '#/properties/kind/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema17.properties.kind.type,
                    parentSchema: schema17.properties.kind,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.label !== undefined) {
            let data1 = data.label;
            if (typeof data1 === 'string') {
                if (func3(data1) > 60) {
                    const err5 = {
                        instancePath: instancePath + '/label',
                        schemaPath: '#/properties/label/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 60 },
                        message: 'must NOT have more than 60 characters',
                        schema: 60,
                        parentSchema: schema17.properties.label,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (func3(data1) < 1) {
                    const err6 = {
                        instancePath: instancePath + '/label',
                        schemaPath: '#/properties/label/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema17.properties.label,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
            }
            else {
                const err7 = {
                    instancePath: instancePath + '/label',
                    schemaPath: '#/properties/label/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema17.properties.label.type,
                    parentSchema: schema17.properties.label,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data2 = data.pos;
            if (Array.isArray(data2)) {
                if (data2.length > 3) {
                    const err8 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/vec3/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema18,
                        data: data2,
                    };
                    if (vErrors === null) {
                        vErrors = [err8];
                    }
                    else {
                        vErrors.push(err8);
                    }
                    errors++;
                }
                if (data2.length < 3) {
                    const err9 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/vec3/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema18,
                        data: data2,
                    };
                    if (vErrors === null) {
                        vErrors = [err9];
                    }
                    else {
                        vErrors.push(err9);
                    }
                    errors++;
                }
                const len0 = data2.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data3 = data2[i0];
                    if (!(typeof data3 == 'number' && isFinite(data3))) {
                        const err10 = {
                            instancePath: instancePath + '/pos/' + i0,
                            schemaPath: '#/definitions/vec3/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema18.items.type,
                            parentSchema: schema18.items,
                            data: data3,
                        };
                        if (vErrors === null) {
                            vErrors = [err10];
                        }
                        else {
                            vErrors.push(err10);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err11 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/vec3/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema18.type,
                    parentSchema: schema18,
                    data: data2,
                };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
        }
        if (data.radius !== undefined) {
            let data4 = data.radius;
            if (typeof data4 == 'number' && isFinite(data4)) {
                if (data4 <= 0 || isNaN(data4)) {
                    const err12 = {
                        instancePath: instancePath + '/radius',
                        schemaPath: '#/properties/radius/exclusiveMinimum',
                        keyword: 'exclusiveMinimum',
                        params: { comparison: '>', limit: 0 },
                        message: 'must be > 0',
                        schema: 0,
                        parentSchema: schema17.properties.radius,
                        data: data4,
                    };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
            }
            else {
                const err13 = {
                    instancePath: instancePath + '/radius',
                    schemaPath: '#/properties/radius/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema17.properties.radius.type,
                    parentSchema: schema17.properties.radius,
                    data: data4,
                };
                if (vErrors === null) {
                    vErrors = [err13];
                }
                else {
                    vErrors.push(err13);
                }
                errors++;
            }
        }
        if (data.spin !== undefined) {
            let data5 = data.spin;
            if (!(typeof data5 == 'number' && isFinite(data5))) {
                const err14 = {
                    instancePath: instancePath + '/spin',
                    schemaPath: '#/properties/spin/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema17.properties.spin.type,
                    parentSchema: schema17.properties.spin,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err14];
                }
                else {
                    vErrors.push(err14);
                }
                errors++;
            }
        }
        if (data.tilt !== undefined) {
            let data6 = data.tilt;
            if (!(typeof data6 == 'number' && isFinite(data6))) {
                const err15 = {
                    instancePath: instancePath + '/tilt',
                    schemaPath: '#/properties/tilt/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema17.properties.tilt.type,
                    parentSchema: schema17.properties.tilt,
                    data: data6,
                };
                if (vErrors === null) {
                    vErrors = [err15];
                }
                else {
                    vErrors.push(err15);
                }
                errors++;
            }
        }
        if (data.ring !== undefined) {
            let data7 = data.ring;
            if (Array.isArray(data7)) {
                if (data7.length > 2) {
                    const err16 = {
                        instancePath: instancePath + '/ring',
                        schemaPath: '#/properties/ring/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 2 },
                        message: 'must NOT have more than 2 items',
                        schema: 2,
                        parentSchema: schema17.properties.ring,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
                if (data7.length < 2) {
                    const err17 = {
                        instancePath: instancePath + '/ring',
                        schemaPath: '#/properties/ring/minItems',
                        keyword: 'minItems',
                        params: { limit: 2 },
                        message: 'must NOT have fewer than 2 items',
                        schema: 2,
                        parentSchema: schema17.properties.ring,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
                const len1 = data7.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    let data8 = data7[i1];
                    if (typeof data8 == 'number' && isFinite(data8)) {
                        if (data8 <= 0 || isNaN(data8)) {
                            const err18 = {
                                instancePath: instancePath + '/ring/' + i1,
                                schemaPath: '#/properties/ring/items/exclusiveMinimum',
                                keyword: 'exclusiveMinimum',
                                params: { comparison: '>', limit: 0 },
                                message: 'must be > 0',
                                schema: 0,
                                parentSchema: schema17.properties.ring.items,
                                data: data8,
                            };
                            if (vErrors === null) {
                                vErrors = [err18];
                            }
                            else {
                                vErrors.push(err18);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err19 = {
                            instancePath: instancePath + '/ring/' + i1,
                            schemaPath: '#/properties/ring/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema17.properties.ring.items.type,
                            parentSchema: schema17.properties.ring.items,
                            data: data8,
                        };
                        if (vErrors === null) {
                            vErrors = [err19];
                        }
                        else {
                            vErrors.push(err19);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err20 = {
                    instancePath: instancePath + '/ring',
                    schemaPath: '#/properties/ring/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema17.properties.ring.type,
                    parentSchema: schema17.properties.ring,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err20];
                }
                else {
                    vErrors.push(err20);
                }
                errors++;
            }
        }
        if (data.parent !== undefined) {
            let data9 = data.parent;
            if (typeof data9 === 'string') {
                if (func3(data9) > 64) {
                    const err21 = {
                        instancePath: instancePath + '/parent',
                        schemaPath: '#/definitions/slug/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 characters',
                        schema: 64,
                        parentSchema: schema12,
                        data: data9,
                    };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
                if (!pattern0.test(data9)) {
                    const err22 = {
                        instancePath: instancePath + '/parent',
                        schemaPath: '#/definitions/slug/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                        message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                        schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                        parentSchema: schema12,
                        data: data9,
                    };
                    if (vErrors === null) {
                        vErrors = [err22];
                    }
                    else {
                        vErrors.push(err22);
                    }
                    errors++;
                }
            }
            else {
                const err23 = {
                    instancePath: instancePath + '/parent',
                    schemaPath: '#/definitions/slug/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema12.type,
                    parentSchema: schema12,
                    data: data9,
                };
                if (vErrors === null) {
                    vErrors = [err23];
                }
                else {
                    vErrors.push(err23);
                }
                errors++;
            }
        }
        if (data.orbit !== undefined) {
            let data10 = data.orbit;
            if (typeof data10 == 'number' && isFinite(data10)) {
                if (data10 <= 0 || isNaN(data10)) {
                    const err24 = {
                        instancePath: instancePath + '/orbit',
                        schemaPath: '#/properties/orbit/exclusiveMinimum',
                        keyword: 'exclusiveMinimum',
                        params: { comparison: '>', limit: 0 },
                        message: 'must be > 0',
                        schema: 0,
                        parentSchema: schema17.properties.orbit,
                        data: data10,
                    };
                    if (vErrors === null) {
                        vErrors = [err24];
                    }
                    else {
                        vErrors.push(err24);
                    }
                    errors++;
                }
            }
            else {
                const err25 = {
                    instancePath: instancePath + '/orbit',
                    schemaPath: '#/properties/orbit/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema17.properties.orbit.type,
                    parentSchema: schema17.properties.orbit,
                    data: data10,
                };
                if (vErrors === null) {
                    vErrors = [err25];
                }
                else {
                    vErrors.push(err25);
                }
                errors++;
            }
        }
        if (data.parts !== undefined) {
            let data11 = data.parts;
            if (Array.isArray(data11)) {
                if (data11.length > 64) {
                    const err26 = {
                        instancePath: instancePath + '/parts',
                        schemaPath: '#/properties/parts/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 items',
                        schema: 64,
                        parentSchema: schema17.properties.parts,
                        data: data11,
                    };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
                if (data11.length < 1) {
                    const err27 = {
                        instancePath: instancePath + '/parts',
                        schemaPath: '#/properties/parts/minItems',
                        keyword: 'minItems',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 items',
                        schema: 1,
                        parentSchema: schema17.properties.parts,
                        data: data11,
                    };
                    if (vErrors === null) {
                        vErrors = [err27];
                    }
                    else {
                        vErrors.push(err27);
                    }
                    errors++;
                }
                const len2 = data11.length;
                for (let i2 = 0; i2 < len2; i2++) {
                    if (!validate14(data11[i2], {
                        instancePath: instancePath + '/parts/' + i2,
                        parentData: data11,
                        parentDataProperty: i2,
                        rootData,
                    })) {
                        vErrors = vErrors === null ? validate14.errors : vErrors.concat(validate14.errors);
                        errors = vErrors.length;
                    }
                }
            }
            else {
                const err28 = {
                    instancePath: instancePath + '/parts',
                    schemaPath: '#/properties/parts/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema17.properties.parts.type,
                    parentSchema: schema17.properties.parts,
                    data: data11,
                };
                if (vErrors === null) {
                    vErrors = [err28];
                }
                else {
                    vErrors.push(err28);
                }
                errors++;
            }
        }
        if (data.hidden !== undefined) {
            let data13 = data.hidden;
            if (typeof data13 !== 'boolean') {
                const err29 = {
                    instancePath: instancePath + '/hidden',
                    schemaPath: '#/properties/hidden/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema17.properties.hidden.type,
                    parentSchema: schema17.properties.hidden,
                    data: data13,
                };
                if (vErrors === null) {
                    vErrors = [err29];
                }
                else {
                    vErrors.push(err29);
                }
                errors++;
            }
        }
        if (data.rot !== undefined) {
            let data14 = data.rot;
            if (Array.isArray(data14)) {
                if (data14.length > 3) {
                    const err30 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data14,
                    };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
                if (data14.length < 3) {
                    const err31 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data14,
                    };
                    if (vErrors === null) {
                        vErrors = [err31];
                    }
                    else {
                        vErrors.push(err31);
                    }
                    errors++;
                }
                const len3 = data14.length;
                for (let i3 = 0; i3 < len3; i3++) {
                    let data15 = data14[i3];
                    if (typeof data15 == 'number' && isFinite(data15)) {
                        if (data15 > 360 || isNaN(data15)) {
                            const err32 = {
                                instancePath: instancePath + '/rot/' + i3,
                                schemaPath: '#/definitions/shapeRotation/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 360 },
                                message: 'must be <= 360',
                                schema: 360,
                                parentSchema: schema24.items,
                                data: data15,
                            };
                            if (vErrors === null) {
                                vErrors = [err32];
                            }
                            else {
                                vErrors.push(err32);
                            }
                            errors++;
                        }
                        if (data15 < -360 || isNaN(data15)) {
                            const err33 = {
                                instancePath: instancePath + '/rot/' + i3,
                                schemaPath: '#/definitions/shapeRotation/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -360 },
                                message: 'must be >= -360',
                                schema: -360,
                                parentSchema: schema24.items,
                                data: data15,
                            };
                            if (vErrors === null) {
                                vErrors = [err33];
                            }
                            else {
                                vErrors.push(err33);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err34 = {
                            instancePath: instancePath + '/rot/' + i3,
                            schemaPath: '#/definitions/shapeRotation/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema24.items.type,
                            parentSchema: schema24.items,
                            data: data15,
                        };
                        if (vErrors === null) {
                            vErrors = [err34];
                        }
                        else {
                            vErrors.push(err34);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err35 = {
                    instancePath: instancePath + '/rot',
                    schemaPath: '#/definitions/shapeRotation/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema24.type,
                    parentSchema: schema24,
                    data: data14,
                };
                if (vErrors === null) {
                    vErrors = [err35];
                }
                else {
                    vErrors.push(err35);
                }
                errors++;
            }
        }
        if (data.scale !== undefined) {
            let data16 = data.scale;
            if (typeof data16 == 'number' && isFinite(data16)) {
                if (data16 > 10 || isNaN(data16)) {
                    const err36 = {
                        instancePath: instancePath + '/scale',
                        schemaPath: '#/properties/scale/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 10 },
                        message: 'must be <= 10',
                        schema: 10,
                        parentSchema: schema17.properties.scale,
                        data: data16,
                    };
                    if (vErrors === null) {
                        vErrors = [err36];
                    }
                    else {
                        vErrors.push(err36);
                    }
                    errors++;
                }
                if (data16 < 0.1 || isNaN(data16)) {
                    const err37 = {
                        instancePath: instancePath + '/scale',
                        schemaPath: '#/properties/scale/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.1 },
                        message: 'must be >= 0.1',
                        schema: 0.1,
                        parentSchema: schema17.properties.scale,
                        data: data16,
                    };
                    if (vErrors === null) {
                        vErrors = [err37];
                    }
                    else {
                        vErrors.push(err37);
                    }
                    errors++;
                }
            }
            else {
                const err38 = {
                    instancePath: instancePath + '/scale',
                    schemaPath: '#/properties/scale/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema17.properties.scale.type,
                    parentSchema: schema17.properties.scale,
                    data: data16,
                };
                if (vErrors === null) {
                    vErrors = [err38];
                }
                else {
                    vErrors.push(err38);
                }
                errors++;
            }
        }
        if (data.width !== undefined) {
            let data17 = data.width;
            if (typeof data17 == 'number' && isFinite(data17)) {
                if (data17 > 3 || isNaN(data17)) {
                    const err39 = {
                        instancePath: instancePath + '/width',
                        schemaPath: '#/properties/width/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 3 },
                        message: 'must be <= 3',
                        schema: 3,
                        parentSchema: schema17.properties.width,
                        data: data17,
                    };
                    if (vErrors === null) {
                        vErrors = [err39];
                    }
                    else {
                        vErrors.push(err39);
                    }
                    errors++;
                }
                if (data17 < 0.4 || isNaN(data17)) {
                    const err40 = {
                        instancePath: instancePath + '/width',
                        schemaPath: '#/properties/width/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.4 },
                        message: 'must be >= 0.4',
                        schema: 0.4,
                        parentSchema: schema17.properties.width,
                        data: data17,
                    };
                    if (vErrors === null) {
                        vErrors = [err40];
                    }
                    else {
                        vErrors.push(err40);
                    }
                    errors++;
                }
            }
            else {
                const err41 = {
                    instancePath: instancePath + '/width',
                    schemaPath: '#/properties/width/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema17.properties.width.type,
                    parentSchema: schema17.properties.width,
                    data: data17,
                };
                if (vErrors === null) {
                    vErrors = [err41];
                }
                else {
                    vErrors.push(err41);
                }
                errors++;
            }
        }
        if (data.facing !== undefined) {
            let data18 = data.facing;
            if (typeof data18 == 'number' && isFinite(data18)) {
                if (data18 > 360 || isNaN(data18)) {
                    const err42 = {
                        instancePath: instancePath + '/facing',
                        schemaPath: '#/properties/facing/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 360 },
                        message: 'must be <= 360',
                        schema: 360,
                        parentSchema: schema17.properties.facing,
                        data: data18,
                    };
                    if (vErrors === null) {
                        vErrors = [err42];
                    }
                    else {
                        vErrors.push(err42);
                    }
                    errors++;
                }
                if (data18 < -360 || isNaN(data18)) {
                    const err43 = {
                        instancePath: instancePath + '/facing',
                        schemaPath: '#/properties/facing/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: -360 },
                        message: 'must be >= -360',
                        schema: -360,
                        parentSchema: schema17.properties.facing,
                        data: data18,
                    };
                    if (vErrors === null) {
                        vErrors = [err43];
                    }
                    else {
                        vErrors.push(err43);
                    }
                    errors++;
                }
            }
            else {
                const err44 = {
                    instancePath: instancePath + '/facing',
                    schemaPath: '#/properties/facing/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema17.properties.facing.type,
                    parentSchema: schema17.properties.facing,
                    data: data18,
                };
                if (vErrors === null) {
                    vErrors = [err44];
                }
                else {
                    vErrors.push(err44);
                }
                errors++;
            }
        }
        if (data.caption !== undefined) {
            let data19 = data.caption;
            if (typeof data19 === 'string') {
                if (func3(data19) > 80) {
                    const err45 = {
                        instancePath: instancePath + '/caption',
                        schemaPath: '#/properties/caption/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 80 },
                        message: 'must NOT have more than 80 characters',
                        schema: 80,
                        parentSchema: schema17.properties.caption,
                        data: data19,
                    };
                    if (vErrors === null) {
                        vErrors = [err45];
                    }
                    else {
                        vErrors.push(err45);
                    }
                    errors++;
                }
                if (func3(data19) < 1) {
                    const err46 = {
                        instancePath: instancePath + '/caption',
                        schemaPath: '#/properties/caption/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema17.properties.caption,
                        data: data19,
                    };
                    if (vErrors === null) {
                        vErrors = [err46];
                    }
                    else {
                        vErrors.push(err46);
                    }
                    errors++;
                }
            }
            else {
                const err47 = {
                    instancePath: instancePath + '/caption',
                    schemaPath: '#/properties/caption/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema17.properties.caption.type,
                    parentSchema: schema17.properties.caption,
                    data: data19,
                };
                if (vErrors === null) {
                    vErrors = [err47];
                }
                else {
                    vErrors.push(err47);
                }
                errors++;
            }
        }
        if (data.want !== undefined) {
            let data20 = data.want;
            if (typeof data20 === 'string') {
                if (func3(data20) > 200) {
                    const err48 = {
                        instancePath: instancePath + '/want',
                        schemaPath: '#/properties/want/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 200 },
                        message: 'must NOT have more than 200 characters',
                        schema: 200,
                        parentSchema: schema17.properties.want,
                        data: data20,
                    };
                    if (vErrors === null) {
                        vErrors = [err48];
                    }
                    else {
                        vErrors.push(err48);
                    }
                    errors++;
                }
                if (func3(data20) < 1) {
                    const err49 = {
                        instancePath: instancePath + '/want',
                        schemaPath: '#/properties/want/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema17.properties.want,
                        data: data20,
                    };
                    if (vErrors === null) {
                        vErrors = [err49];
                    }
                    else {
                        vErrors.push(err49);
                    }
                    errors++;
                }
            }
            else {
                const err50 = {
                    instancePath: instancePath + '/want',
                    schemaPath: '#/properties/want/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema17.properties.want.type,
                    parentSchema: schema17.properties.want,
                    data: data20,
                };
                if (vErrors === null) {
                    vErrors = [err50];
                }
                else {
                    vErrors.push(err50);
                }
                errors++;
            }
        }
        if (data.search !== undefined) {
            let data21 = data.search;
            if (typeof data21 === 'string') {
                if (func3(data21) > 80) {
                    const err51 = {
                        instancePath: instancePath + '/search',
                        schemaPath: '#/properties/search/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 80 },
                        message: 'must NOT have more than 80 characters',
                        schema: 80,
                        parentSchema: schema17.properties.search,
                        data: data21,
                    };
                    if (vErrors === null) {
                        vErrors = [err51];
                    }
                    else {
                        vErrors.push(err51);
                    }
                    errors++;
                }
                if (func3(data21) < 1) {
                    const err52 = {
                        instancePath: instancePath + '/search',
                        schemaPath: '#/properties/search/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema17.properties.search,
                        data: data21,
                    };
                    if (vErrors === null) {
                        vErrors = [err52];
                    }
                    else {
                        vErrors.push(err52);
                    }
                    errors++;
                }
            }
            else {
                const err53 = {
                    instancePath: instancePath + '/search',
                    schemaPath: '#/properties/search/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema17.properties.search.type,
                    parentSchema: schema17.properties.search,
                    data: data21,
                };
                if (vErrors === null) {
                    vErrors = [err53];
                }
                else {
                    vErrors.push(err53);
                }
                errors++;
            }
        }
        if (data.media !== undefined) {
            let data22 = data.media;
            if (typeof data22 === 'string') {
                if (!pattern1.test(data22)) {
                    const err54 = {
                        instancePath: instancePath + '/media',
                        schemaPath: '#/definitions/mediaId/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^m_[A-Za-z0-9_-]{1,64}$' },
                        message: 'must match pattern "' + '^m_[A-Za-z0-9_-]{1,64}$' + '"',
                        schema: '^m_[A-Za-z0-9_-]{1,64}$',
                        parentSchema: schema14,
                        data: data22,
                    };
                    if (vErrors === null) {
                        vErrors = [err54];
                    }
                    else {
                        vErrors.push(err54);
                    }
                    errors++;
                }
            }
            else {
                const err55 = {
                    instancePath: instancePath + '/media',
                    schemaPath: '#/definitions/mediaId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema14.type,
                    parentSchema: schema14,
                    data: data22,
                };
                if (vErrors === null) {
                    vErrors = [err55];
                }
                else {
                    vErrors.push(err55);
                }
                errors++;
            }
        }
        if (data.aspect !== undefined) {
            let data23 = data.aspect;
            if (typeof data23 == 'number' && isFinite(data23)) {
                if (data23 > 2.5 || isNaN(data23)) {
                    const err56 = {
                        instancePath: instancePath + '/aspect',
                        schemaPath: '#/properties/aspect/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 2.5 },
                        message: 'must be <= 2.5',
                        schema: 2.5,
                        parentSchema: schema17.properties.aspect,
                        data: data23,
                    };
                    if (vErrors === null) {
                        vErrors = [err56];
                    }
                    else {
                        vErrors.push(err56);
                    }
                    errors++;
                }
                if (data23 < 0.4 || isNaN(data23)) {
                    const err57 = {
                        instancePath: instancePath + '/aspect',
                        schemaPath: '#/properties/aspect/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.4 },
                        message: 'must be >= 0.4',
                        schema: 0.4,
                        parentSchema: schema17.properties.aspect,
                        data: data23,
                    };
                    if (vErrors === null) {
                        vErrors = [err57];
                    }
                    else {
                        vErrors.push(err57);
                    }
                    errors++;
                }
            }
            else {
                const err58 = {
                    instancePath: instancePath + '/aspect',
                    schemaPath: '#/properties/aspect/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema17.properties.aspect.type,
                    parentSchema: schema17.properties.aspect,
                    data: data23,
                };
                if (vErrors === null) {
                    vErrors = [err58];
                }
                else {
                    vErrors.push(err58);
                }
                errors++;
            }
        }
        if (data.credit !== undefined) {
            let data24 = data.credit;
            if (typeof data24 === 'string') {
                if (func3(data24) > 140) {
                    const err59 = {
                        instancePath: instancePath + '/credit',
                        schemaPath: '#/properties/credit/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 140 },
                        message: 'must NOT have more than 140 characters',
                        schema: 140,
                        parentSchema: schema17.properties.credit,
                        data: data24,
                    };
                    if (vErrors === null) {
                        vErrors = [err59];
                    }
                    else {
                        vErrors.push(err59);
                    }
                    errors++;
                }
                if (func3(data24) < 1) {
                    const err60 = {
                        instancePath: instancePath + '/credit',
                        schemaPath: '#/properties/credit/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema17.properties.credit,
                        data: data24,
                    };
                    if (vErrors === null) {
                        vErrors = [err60];
                    }
                    else {
                        vErrors.push(err60);
                    }
                    errors++;
                }
            }
            else {
                const err61 = {
                    instancePath: instancePath + '/credit',
                    schemaPath: '#/properties/credit/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema17.properties.credit.type,
                    parentSchema: schema17.properties.credit,
                    data: data24,
                };
                if (vErrors === null) {
                    vErrors = [err61];
                }
                else {
                    vErrors.push(err61);
                }
                errors++;
            }
        }
        if (data.turn !== undefined) {
            let data25 = data.turn;
            if (typeof data25 == 'number' && isFinite(data25)) {
                if (data25 > 360 || isNaN(data25)) {
                    const err62 = {
                        instancePath: instancePath + '/turn',
                        schemaPath: '#/properties/turn/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 360 },
                        message: 'must be <= 360',
                        schema: 360,
                        parentSchema: schema17.properties.turn,
                        data: data25,
                    };
                    if (vErrors === null) {
                        vErrors = [err62];
                    }
                    else {
                        vErrors.push(err62);
                    }
                    errors++;
                }
                if (data25 < -360 || isNaN(data25)) {
                    const err63 = {
                        instancePath: instancePath + '/turn',
                        schemaPath: '#/properties/turn/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: -360 },
                        message: 'must be >= -360',
                        schema: -360,
                        parentSchema: schema17.properties.turn,
                        data: data25,
                    };
                    if (vErrors === null) {
                        vErrors = [err63];
                    }
                    else {
                        vErrors.push(err63);
                    }
                    errors++;
                }
            }
            else {
                const err64 = {
                    instancePath: instancePath + '/turn',
                    schemaPath: '#/properties/turn/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema17.properties.turn.type,
                    parentSchema: schema17.properties.turn,
                    data: data25,
                };
                if (vErrors === null) {
                    vErrors = [err64];
                }
                else {
                    vErrors.push(err64);
                }
                errors++;
            }
        }
        if (data.size !== undefined) {
            let data26 = data.size;
            if (typeof data26 == 'number' && isFinite(data26)) {
                if (data26 > 80 || isNaN(data26)) {
                    const err65 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 80 },
                        message: 'must be <= 80',
                        schema: 80,
                        parentSchema: schema17.properties.size,
                        data: data26,
                    };
                    if (vErrors === null) {
                        vErrors = [err65];
                    }
                    else {
                        vErrors.push(err65);
                    }
                    errors++;
                }
                if (data26 < 0.05 || isNaN(data26)) {
                    const err66 = {
                        instancePath: instancePath + '/size',
                        schemaPath: '#/properties/size/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.05 },
                        message: 'must be >= 0.05',
                        schema: 0.05,
                        parentSchema: schema17.properties.size,
                        data: data26,
                    };
                    if (vErrors === null) {
                        vErrors = [err66];
                    }
                    else {
                        vErrors.push(err66);
                    }
                    errors++;
                }
            }
            else {
                const err67 = {
                    instancePath: instancePath + '/size',
                    schemaPath: '#/properties/size/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema17.properties.size.type,
                    parentSchema: schema17.properties.size,
                    data: data26,
                };
                if (vErrors === null) {
                    vErrors = [err67];
                }
                else {
                    vErrors.push(err67);
                }
                errors++;
            }
        }
        if (data.above !== undefined) {
            let data27 = data.above;
            if (typeof data27 == 'number' && isFinite(data27)) {
                if (data27 > 20 || isNaN(data27)) {
                    const err68 = {
                        instancePath: instancePath + '/above',
                        schemaPath: '#/properties/above/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 20 },
                        message: 'must be <= 20',
                        schema: 20,
                        parentSchema: schema17.properties.above,
                        data: data27,
                    };
                    if (vErrors === null) {
                        vErrors = [err68];
                    }
                    else {
                        vErrors.push(err68);
                    }
                    errors++;
                }
                if (data27 < 0 || isNaN(data27)) {
                    const err69 = {
                        instancePath: instancePath + '/above',
                        schemaPath: '#/properties/above/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0 },
                        message: 'must be >= 0',
                        schema: 0,
                        parentSchema: schema17.properties.above,
                        data: data27,
                    };
                    if (vErrors === null) {
                        vErrors = [err69];
                    }
                    else {
                        vErrors.push(err69);
                    }
                    errors++;
                }
            }
            else {
                const err70 = {
                    instancePath: instancePath + '/above',
                    schemaPath: '#/properties/above/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema17.properties.above.type,
                    parentSchema: schema17.properties.above,
                    data: data27,
                };
                if (vErrors === null) {
                    vErrors = [err70];
                }
                else {
                    vErrors.push(err70);
                }
                errors++;
            }
        }
    }
    else {
        const err71 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema17.type,
            parentSchema: schema17,
            data,
        };
        if (vErrors === null) {
            vErrors = [err71];
        }
        else {
            vErrors.push(err71);
        }
        errors++;
    }
    validate13.errors = vErrors;
    return errors === 0;
}
const schema105 = {
    type: 'object',
    additionalProperties: false,
    required: ['id', 'title'],
    properties: {
        id: { $ref: '#/definitions/slug' },
        title: { type: 'string', minLength: 1, maxLength: 80 },
        focus: {
            description: 'Which object the step is about; the engine dims the other labels.',
            oneOf: [{ $ref: '#/definitions/slug' }, { $ref: '#/definitions/worldFeature' }],
        },
        view: { $ref: '#/definitions/view' },
        panel: { $ref: '#/definitions/panel' },
        narration: {
            description: "What the voice says for this step: spoken Dutch, 15–45 s. Absent: the panel's text, then the step's question. Write numbers and abbreviations out.",
            type: 'string',
            minLength: 1,
            maxLength: 600,
            pattern: '^ *[^ ].*$',
        },
        voiceover: { $ref: '#/definitions/mediaId' },
        hotspots: { type: 'array', maxItems: 6, items: { $ref: '#/definitions/hotspot' } },
        quiz: { $ref: '#/definitions/quiz' },
        predict: { $ref: '#/definitions/predict' },
        task: { $ref: '#/definitions/task' },
        show: {
            description: 'Objects that appear when this step starts, growing into place. VR only.',
            type: 'array',
            maxItems: 12,
            items: { $ref: '#/definitions/slug' },
        },
        hide: {
            description: 'Objects that disappear when this step starts, shrinking away. VR only.',
            type: 'array',
            maxItems: 12,
            items: { $ref: '#/definitions/slug' },
        },
        move: {
            description: 'Shapes that move, turn or grow to a new place when this step starts, after show and hide. VR only.',
            type: 'array',
            maxItems: 8,
            items: { $ref: '#/definitions/stepMove' },
        },
        highlight: {
            description: 'The object this step points out: it lights up twice once the changes are done. VR only.',
            $ref: '#/definitions/slug',
        },
        world: {
            description: 'States of the world\'s features from this step on, by feature: {"vulkaan": "uitbarsting"}.',
            type: 'object',
            additionalProperties: { type: 'string' },
        },
        pano: {
            description: 'Changes the 360° photo from this step on; a pano360 lesson only.',
            $ref: '#/definitions/panoPhoto',
        },
        models: {
            description: "What the lesson's models do when this step starts, one entry per model, in this order: walk, face, play. A model with no entry carries on. VR only.",
            type: 'array',
            maxItems: 5,
            items: { $ref: '#/definitions/stepModel' },
        },
        spannend: {
            description: "An exciting version of this step's models, played instead of models only when the teacher turned Spannend on.",
            $ref: '#/definitions/stepSpannend',
        },
        pause: {
            description: "A good moment for the teacher to pause the class after this step: only the teacher's console shows it; the lesson never stops by itself.",
            type: 'boolean',
        },
    },
    not: {
        description: 'A step asks one thing. predict may accompany a task (estimate, then measure), but quiz and task are alternatives.',
        required: ['quiz', 'task'],
    },
};
const schema108 = {
    description: "A feature of the lesson's world, as wereld:<feature>: the catalogue lists each world's.",
    type: 'string',
    pattern: '^wereld:[a-z0-9]+(-[a-z0-9]+)*$',
    maxLength: 71,
};
const schema117 = {
    description: 'Text on the lectern. In a predict step it is the introduction, shown before the question. Limits come from what stayed readable in the prototypes.',
    type: 'object',
    additionalProperties: false,
    required: ['title', 'text'],
    properties: {
        title: { type: 'string', minLength: 1, maxLength: 80 },
        text: { type: 'string', minLength: 1, maxLength: 260 },
    },
};
const schema121 = {
    description: 'Retrieval at the end of a lesson. answer is a zero-based index into options.',
    type: 'object',
    additionalProperties: false,
    required: ['question', 'options', 'answer', 'explain'],
    properties: {
        question: { type: 'string', minLength: 1, maxLength: 200 },
        options: {
            type: 'array',
            minItems: 2,
            maxItems: 4,
            items: { type: 'string', minLength: 1, maxLength: 80 },
        },
        answer: { type: 'integer', minimum: 0 },
        explain: { type: 'string', minLength: 1, maxLength: 260 },
        level: {
            description: "How hard the question is: herkennen (recognise it), begrijpen (understand why), toepassen (apply it to a new case). A lesson's questions rise: never an easier one after a harder one.",
            enum: ['herkennen', 'begrijpen', 'toepassen'],
        },
        doordenk: {
            description: "The lesson's doordenkvraag: its last question, a reasoning question (why, or what would happen if, in a new case) answered from memory, at level toepassen. The teacher's console shows it after the lesson as a starter for a class discussion.",
            type: 'boolean',
        },
    },
};
const schema122 = {
    description: "Asked after the step's panel (its introduction), before the reveal: the task, or the next step. Omit answer when a task decides what was right, as in AR measuring.",
    type: 'object',
    additionalProperties: false,
    required: ['question', 'options'],
    properties: {
        question: { type: 'string', minLength: 1, maxLength: 200 },
        options: {
            type: 'array',
            minItems: 2,
            maxItems: 4,
            items: { type: 'string', minLength: 1, maxLength: 80 },
        },
        answer: { type: 'integer', minimum: 0 },
    },
};
const pattern19 = new RegExp('^wereld:[a-z0-9]+(-[a-z0-9]+)*$', 'u');
const pattern25 = new RegExp('^ *[^ ].*$', 'u');
const schema109 = {
    description: 'Where the visitor stands and what they look at. Three forms, all used by the prototypes.',
    oneOf: [
        {
            type: 'object',
            additionalProperties: false,
            required: ['look'],
            properties: {
                look: { oneOf: [{ $ref: '#/definitions/slug' }, { $ref: '#/definitions/worldFeature' }] },
            },
        },
        {
            type: 'object',
            additionalProperties: false,
            required: ['pos', 'look'],
            properties: {
                pos: { $ref: '#/definitions/vec3' },
                look: {
                    oneOf: [
                        { $ref: '#/definitions/slug' },
                        { $ref: '#/definitions/worldFeature' },
                        { $ref: '#/definitions/vec3' },
                    ],
                },
            },
        },
        {
            type: 'object',
            additionalProperties: false,
            required: ['station'],
            properties: { station: { $ref: '#/definitions/slug' } },
        },
    ],
};
function validate60(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.look === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/oneOf/0/required',
                keyword: 'required',
                params: { missingProperty: 'look' },
                message: "must have required property '" + 'look' + "'",
                schema: schema109.oneOf[0].required,
                parentSchema: schema109.oneOf[0],
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'look')) {
                const err1 = {
                    instancePath,
                    schemaPath: '#/oneOf/0/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema109.oneOf[0],
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        if (data.look !== undefined) {
            let data0 = data.look;
            const _errs5 = errors;
            let valid2 = false;
            let passing1 = null;
            const _errs6 = errors;
            if (typeof data0 === 'string') {
                if (func3(data0) > 64) {
                    const err2 = {
                        instancePath: instancePath + '/look',
                        schemaPath: '#/definitions/slug/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 characters',
                        schema: 64,
                        parentSchema: schema12,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
                if (!pattern0.test(data0)) {
                    const err3 = {
                        instancePath: instancePath + '/look',
                        schemaPath: '#/definitions/slug/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                        message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                        schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                        parentSchema: schema12,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
            }
            else {
                const err4 = {
                    instancePath: instancePath + '/look',
                    schemaPath: '#/definitions/slug/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema12.type,
                    parentSchema: schema12,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            var _valid1 = _errs6 === errors;
            if (_valid1) {
                valid2 = true;
                passing1 = 0;
            }
            const _errs9 = errors;
            if (typeof data0 === 'string') {
                if (func3(data0) > 71) {
                    const err5 = {
                        instancePath: instancePath + '/look',
                        schemaPath: '#/definitions/worldFeature/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 71 },
                        message: 'must NOT have more than 71 characters',
                        schema: 71,
                        parentSchema: schema108,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (!pattern19.test(data0)) {
                    const err6 = {
                        instancePath: instancePath + '/look',
                        schemaPath: '#/definitions/worldFeature/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^wereld:[a-z0-9]+(-[a-z0-9]+)*$' },
                        message: 'must match pattern "' + '^wereld:[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                        schema: '^wereld:[a-z0-9]+(-[a-z0-9]+)*$',
                        parentSchema: schema108,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
            }
            else {
                const err7 = {
                    instancePath: instancePath + '/look',
                    schemaPath: '#/definitions/worldFeature/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema108.type,
                    parentSchema: schema108,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            var _valid1 = _errs9 === errors;
            if (_valid1 && valid2) {
                valid2 = false;
                passing1 = [passing1, 1];
            }
            else {
                if (_valid1) {
                    valid2 = true;
                    passing1 = 1;
                }
            }
            if (!valid2) {
                const err8 = {
                    instancePath: instancePath + '/look',
                    schemaPath: '#/oneOf/0/properties/look/oneOf',
                    keyword: 'oneOf',
                    params: { passingSchemas: passing1 },
                    message: 'must match exactly one schema in oneOf',
                    schema: schema109.oneOf[0].properties.look.oneOf,
                    parentSchema: schema109.oneOf[0].properties.look,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            else {
                errors = _errs5;
                if (vErrors !== null) {
                    if (_errs5) {
                        vErrors.length = _errs5;
                    }
                    else {
                        vErrors = null;
                    }
                }
            }
        }
    }
    else {
        const err9 = {
            instancePath,
            schemaPath: '#/oneOf/0/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema109.oneOf[0].type,
            parentSchema: schema109.oneOf[0],
            data,
        };
        if (vErrors === null) {
            vErrors = [err9];
        }
        else {
            vErrors.push(err9);
        }
        errors++;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    const _errs12 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.pos === undefined) {
            const err10 = {
                instancePath,
                schemaPath: '#/oneOf/1/required',
                keyword: 'required',
                params: { missingProperty: 'pos' },
                message: "must have required property '" + 'pos' + "'",
                schema: schema109.oneOf[1].required,
                parentSchema: schema109.oneOf[1],
                data,
            };
            if (vErrors === null) {
                vErrors = [err10];
            }
            else {
                vErrors.push(err10);
            }
            errors++;
        }
        if (data.look === undefined) {
            const err11 = {
                instancePath,
                schemaPath: '#/oneOf/1/required',
                keyword: 'required',
                params: { missingProperty: 'look' },
                message: "must have required property '" + 'look' + "'",
                schema: schema109.oneOf[1].required,
                parentSchema: schema109.oneOf[1],
                data,
            };
            if (vErrors === null) {
                vErrors = [err11];
            }
            else {
                vErrors.push(err11);
            }
            errors++;
        }
        for (const key1 in data) {
            if (!(key1 === 'pos' || key1 === 'look')) {
                const err12 = {
                    instancePath,
                    schemaPath: '#/oneOf/1/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key1 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema109.oneOf[1],
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err12];
                }
                else {
                    vErrors.push(err12);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data1 = data.pos;
            if (Array.isArray(data1)) {
                if (data1.length > 3) {
                    const err13 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/vec3/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema18,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err13];
                    }
                    else {
                        vErrors.push(err13);
                    }
                    errors++;
                }
                if (data1.length < 3) {
                    const err14 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/vec3/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema18,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (!(typeof data2 == 'number' && isFinite(data2))) {
                        const err15 = {
                            instancePath: instancePath + '/pos/' + i0,
                            schemaPath: '#/definitions/vec3/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema18.items.type,
                            parentSchema: schema18.items,
                            data: data2,
                        };
                        if (vErrors === null) {
                            vErrors = [err15];
                        }
                        else {
                            vErrors.push(err15);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err16 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/vec3/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema18.type,
                    parentSchema: schema18,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.look !== undefined) {
            let data3 = data.look;
            const _errs21 = errors;
            let valid9 = false;
            let passing2 = null;
            const _errs22 = errors;
            if (typeof data3 === 'string') {
                if (func3(data3) > 64) {
                    const err17 = {
                        instancePath: instancePath + '/look',
                        schemaPath: '#/definitions/slug/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 characters',
                        schema: 64,
                        parentSchema: schema12,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
                if (!pattern0.test(data3)) {
                    const err18 = {
                        instancePath: instancePath + '/look',
                        schemaPath: '#/definitions/slug/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                        message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                        schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                        parentSchema: schema12,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
            }
            else {
                const err19 = {
                    instancePath: instancePath + '/look',
                    schemaPath: '#/definitions/slug/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema12.type,
                    parentSchema: schema12,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err19];
                }
                else {
                    vErrors.push(err19);
                }
                errors++;
            }
            var _valid2 = _errs22 === errors;
            if (_valid2) {
                valid9 = true;
                passing2 = 0;
            }
            const _errs25 = errors;
            if (typeof data3 === 'string') {
                if (func3(data3) > 71) {
                    const err20 = {
                        instancePath: instancePath + '/look',
                        schemaPath: '#/definitions/worldFeature/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 71 },
                        message: 'must NOT have more than 71 characters',
                        schema: 71,
                        parentSchema: schema108,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
                if (!pattern19.test(data3)) {
                    const err21 = {
                        instancePath: instancePath + '/look',
                        schemaPath: '#/definitions/worldFeature/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^wereld:[a-z0-9]+(-[a-z0-9]+)*$' },
                        message: 'must match pattern "' + '^wereld:[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                        schema: '^wereld:[a-z0-9]+(-[a-z0-9]+)*$',
                        parentSchema: schema108,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
            }
            else {
                const err22 = {
                    instancePath: instancePath + '/look',
                    schemaPath: '#/definitions/worldFeature/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema108.type,
                    parentSchema: schema108,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err22];
                }
                else {
                    vErrors.push(err22);
                }
                errors++;
            }
            var _valid2 = _errs25 === errors;
            if (_valid2 && valid9) {
                valid9 = false;
                passing2 = [passing2, 1];
            }
            else {
                if (_valid2) {
                    valid9 = true;
                    passing2 = 1;
                }
                const _errs28 = errors;
                if (Array.isArray(data3)) {
                    if (data3.length > 3) {
                        const err23 = {
                            instancePath: instancePath + '/look',
                            schemaPath: '#/definitions/vec3/maxItems',
                            keyword: 'maxItems',
                            params: { limit: 3 },
                            message: 'must NOT have more than 3 items',
                            schema: 3,
                            parentSchema: schema18,
                            data: data3,
                        };
                        if (vErrors === null) {
                            vErrors = [err23];
                        }
                        else {
                            vErrors.push(err23);
                        }
                        errors++;
                    }
                    if (data3.length < 3) {
                        const err24 = {
                            instancePath: instancePath + '/look',
                            schemaPath: '#/definitions/vec3/minItems',
                            keyword: 'minItems',
                            params: { limit: 3 },
                            message: 'must NOT have fewer than 3 items',
                            schema: 3,
                            parentSchema: schema18,
                            data: data3,
                        };
                        if (vErrors === null) {
                            vErrors = [err24];
                        }
                        else {
                            vErrors.push(err24);
                        }
                        errors++;
                    }
                    const len1 = data3.length;
                    for (let i1 = 0; i1 < len1; i1++) {
                        let data4 = data3[i1];
                        if (!(typeof data4 == 'number' && isFinite(data4))) {
                            const err25 = {
                                instancePath: instancePath + '/look/' + i1,
                                schemaPath: '#/definitions/vec3/items/type',
                                keyword: 'type',
                                params: { type: 'number' },
                                message: 'must be number',
                                schema: schema18.items.type,
                                parentSchema: schema18.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err25];
                            }
                            else {
                                vErrors.push(err25);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err26 = {
                        instancePath: instancePath + '/look',
                        schemaPath: '#/definitions/vec3/type',
                        keyword: 'type',
                        params: { type: 'array' },
                        message: 'must be array',
                        schema: schema18.type,
                        parentSchema: schema18,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
                var _valid2 = _errs28 === errors;
                if (_valid2 && valid9) {
                    valid9 = false;
                    passing2 = [passing2, 2];
                }
                else {
                    if (_valid2) {
                        valid9 = true;
                        passing2 = 2;
                    }
                }
            }
            if (!valid9) {
                const err27 = {
                    instancePath: instancePath + '/look',
                    schemaPath: '#/oneOf/1/properties/look/oneOf',
                    keyword: 'oneOf',
                    params: { passingSchemas: passing2 },
                    message: 'must match exactly one schema in oneOf',
                    schema: schema109.oneOf[1].properties.look.oneOf,
                    parentSchema: schema109.oneOf[1].properties.look,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err27];
                }
                else {
                    vErrors.push(err27);
                }
                errors++;
            }
            else {
                errors = _errs21;
                if (vErrors !== null) {
                    if (_errs21) {
                        vErrors.length = _errs21;
                    }
                    else {
                        vErrors = null;
                    }
                }
            }
        }
    }
    else {
        const err28 = {
            instancePath,
            schemaPath: '#/oneOf/1/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema109.oneOf[1].type,
            parentSchema: schema109.oneOf[1],
            data,
        };
        if (vErrors === null) {
            vErrors = [err28];
        }
        else {
            vErrors.push(err28);
        }
        errors++;
    }
    var _valid0 = _errs12 === errors;
    if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 1];
    }
    else {
        if (_valid0) {
            valid0 = true;
            passing0 = 1;
        }
        const _errs33 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.station === undefined) {
                const err29 = {
                    instancePath,
                    schemaPath: '#/oneOf/2/required',
                    keyword: 'required',
                    params: { missingProperty: 'station' },
                    message: "must have required property '" + 'station' + "'",
                    schema: schema109.oneOf[2].required,
                    parentSchema: schema109.oneOf[2],
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err29];
                }
                else {
                    vErrors.push(err29);
                }
                errors++;
            }
            for (const key2 in data) {
                if (!(key2 === 'station')) {
                    const err30 = {
                        instancePath,
                        schemaPath: '#/oneOf/2/additionalProperties',
                        keyword: 'additionalProperties',
                        params: { additionalProperty: key2 },
                        message: 'must NOT have additional properties',
                        schema: false,
                        parentSchema: schema109.oneOf[2],
                        data,
                    };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
            }
            if (data.station !== undefined) {
                let data5 = data.station;
                if (typeof data5 === 'string') {
                    if (func3(data5) > 64) {
                        const err31 = {
                            instancePath: instancePath + '/station',
                            schemaPath: '#/definitions/slug/maxLength',
                            keyword: 'maxLength',
                            params: { limit: 64 },
                            message: 'must NOT have more than 64 characters',
                            schema: 64,
                            parentSchema: schema12,
                            data: data5,
                        };
                        if (vErrors === null) {
                            vErrors = [err31];
                        }
                        else {
                            vErrors.push(err31);
                        }
                        errors++;
                    }
                    if (!pattern0.test(data5)) {
                        const err32 = {
                            instancePath: instancePath + '/station',
                            schemaPath: '#/definitions/slug/pattern',
                            keyword: 'pattern',
                            params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                            message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                            schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                            parentSchema: schema12,
                            data: data5,
                        };
                        if (vErrors === null) {
                            vErrors = [err32];
                        }
                        else {
                            vErrors.push(err32);
                        }
                        errors++;
                    }
                }
                else {
                    const err33 = {
                        instancePath: instancePath + '/station',
                        schemaPath: '#/definitions/slug/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                        schema: schema12.type,
                        parentSchema: schema12,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err33];
                    }
                    else {
                        vErrors.push(err33);
                    }
                    errors++;
                }
            }
        }
        else {
            const err34 = {
                instancePath,
                schemaPath: '#/oneOf/2/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
                schema: schema109.oneOf[2].type,
                parentSchema: schema109.oneOf[2],
                data,
            };
            if (vErrors === null) {
                vErrors = [err34];
            }
            else {
                vErrors.push(err34);
            }
            errors++;
        }
        var _valid0 = _errs33 === errors;
        if (_valid0 && valid0) {
            valid0 = false;
            passing0 = [passing0, 2];
        }
        else {
            if (_valid0) {
                valid0 = true;
                passing0 = 2;
            }
        }
    }
    if (!valid0) {
        const err35 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
            schema: schema109.oneOf,
            parentSchema: schema109,
            data,
        };
        if (vErrors === null) {
            vErrors = [err35];
        }
        else {
            vErrors.push(err35);
        }
        errors++;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate60.errors = vErrors;
    return errors === 0;
}
const schema119 = {
    type: 'object',
    additionalProperties: false,
    required: ['title', 'text'],
    properties: {
        object: {
            description: 'The object the hotspot hangs on. Exactly one of object, find and toward.',
            $ref: '#/definitions/slug',
        },
        feature: {
            description: 'A world lesson, instead of object: the feature of the lesson\'s world the hotspot hangs on, by its id ("bloedstroom"), in any state. Its badge sits at the feature.',
            type: 'string',
            minLength: 1,
            maxLength: 64,
        },
        find: {
            description: 'A pano360 lesson only, instead of object: what to look for in the photo, in Dutch. The platform points it.',
            type: 'string',
            minLength: 1,
            maxLength: 60,
        },
        point: {
            description: "A pano360 lesson of a place with named points, instead of object: the point's name. The platform fills toward.",
            type: 'string',
            minLength: 1,
            maxLength: 40,
        },
        toward: {
            description: 'Where find points in the photo, [azimuth, elevation] in degrees. Filled in by the platform.',
            type: 'array',
            minItems: 2,
            maxItems: 2,
            items: [
                { type: 'number', minimum: -180, maximum: 180 },
                { type: 'number', minimum: -90, maximum: 90 },
            ],
        },
        title: { type: 'string', minLength: 1, maxLength: 80 },
        text: { type: 'string', minLength: 1, maxLength: 200 },
    },
};
function validate62(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.title === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'title' },
                message: "must have required property '" + 'title' + "'",
                schema: schema119.required,
                parentSchema: schema119,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.text === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'text' },
                message: "must have required property '" + 'text' + "'",
                schema: schema119.required,
                parentSchema: schema119,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'object' ||
                key0 === 'feature' ||
                key0 === 'find' ||
                key0 === 'point' ||
                key0 === 'toward' ||
                key0 === 'title' ||
                key0 === 'text')) {
                const err2 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema119,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.object !== undefined) {
            let data0 = data.object;
            if (typeof data0 === 'string') {
                if (func3(data0) > 64) {
                    const err3 = {
                        instancePath: instancePath + '/object',
                        schemaPath: '#/definitions/slug/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 characters',
                        schema: 64,
                        parentSchema: schema12,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
                if (!pattern0.test(data0)) {
                    const err4 = {
                        instancePath: instancePath + '/object',
                        schemaPath: '#/definitions/slug/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                        message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                        schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                        parentSchema: schema12,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            else {
                const err5 = {
                    instancePath: instancePath + '/object',
                    schemaPath: '#/definitions/slug/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema12.type,
                    parentSchema: schema12,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
        }
        if (data.feature !== undefined) {
            let data1 = data.feature;
            if (typeof data1 === 'string') {
                if (func3(data1) > 64) {
                    const err6 = {
                        instancePath: instancePath + '/feature',
                        schemaPath: '#/properties/feature/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 characters',
                        schema: 64,
                        parentSchema: schema119.properties.feature,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                if (func3(data1) < 1) {
                    const err7 = {
                        instancePath: instancePath + '/feature',
                        schemaPath: '#/properties/feature/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema119.properties.feature,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                }
            }
            else {
                const err8 = {
                    instancePath: instancePath + '/feature',
                    schemaPath: '#/properties/feature/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema119.properties.feature.type,
                    parentSchema: schema119.properties.feature,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
        }
        if (data.find !== undefined) {
            let data2 = data.find;
            if (typeof data2 === 'string') {
                if (func3(data2) > 60) {
                    const err9 = {
                        instancePath: instancePath + '/find',
                        schemaPath: '#/properties/find/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 60 },
                        message: 'must NOT have more than 60 characters',
                        schema: 60,
                        parentSchema: schema119.properties.find,
                        data: data2,
                    };
                    if (vErrors === null) {
                        vErrors = [err9];
                    }
                    else {
                        vErrors.push(err9);
                    }
                    errors++;
                }
                if (func3(data2) < 1) {
                    const err10 = {
                        instancePath: instancePath + '/find',
                        schemaPath: '#/properties/find/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema119.properties.find,
                        data: data2,
                    };
                    if (vErrors === null) {
                        vErrors = [err10];
                    }
                    else {
                        vErrors.push(err10);
                    }
                    errors++;
                }
            }
            else {
                const err11 = {
                    instancePath: instancePath + '/find',
                    schemaPath: '#/properties/find/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema119.properties.find.type,
                    parentSchema: schema119.properties.find,
                    data: data2,
                };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
        }
        if (data.point !== undefined) {
            let data3 = data.point;
            if (typeof data3 === 'string') {
                if (func3(data3) > 40) {
                    const err12 = {
                        instancePath: instancePath + '/point',
                        schemaPath: '#/properties/point/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 40 },
                        message: 'must NOT have more than 40 characters',
                        schema: 40,
                        parentSchema: schema119.properties.point,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
                if (func3(data3) < 1) {
                    const err13 = {
                        instancePath: instancePath + '/point',
                        schemaPath: '#/properties/point/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema119.properties.point,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err13];
                    }
                    else {
                        vErrors.push(err13);
                    }
                    errors++;
                }
            }
            else {
                const err14 = {
                    instancePath: instancePath + '/point',
                    schemaPath: '#/properties/point/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema119.properties.point.type,
                    parentSchema: schema119.properties.point,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err14];
                }
                else {
                    vErrors.push(err14);
                }
                errors++;
            }
        }
        if (data.toward !== undefined) {
            let data4 = data.toward;
            if (Array.isArray(data4)) {
                if (data4.length > 2) {
                    const err15 = {
                        instancePath: instancePath + '/toward',
                        schemaPath: '#/properties/toward/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 2 },
                        message: 'must NOT have more than 2 items',
                        schema: 2,
                        parentSchema: schema119.properties.toward,
                        data: data4,
                    };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
                if (data4.length < 2) {
                    const err16 = {
                        instancePath: instancePath + '/toward',
                        schemaPath: '#/properties/toward/minItems',
                        keyword: 'minItems',
                        params: { limit: 2 },
                        message: 'must NOT have fewer than 2 items',
                        schema: 2,
                        parentSchema: schema119.properties.toward,
                        data: data4,
                    };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
                const len0 = data4.length;
                if (len0 > 0) {
                    let data5 = data4[0];
                    if (typeof data5 == 'number' && isFinite(data5)) {
                        if (data5 > 180 || isNaN(data5)) {
                            const err17 = {
                                instancePath: instancePath + '/toward/0',
                                schemaPath: '#/properties/toward/items/0/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 180 },
                                message: 'must be <= 180',
                                schema: 180,
                                parentSchema: schema119.properties.toward.items[0],
                                data: data5,
                            };
                            if (vErrors === null) {
                                vErrors = [err17];
                            }
                            else {
                                vErrors.push(err17);
                            }
                            errors++;
                        }
                        if (data5 < -180 || isNaN(data5)) {
                            const err18 = {
                                instancePath: instancePath + '/toward/0',
                                schemaPath: '#/properties/toward/items/0/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -180 },
                                message: 'must be >= -180',
                                schema: -180,
                                parentSchema: schema119.properties.toward.items[0],
                                data: data5,
                            };
                            if (vErrors === null) {
                                vErrors = [err18];
                            }
                            else {
                                vErrors.push(err18);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err19 = {
                            instancePath: instancePath + '/toward/0',
                            schemaPath: '#/properties/toward/items/0/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema119.properties.toward.items[0].type,
                            parentSchema: schema119.properties.toward.items[0],
                            data: data5,
                        };
                        if (vErrors === null) {
                            vErrors = [err19];
                        }
                        else {
                            vErrors.push(err19);
                        }
                        errors++;
                    }
                }
                if (len0 > 1) {
                    let data6 = data4[1];
                    if (typeof data6 == 'number' && isFinite(data6)) {
                        if (data6 > 90 || isNaN(data6)) {
                            const err20 = {
                                instancePath: instancePath + '/toward/1',
                                schemaPath: '#/properties/toward/items/1/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 90 },
                                message: 'must be <= 90',
                                schema: 90,
                                parentSchema: schema119.properties.toward.items[1],
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err20];
                            }
                            else {
                                vErrors.push(err20);
                            }
                            errors++;
                        }
                        if (data6 < -90 || isNaN(data6)) {
                            const err21 = {
                                instancePath: instancePath + '/toward/1',
                                schemaPath: '#/properties/toward/items/1/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -90 },
                                message: 'must be >= -90',
                                schema: -90,
                                parentSchema: schema119.properties.toward.items[1],
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err21];
                            }
                            else {
                                vErrors.push(err21);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err22 = {
                            instancePath: instancePath + '/toward/1',
                            schemaPath: '#/properties/toward/items/1/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema119.properties.toward.items[1].type,
                            parentSchema: schema119.properties.toward.items[1],
                            data: data6,
                        };
                        if (vErrors === null) {
                            vErrors = [err22];
                        }
                        else {
                            vErrors.push(err22);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err23 = {
                    instancePath: instancePath + '/toward',
                    schemaPath: '#/properties/toward/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema119.properties.toward.type,
                    parentSchema: schema119.properties.toward,
                    data: data4,
                };
                if (vErrors === null) {
                    vErrors = [err23];
                }
                else {
                    vErrors.push(err23);
                }
                errors++;
            }
        }
        if (data.title !== undefined) {
            let data7 = data.title;
            if (typeof data7 === 'string') {
                if (func3(data7) > 80) {
                    const err24 = {
                        instancePath: instancePath + '/title',
                        schemaPath: '#/properties/title/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 80 },
                        message: 'must NOT have more than 80 characters',
                        schema: 80,
                        parentSchema: schema119.properties.title,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err24];
                    }
                    else {
                        vErrors.push(err24);
                    }
                    errors++;
                }
                if (func3(data7) < 1) {
                    const err25 = {
                        instancePath: instancePath + '/title',
                        schemaPath: '#/properties/title/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema119.properties.title,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
            }
            else {
                const err26 = {
                    instancePath: instancePath + '/title',
                    schemaPath: '#/properties/title/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema119.properties.title.type,
                    parentSchema: schema119.properties.title,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err26];
                }
                else {
                    vErrors.push(err26);
                }
                errors++;
            }
        }
        if (data.text !== undefined) {
            let data8 = data.text;
            if (typeof data8 === 'string') {
                if (func3(data8) > 200) {
                    const err27 = {
                        instancePath: instancePath + '/text',
                        schemaPath: '#/properties/text/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 200 },
                        message: 'must NOT have more than 200 characters',
                        schema: 200,
                        parentSchema: schema119.properties.text,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err27];
                    }
                    else {
                        vErrors.push(err27);
                    }
                    errors++;
                }
                if (func3(data8) < 1) {
                    const err28 = {
                        instancePath: instancePath + '/text',
                        schemaPath: '#/properties/text/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema119.properties.text,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err28];
                    }
                    else {
                        vErrors.push(err28);
                    }
                    errors++;
                }
            }
            else {
                const err29 = {
                    instancePath: instancePath + '/text',
                    schemaPath: '#/properties/text/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema119.properties.text.type,
                    parentSchema: schema119.properties.text,
                    data: data8,
                };
                if (vErrors === null) {
                    vErrors = [err29];
                }
                else {
                    vErrors.push(err29);
                }
                errors++;
            }
        }
    }
    else {
        const err30 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema119.type,
            parentSchema: schema119,
            data,
        };
        if (vErrors === null) {
            vErrors = [err30];
        }
        else {
            vErrors.push(err30);
        }
        errors++;
    }
    validate62.errors = vErrors;
    return errors === 0;
}
const schema123 = {
    description: 'Something the pupil does. measure and assemble: AR, in the real world; furnish: VR, in the villa.',
    oneOf: [
        {
            type: 'object',
            additionalProperties: false,
            required: ['type', 'instruction'],
            properties: {
                type: { const: 'measure' },
                instruction: { type: 'string', minLength: 1, maxLength: 200 },
                edges: {
                    description: 'Ascending bucket boundaries in metres. With a predict, there must be one fewer edge than there are options.',
                    type: 'array',
                    minItems: 1,
                    items: { type: 'number', exclusiveMinimum: 0 },
                },
            },
        },
        {
            type: 'object',
            additionalProperties: false,
            required: ['type', 'instruction', 'parts'],
            properties: {
                type: { const: 'assemble' },
                instruction: { type: 'string', minLength: 1, maxLength: 200 },
                parts: {
                    description: "Object ids the student has to put in place. Each one's `pos` in `objects` is where it belongs -- the lesson states the finished thing and the engine scatters it, so there is no second copy of the right answer to keep in step.",
                    type: 'array',
                    minItems: 2,
                    maxItems: 24,
                    items: { $ref: '#/definitions/slug' },
                },
                snapMetres: {
                    description: 'How close counts as placed. Default 0.08. A ten-year-old pinching a bone in mid-air is not accurate to a centimetre, and a lesson about the skeleton is not a test of fine motor control.',
                    type: 'number',
                    exclusiveMinimum: 0,
                    maximum: 0.5,
                },
            },
        },
        {
            type: 'object',
            additionalProperties: false,
            required: ['type', 'instruction'],
            properties: {
                type: {
                    description: "The pupils place the school's own work (furniture, sculptures, cars: a set of werkstukken the teacher picks when the lesson starts, never named in the lesson). Only in a world with a placement space (the villa, or a package with a plaatsruimte), one step per lesson (ADR-037, ADR-050).",
                    const: 'furnish',
                },
                instruction: { type: 'string', minLength: 1, maxLength: 200 },
            },
        },
    ],
};
function validate64(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs0 = errors;
    let valid0 = false;
    let passing0 = null;
    const _errs1 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/oneOf/0/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema123.oneOf[0].required,
                parentSchema: schema123.oneOf[0],
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.instruction === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/oneOf/0/required',
                keyword: 'required',
                params: { missingProperty: 'instruction' },
                message: "must have required property '" + 'instruction' + "'",
                schema: schema123.oneOf[0].required,
                parentSchema: schema123.oneOf[0],
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'type' || key0 === 'instruction' || key0 === 'edges')) {
                const err2 = {
                    instancePath,
                    schemaPath: '#/oneOf/0/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema123.oneOf[0],
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.type !== undefined) {
            let data0 = data.type;
            if ('measure' !== data0) {
                const err3 = {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/oneOf/0/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'measure' },
                    message: 'must be equal to constant',
                    schema: 'measure',
                    parentSchema: schema123.oneOf[0].properties.type,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
        }
        if (data.instruction !== undefined) {
            let data1 = data.instruction;
            if (typeof data1 === 'string') {
                if (func3(data1) > 200) {
                    const err4 = {
                        instancePath: instancePath + '/instruction',
                        schemaPath: '#/oneOf/0/properties/instruction/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 200 },
                        message: 'must NOT have more than 200 characters',
                        schema: 200,
                        parentSchema: schema123.oneOf[0].properties.instruction,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
                if (func3(data1) < 1) {
                    const err5 = {
                        instancePath: instancePath + '/instruction',
                        schemaPath: '#/oneOf/0/properties/instruction/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema123.oneOf[0].properties.instruction,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
            }
            else {
                const err6 = {
                    instancePath: instancePath + '/instruction',
                    schemaPath: '#/oneOf/0/properties/instruction/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema123.oneOf[0].properties.instruction.type,
                    parentSchema: schema123.oneOf[0].properties.instruction,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
        }
        if (data.edges !== undefined) {
            let data2 = data.edges;
            if (Array.isArray(data2)) {
                if (data2.length < 1) {
                    const err7 = {
                        instancePath: instancePath + '/edges',
                        schemaPath: '#/oneOf/0/properties/edges/minItems',
                        keyword: 'minItems',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 items',
                        schema: 1,
                        parentSchema: schema123.oneOf[0].properties.edges,
                        data: data2,
                    };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                }
                const len0 = data2.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data3 = data2[i0];
                    if (typeof data3 == 'number' && isFinite(data3)) {
                        if (data3 <= 0 || isNaN(data3)) {
                            const err8 = {
                                instancePath: instancePath + '/edges/' + i0,
                                schemaPath: '#/oneOf/0/properties/edges/items/exclusiveMinimum',
                                keyword: 'exclusiveMinimum',
                                params: { comparison: '>', limit: 0 },
                                message: 'must be > 0',
                                schema: 0,
                                parentSchema: schema123.oneOf[0].properties.edges.items,
                                data: data3,
                            };
                            if (vErrors === null) {
                                vErrors = [err8];
                            }
                            else {
                                vErrors.push(err8);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err9 = {
                            instancePath: instancePath + '/edges/' + i0,
                            schemaPath: '#/oneOf/0/properties/edges/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema123.oneOf[0].properties.edges.items.type,
                            parentSchema: schema123.oneOf[0].properties.edges.items,
                            data: data3,
                        };
                        if (vErrors === null) {
                            vErrors = [err9];
                        }
                        else {
                            vErrors.push(err9);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err10 = {
                    instancePath: instancePath + '/edges',
                    schemaPath: '#/oneOf/0/properties/edges/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema123.oneOf[0].properties.edges.type,
                    parentSchema: schema123.oneOf[0].properties.edges,
                    data: data2,
                };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
        }
    }
    else {
        const err11 = {
            instancePath,
            schemaPath: '#/oneOf/0/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema123.oneOf[0].type,
            parentSchema: schema123.oneOf[0],
            data,
        };
        if (vErrors === null) {
            vErrors = [err11];
        }
        else {
            vErrors.push(err11);
        }
        errors++;
    }
    var _valid0 = _errs1 === errors;
    if (_valid0) {
        valid0 = true;
        passing0 = 0;
    }
    const _errs11 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type === undefined) {
            const err12 = {
                instancePath,
                schemaPath: '#/oneOf/1/required',
                keyword: 'required',
                params: { missingProperty: 'type' },
                message: "must have required property '" + 'type' + "'",
                schema: schema123.oneOf[1].required,
                parentSchema: schema123.oneOf[1],
                data,
            };
            if (vErrors === null) {
                vErrors = [err12];
            }
            else {
                vErrors.push(err12);
            }
            errors++;
        }
        if (data.instruction === undefined) {
            const err13 = {
                instancePath,
                schemaPath: '#/oneOf/1/required',
                keyword: 'required',
                params: { missingProperty: 'instruction' },
                message: "must have required property '" + 'instruction' + "'",
                schema: schema123.oneOf[1].required,
                parentSchema: schema123.oneOf[1],
                data,
            };
            if (vErrors === null) {
                vErrors = [err13];
            }
            else {
                vErrors.push(err13);
            }
            errors++;
        }
        if (data.parts === undefined) {
            const err14 = {
                instancePath,
                schemaPath: '#/oneOf/1/required',
                keyword: 'required',
                params: { missingProperty: 'parts' },
                message: "must have required property '" + 'parts' + "'",
                schema: schema123.oneOf[1].required,
                parentSchema: schema123.oneOf[1],
                data,
            };
            if (vErrors === null) {
                vErrors = [err14];
            }
            else {
                vErrors.push(err14);
            }
            errors++;
        }
        for (const key1 in data) {
            if (!(key1 === 'type' ||
                key1 === 'instruction' ||
                key1 === 'parts' ||
                key1 === 'snapMetres')) {
                const err15 = {
                    instancePath,
                    schemaPath: '#/oneOf/1/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key1 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema123.oneOf[1],
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err15];
                }
                else {
                    vErrors.push(err15);
                }
                errors++;
            }
        }
        if (data.type !== undefined) {
            let data4 = data.type;
            if ('assemble' !== data4) {
                const err16 = {
                    instancePath: instancePath + '/type',
                    schemaPath: '#/oneOf/1/properties/type/const',
                    keyword: 'const',
                    params: { allowedValue: 'assemble' },
                    message: 'must be equal to constant',
                    schema: 'assemble',
                    parentSchema: schema123.oneOf[1].properties.type,
                    data: data4,
                };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.instruction !== undefined) {
            let data5 = data.instruction;
            if (typeof data5 === 'string') {
                if (func3(data5) > 200) {
                    const err17 = {
                        instancePath: instancePath + '/instruction',
                        schemaPath: '#/oneOf/1/properties/instruction/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 200 },
                        message: 'must NOT have more than 200 characters',
                        schema: 200,
                        parentSchema: schema123.oneOf[1].properties.instruction,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
                if (func3(data5) < 1) {
                    const err18 = {
                        instancePath: instancePath + '/instruction',
                        schemaPath: '#/oneOf/1/properties/instruction/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema123.oneOf[1].properties.instruction,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
            }
            else {
                const err19 = {
                    instancePath: instancePath + '/instruction',
                    schemaPath: '#/oneOf/1/properties/instruction/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema123.oneOf[1].properties.instruction.type,
                    parentSchema: schema123.oneOf[1].properties.instruction,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err19];
                }
                else {
                    vErrors.push(err19);
                }
                errors++;
            }
        }
        if (data.parts !== undefined) {
            let data6 = data.parts;
            if (Array.isArray(data6)) {
                if (data6.length > 24) {
                    const err20 = {
                        instancePath: instancePath + '/parts',
                        schemaPath: '#/oneOf/1/properties/parts/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 24 },
                        message: 'must NOT have more than 24 items',
                        schema: 24,
                        parentSchema: schema123.oneOf[1].properties.parts,
                        data: data6,
                    };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
                if (data6.length < 2) {
                    const err21 = {
                        instancePath: instancePath + '/parts',
                        schemaPath: '#/oneOf/1/properties/parts/minItems',
                        keyword: 'minItems',
                        params: { limit: 2 },
                        message: 'must NOT have fewer than 2 items',
                        schema: 2,
                        parentSchema: schema123.oneOf[1].properties.parts,
                        data: data6,
                    };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
                const len1 = data6.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    let data7 = data6[i1];
                    if (typeof data7 === 'string') {
                        if (func3(data7) > 64) {
                            const err22 = {
                                instancePath: instancePath + '/parts/' + i1,
                                schemaPath: '#/definitions/slug/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 64 },
                                message: 'must NOT have more than 64 characters',
                                schema: 64,
                                parentSchema: schema12,
                                data: data7,
                            };
                            if (vErrors === null) {
                                vErrors = [err22];
                            }
                            else {
                                vErrors.push(err22);
                            }
                            errors++;
                        }
                        if (!pattern0.test(data7)) {
                            const err23 = {
                                instancePath: instancePath + '/parts/' + i1,
                                schemaPath: '#/definitions/slug/pattern',
                                keyword: 'pattern',
                                params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                                message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                                schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                                parentSchema: schema12,
                                data: data7,
                            };
                            if (vErrors === null) {
                                vErrors = [err23];
                            }
                            else {
                                vErrors.push(err23);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err24 = {
                            instancePath: instancePath + '/parts/' + i1,
                            schemaPath: '#/definitions/slug/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                            schema: schema12.type,
                            parentSchema: schema12,
                            data: data7,
                        };
                        if (vErrors === null) {
                            vErrors = [err24];
                        }
                        else {
                            vErrors.push(err24);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err25 = {
                    instancePath: instancePath + '/parts',
                    schemaPath: '#/oneOf/1/properties/parts/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema123.oneOf[1].properties.parts.type,
                    parentSchema: schema123.oneOf[1].properties.parts,
                    data: data6,
                };
                if (vErrors === null) {
                    vErrors = [err25];
                }
                else {
                    vErrors.push(err25);
                }
                errors++;
            }
        }
        if (data.snapMetres !== undefined) {
            let data8 = data.snapMetres;
            if (typeof data8 == 'number' && isFinite(data8)) {
                if (data8 > 0.5 || isNaN(data8)) {
                    const err26 = {
                        instancePath: instancePath + '/snapMetres',
                        schemaPath: '#/oneOf/1/properties/snapMetres/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 0.5 },
                        message: 'must be <= 0.5',
                        schema: 0.5,
                        parentSchema: schema123.oneOf[1].properties.snapMetres,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
                if (data8 <= 0 || isNaN(data8)) {
                    const err27 = {
                        instancePath: instancePath + '/snapMetres',
                        schemaPath: '#/oneOf/1/properties/snapMetres/exclusiveMinimum',
                        keyword: 'exclusiveMinimum',
                        params: { comparison: '>', limit: 0 },
                        message: 'must be > 0',
                        schema: 0,
                        parentSchema: schema123.oneOf[1].properties.snapMetres,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err27];
                    }
                    else {
                        vErrors.push(err27);
                    }
                    errors++;
                }
            }
            else {
                const err28 = {
                    instancePath: instancePath + '/snapMetres',
                    schemaPath: '#/oneOf/1/properties/snapMetres/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema123.oneOf[1].properties.snapMetres.type,
                    parentSchema: schema123.oneOf[1].properties.snapMetres,
                    data: data8,
                };
                if (vErrors === null) {
                    vErrors = [err28];
                }
                else {
                    vErrors.push(err28);
                }
                errors++;
            }
        }
    }
    else {
        const err29 = {
            instancePath,
            schemaPath: '#/oneOf/1/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema123.oneOf[1].type,
            parentSchema: schema123.oneOf[1],
            data,
        };
        if (vErrors === null) {
            vErrors = [err29];
        }
        else {
            vErrors.push(err29);
        }
        errors++;
    }
    var _valid0 = _errs11 === errors;
    if (_valid0 && valid0) {
        valid0 = false;
        passing0 = [passing0, 1];
    }
    else {
        if (_valid0) {
            valid0 = true;
            passing0 = 1;
        }
        const _errs24 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.type === undefined) {
                const err30 = {
                    instancePath,
                    schemaPath: '#/oneOf/2/required',
                    keyword: 'required',
                    params: { missingProperty: 'type' },
                    message: "must have required property '" + 'type' + "'",
                    schema: schema123.oneOf[2].required,
                    parentSchema: schema123.oneOf[2],
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err30];
                }
                else {
                    vErrors.push(err30);
                }
                errors++;
            }
            if (data.instruction === undefined) {
                const err31 = {
                    instancePath,
                    schemaPath: '#/oneOf/2/required',
                    keyword: 'required',
                    params: { missingProperty: 'instruction' },
                    message: "must have required property '" + 'instruction' + "'",
                    schema: schema123.oneOf[2].required,
                    parentSchema: schema123.oneOf[2],
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err31];
                }
                else {
                    vErrors.push(err31);
                }
                errors++;
            }
            for (const key2 in data) {
                if (!(key2 === 'type' || key2 === 'instruction')) {
                    const err32 = {
                        instancePath,
                        schemaPath: '#/oneOf/2/additionalProperties',
                        keyword: 'additionalProperties',
                        params: { additionalProperty: key2 },
                        message: 'must NOT have additional properties',
                        schema: false,
                        parentSchema: schema123.oneOf[2],
                        data,
                    };
                    if (vErrors === null) {
                        vErrors = [err32];
                    }
                    else {
                        vErrors.push(err32);
                    }
                    errors++;
                }
            }
            if (data.type !== undefined) {
                let data9 = data.type;
                if ('furnish' !== data9) {
                    const err33 = {
                        instancePath: instancePath + '/type',
                        schemaPath: '#/oneOf/2/properties/type/const',
                        keyword: 'const',
                        params: { allowedValue: 'furnish' },
                        message: 'must be equal to constant',
                        schema: 'furnish',
                        parentSchema: schema123.oneOf[2].properties.type,
                        data: data9,
                    };
                    if (vErrors === null) {
                        vErrors = [err33];
                    }
                    else {
                        vErrors.push(err33);
                    }
                    errors++;
                }
            }
            if (data.instruction !== undefined) {
                let data10 = data.instruction;
                if (typeof data10 === 'string') {
                    if (func3(data10) > 200) {
                        const err34 = {
                            instancePath: instancePath + '/instruction',
                            schemaPath: '#/oneOf/2/properties/instruction/maxLength',
                            keyword: 'maxLength',
                            params: { limit: 200 },
                            message: 'must NOT have more than 200 characters',
                            schema: 200,
                            parentSchema: schema123.oneOf[2].properties.instruction,
                            data: data10,
                        };
                        if (vErrors === null) {
                            vErrors = [err34];
                        }
                        else {
                            vErrors.push(err34);
                        }
                        errors++;
                    }
                    if (func3(data10) < 1) {
                        const err35 = {
                            instancePath: instancePath + '/instruction',
                            schemaPath: '#/oneOf/2/properties/instruction/minLength',
                            keyword: 'minLength',
                            params: { limit: 1 },
                            message: 'must NOT have fewer than 1 characters',
                            schema: 1,
                            parentSchema: schema123.oneOf[2].properties.instruction,
                            data: data10,
                        };
                        if (vErrors === null) {
                            vErrors = [err35];
                        }
                        else {
                            vErrors.push(err35);
                        }
                        errors++;
                    }
                }
                else {
                    const err36 = {
                        instancePath: instancePath + '/instruction',
                        schemaPath: '#/oneOf/2/properties/instruction/type',
                        keyword: 'type',
                        params: { type: 'string' },
                        message: 'must be string',
                        schema: schema123.oneOf[2].properties.instruction.type,
                        parentSchema: schema123.oneOf[2].properties.instruction,
                        data: data10,
                    };
                    if (vErrors === null) {
                        vErrors = [err36];
                    }
                    else {
                        vErrors.push(err36);
                    }
                    errors++;
                }
            }
        }
        else {
            const err37 = {
                instancePath,
                schemaPath: '#/oneOf/2/type',
                keyword: 'type',
                params: { type: 'object' },
                message: 'must be object',
                schema: schema123.oneOf[2].type,
                parentSchema: schema123.oneOf[2],
                data,
            };
            if (vErrors === null) {
                vErrors = [err37];
            }
            else {
                vErrors.push(err37);
            }
            errors++;
        }
        var _valid0 = _errs24 === errors;
        if (_valid0 && valid0) {
            valid0 = false;
            passing0 = [passing0, 2];
        }
        else {
            if (_valid0) {
                valid0 = true;
                passing0 = 2;
            }
        }
    }
    if (!valid0) {
        const err38 = {
            instancePath,
            schemaPath: '#/oneOf',
            keyword: 'oneOf',
            params: { passingSchemas: passing0 },
            message: 'must match exactly one schema in oneOf',
            schema: schema123.oneOf,
            parentSchema: schema123,
            data,
        };
        if (vErrors === null) {
            vErrors = [err38];
        }
        else {
            vErrors.push(err38);
        }
        errors++;
    }
    else {
        errors = _errs0;
        if (vErrors !== null) {
            if (_errs0) {
                vErrors.length = _errs0;
            }
            else {
                vErrors = null;
            }
        }
    }
    validate64.errors = vErrors;
    return errors === 0;
}
const schema127 = {
    description: 'Where a shape ends up; what is left out stays as it was.',
    type: 'object',
    additionalProperties: false,
    required: ['object'],
    properties: {
        object: { $ref: '#/definitions/slug' },
        pos: { $ref: '#/definitions/vec3' },
        rot: { $ref: '#/definitions/shapeRotation' },
        scale: { type: 'number', minimum: 0.1, maximum: 10 },
        seconds: {
            description: 'How long the move takes; default 2.',
            type: 'number',
            minimum: 0.5,
            maximum: 10,
        },
    },
};
function validate66(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.object === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'object' },
                message: "must have required property '" + 'object' + "'",
                schema: schema127.required,
                parentSchema: schema127,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'object' ||
                key0 === 'pos' ||
                key0 === 'rot' ||
                key0 === 'scale' ||
                key0 === 'seconds')) {
                const err1 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema127,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        if (data.object !== undefined) {
            let data0 = data.object;
            if (typeof data0 === 'string') {
                if (func3(data0) > 64) {
                    const err2 = {
                        instancePath: instancePath + '/object',
                        schemaPath: '#/definitions/slug/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 characters',
                        schema: 64,
                        parentSchema: schema12,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
                if (!pattern0.test(data0)) {
                    const err3 = {
                        instancePath: instancePath + '/object',
                        schemaPath: '#/definitions/slug/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                        message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                        schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                        parentSchema: schema12,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
            }
            else {
                const err4 = {
                    instancePath: instancePath + '/object',
                    schemaPath: '#/definitions/slug/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema12.type,
                    parentSchema: schema12,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.pos !== undefined) {
            let data1 = data.pos;
            if (Array.isArray(data1)) {
                if (data1.length > 3) {
                    const err5 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/vec3/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema18,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (data1.length < 3) {
                    const err6 = {
                        instancePath: instancePath + '/pos',
                        schemaPath: '#/definitions/vec3/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema18,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (!(typeof data2 == 'number' && isFinite(data2))) {
                        const err7 = {
                            instancePath: instancePath + '/pos/' + i0,
                            schemaPath: '#/definitions/vec3/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema18.items.type,
                            parentSchema: schema18.items,
                            data: data2,
                        };
                        if (vErrors === null) {
                            vErrors = [err7];
                        }
                        else {
                            vErrors.push(err7);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err8 = {
                    instancePath: instancePath + '/pos',
                    schemaPath: '#/definitions/vec3/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema18.type,
                    parentSchema: schema18,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
        }
        if (data.rot !== undefined) {
            let data3 = data.rot;
            if (Array.isArray(data3)) {
                if (data3.length > 3) {
                    const err9 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 3 },
                        message: 'must NOT have more than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err9];
                    }
                    else {
                        vErrors.push(err9);
                    }
                    errors++;
                }
                if (data3.length < 3) {
                    const err10 = {
                        instancePath: instancePath + '/rot',
                        schemaPath: '#/definitions/shapeRotation/minItems',
                        keyword: 'minItems',
                        params: { limit: 3 },
                        message: 'must NOT have fewer than 3 items',
                        schema: 3,
                        parentSchema: schema24,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err10];
                    }
                    else {
                        vErrors.push(err10);
                    }
                    errors++;
                }
                const len1 = data3.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    let data4 = data3[i1];
                    if (typeof data4 == 'number' && isFinite(data4)) {
                        if (data4 > 360 || isNaN(data4)) {
                            const err11 = {
                                instancePath: instancePath + '/rot/' + i1,
                                schemaPath: '#/definitions/shapeRotation/items/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 360 },
                                message: 'must be <= 360',
                                schema: 360,
                                parentSchema: schema24.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err11];
                            }
                            else {
                                vErrors.push(err11);
                            }
                            errors++;
                        }
                        if (data4 < -360 || isNaN(data4)) {
                            const err12 = {
                                instancePath: instancePath + '/rot/' + i1,
                                schemaPath: '#/definitions/shapeRotation/items/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: -360 },
                                message: 'must be >= -360',
                                schema: -360,
                                parentSchema: schema24.items,
                                data: data4,
                            };
                            if (vErrors === null) {
                                vErrors = [err12];
                            }
                            else {
                                vErrors.push(err12);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err13 = {
                            instancePath: instancePath + '/rot/' + i1,
                            schemaPath: '#/definitions/shapeRotation/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema24.items.type,
                            parentSchema: schema24.items,
                            data: data4,
                        };
                        if (vErrors === null) {
                            vErrors = [err13];
                        }
                        else {
                            vErrors.push(err13);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err14 = {
                    instancePath: instancePath + '/rot',
                    schemaPath: '#/definitions/shapeRotation/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema24.type,
                    parentSchema: schema24,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err14];
                }
                else {
                    vErrors.push(err14);
                }
                errors++;
            }
        }
        if (data.scale !== undefined) {
            let data5 = data.scale;
            if (typeof data5 == 'number' && isFinite(data5)) {
                if (data5 > 10 || isNaN(data5)) {
                    const err15 = {
                        instancePath: instancePath + '/scale',
                        schemaPath: '#/properties/scale/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 10 },
                        message: 'must be <= 10',
                        schema: 10,
                        parentSchema: schema127.properties.scale,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
                if (data5 < 0.1 || isNaN(data5)) {
                    const err16 = {
                        instancePath: instancePath + '/scale',
                        schemaPath: '#/properties/scale/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.1 },
                        message: 'must be >= 0.1',
                        schema: 0.1,
                        parentSchema: schema127.properties.scale,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
            }
            else {
                const err17 = {
                    instancePath: instancePath + '/scale',
                    schemaPath: '#/properties/scale/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema127.properties.scale.type,
                    parentSchema: schema127.properties.scale,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err17];
                }
                else {
                    vErrors.push(err17);
                }
                errors++;
            }
        }
        if (data.seconds !== undefined) {
            let data6 = data.seconds;
            if (typeof data6 == 'number' && isFinite(data6)) {
                if (data6 > 10 || isNaN(data6)) {
                    const err18 = {
                        instancePath: instancePath + '/seconds',
                        schemaPath: '#/properties/seconds/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 10 },
                        message: 'must be <= 10',
                        schema: 10,
                        parentSchema: schema127.properties.seconds,
                        data: data6,
                    };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                if (data6 < 0.5 || isNaN(data6)) {
                    const err19 = {
                        instancePath: instancePath + '/seconds',
                        schemaPath: '#/properties/seconds/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 0.5 },
                        message: 'must be >= 0.5',
                        schema: 0.5,
                        parentSchema: schema127.properties.seconds,
                        data: data6,
                    };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
            }
            else {
                const err20 = {
                    instancePath: instancePath + '/seconds',
                    schemaPath: '#/properties/seconds/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema127.properties.seconds.type,
                    parentSchema: schema127.properties.seconds,
                    data: data6,
                };
                if (vErrors === null) {
                    vErrors = [err20];
                }
                else {
                    vErrors.push(err20);
                }
                errors++;
            }
        }
    }
    else {
        const err21 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema127.type,
            parentSchema: schema127,
            data,
        };
        if (vErrors === null) {
            vErrors = [err21];
        }
        else {
            vErrors.push(err21);
        }
        errors++;
    }
    validate66.errors = vErrors;
    return errors === 0;
}
const schema132 = {
    description: "A 360° photo from this step on, in a pano360 lesson: the scene's fields without type.",
    type: 'object',
    additionalProperties: false,
    properties: {
        media: {
            description: 'The photo, equirectangular 2:1. Filled in by the platform, never written by a model.',
            $ref: '#/definitions/mediaId',
        },
        want: {
            description: 'Which place and view the photo should show, in Dutch. The platform finds the photo.',
            type: 'string',
            minLength: 1,
            maxLength: 200,
        },
        search: {
            description: '1-6 English words to search for the photo with.',
            type: 'string',
            minLength: 1,
            maxLength: 80,
        },
        brief: {
            description: "The school's own photo n from the brief, 1-4, instead of want and search.",
            type: 'integer',
            minimum: 1,
            maximum: 4,
        },
        credit: {
            description: 'Who made the photo and under which licence. Filled in by the platform.',
            type: 'string',
            minLength: 1,
            maxLength: 140,
        },
        yaw: {
            description: "The photo's azimuth, degrees, that faces the pupil at the start. Filled in by the platform; default 0.",
            type: 'number',
            minimum: -180,
            maximum: 180,
        },
    },
};
function validate68(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        for (const key0 in data) {
            if (!(key0 === 'media' ||
                key0 === 'want' ||
                key0 === 'search' ||
                key0 === 'brief' ||
                key0 === 'credit' ||
                key0 === 'yaw')) {
                const err0 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema132,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
        if (data.media !== undefined) {
            let data0 = data.media;
            if (typeof data0 === 'string') {
                if (!pattern1.test(data0)) {
                    const err1 = {
                        instancePath: instancePath + '/media',
                        schemaPath: '#/definitions/mediaId/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^m_[A-Za-z0-9_-]{1,64}$' },
                        message: 'must match pattern "' + '^m_[A-Za-z0-9_-]{1,64}$' + '"',
                        schema: '^m_[A-Za-z0-9_-]{1,64}$',
                        parentSchema: schema14,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
            else {
                const err2 = {
                    instancePath: instancePath + '/media',
                    schemaPath: '#/definitions/mediaId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema14.type,
                    parentSchema: schema14,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.want !== undefined) {
            let data1 = data.want;
            if (typeof data1 === 'string') {
                if (func3(data1) > 200) {
                    const err3 = {
                        instancePath: instancePath + '/want',
                        schemaPath: '#/properties/want/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 200 },
                        message: 'must NOT have more than 200 characters',
                        schema: 200,
                        parentSchema: schema132.properties.want,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
                if (func3(data1) < 1) {
                    const err4 = {
                        instancePath: instancePath + '/want',
                        schemaPath: '#/properties/want/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema132.properties.want,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            else {
                const err5 = {
                    instancePath: instancePath + '/want',
                    schemaPath: '#/properties/want/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema132.properties.want.type,
                    parentSchema: schema132.properties.want,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
        }
        if (data.search !== undefined) {
            let data2 = data.search;
            if (typeof data2 === 'string') {
                if (func3(data2) > 80) {
                    const err6 = {
                        instancePath: instancePath + '/search',
                        schemaPath: '#/properties/search/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 80 },
                        message: 'must NOT have more than 80 characters',
                        schema: 80,
                        parentSchema: schema132.properties.search,
                        data: data2,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                if (func3(data2) < 1) {
                    const err7 = {
                        instancePath: instancePath + '/search',
                        schemaPath: '#/properties/search/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema132.properties.search,
                        data: data2,
                    };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                }
            }
            else {
                const err8 = {
                    instancePath: instancePath + '/search',
                    schemaPath: '#/properties/search/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema132.properties.search.type,
                    parentSchema: schema132.properties.search,
                    data: data2,
                };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
        }
        if (data.brief !== undefined) {
            let data3 = data.brief;
            if (!(typeof data3 == 'number' && !(data3 % 1) && !isNaN(data3) && isFinite(data3))) {
                const err9 = {
                    instancePath: instancePath + '/brief',
                    schemaPath: '#/properties/brief/type',
                    keyword: 'type',
                    params: { type: 'integer' },
                    message: 'must be integer',
                    schema: schema132.properties.brief.type,
                    parentSchema: schema132.properties.brief,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
            if (typeof data3 == 'number' && isFinite(data3)) {
                if (data3 > 4 || isNaN(data3)) {
                    const err10 = {
                        instancePath: instancePath + '/brief',
                        schemaPath: '#/properties/brief/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 4 },
                        message: 'must be <= 4',
                        schema: 4,
                        parentSchema: schema132.properties.brief,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err10];
                    }
                    else {
                        vErrors.push(err10);
                    }
                    errors++;
                }
                if (data3 < 1 || isNaN(data3)) {
                    const err11 = {
                        instancePath: instancePath + '/brief',
                        schemaPath: '#/properties/brief/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: 1 },
                        message: 'must be >= 1',
                        schema: 1,
                        parentSchema: schema132.properties.brief,
                        data: data3,
                    };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
            }
        }
        if (data.credit !== undefined) {
            let data4 = data.credit;
            if (typeof data4 === 'string') {
                if (func3(data4) > 140) {
                    const err12 = {
                        instancePath: instancePath + '/credit',
                        schemaPath: '#/properties/credit/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 140 },
                        message: 'must NOT have more than 140 characters',
                        schema: 140,
                        parentSchema: schema132.properties.credit,
                        data: data4,
                    };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
                if (func3(data4) < 1) {
                    const err13 = {
                        instancePath: instancePath + '/credit',
                        schemaPath: '#/properties/credit/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema132.properties.credit,
                        data: data4,
                    };
                    if (vErrors === null) {
                        vErrors = [err13];
                    }
                    else {
                        vErrors.push(err13);
                    }
                    errors++;
                }
            }
            else {
                const err14 = {
                    instancePath: instancePath + '/credit',
                    schemaPath: '#/properties/credit/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema132.properties.credit.type,
                    parentSchema: schema132.properties.credit,
                    data: data4,
                };
                if (vErrors === null) {
                    vErrors = [err14];
                }
                else {
                    vErrors.push(err14);
                }
                errors++;
            }
        }
        if (data.yaw !== undefined) {
            let data5 = data.yaw;
            if (typeof data5 == 'number' && isFinite(data5)) {
                if (data5 > 180 || isNaN(data5)) {
                    const err15 = {
                        instancePath: instancePath + '/yaw',
                        schemaPath: '#/properties/yaw/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 180 },
                        message: 'must be <= 180',
                        schema: 180,
                        parentSchema: schema132.properties.yaw,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
                if (data5 < -180 || isNaN(data5)) {
                    const err16 = {
                        instancePath: instancePath + '/yaw',
                        schemaPath: '#/properties/yaw/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: -180 },
                        message: 'must be >= -180',
                        schema: -180,
                        parentSchema: schema132.properties.yaw,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
            }
            else {
                const err17 = {
                    instancePath: instancePath + '/yaw',
                    schemaPath: '#/properties/yaw/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema132.properties.yaw.type,
                    parentSchema: schema132.properties.yaw,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err17];
                }
                else {
                    vErrors.push(err17);
                }
                errors++;
            }
        }
    }
    else {
        const err18 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema132.type,
            parentSchema: schema132,
            data,
        };
        if (vErrors === null) {
            vErrors = [err18];
        }
        else {
            vErrors.push(err18);
        }
        errors++;
    }
    validate68.errors = vErrors;
    return errors === 0;
}
const schema134 = {
    description: 'What one model does when the step starts: walkTo, then face, then play.',
    type: 'object',
    additionalProperties: false,
    required: ['object'],
    properties: {
        object: { $ref: '#/definitions/slug' },
        walkTo: {
            description: 'Where it walks to, [x, z] on the ground; "pupil" only in a spannend part.',
            oneOf: [
                { type: 'array', minItems: 2, maxItems: 2, items: { type: 'number' } },
                { const: 'pupil' },
            ],
        },
        gait: {
            description: 'How it walks; default lopen.',
            enum: ['lopen', 'rennen', 'zwemmen', 'vliegen', 'rijden'],
        },
        face: { description: 'Turns to look at the pupil.', const: 'pupil' },
        turn: {
            description: "Turns where it stands to this heading, degrees as an object's turn (0 faces -z, positive turns left), eased, before it plays: the pupil sees another side. Not with walkTo, face or circle; never in a spannend part.",
            type: 'number',
            minimum: -360,
            maximum: 360,
        },
        play: {
            description: 'The animation it plays, one the model has.',
            enum: [
                'staan',
                'lopen',
                'rennen',
                'brullen',
                'bijten',
                'eten',
                'kijken',
                'liggen',
                'zwemmen',
                'vliegen',
                'springen',
                'aanvallen',
                'slapen',
                'rijden',
                'werken',
            ],
        },
        loop: { description: 'Whether play repeats; default as the library says.', type: 'boolean' },
        then: {
            description: 'What it does once the rest of this entry is done: after a walk with no play, or after a once-only play; default staan.',
            enum: [
                'staan',
                'lopen',
                'rennen',
                'brullen',
                'bijten',
                'eten',
                'kijken',
                'liggen',
                'zwemmen',
                'vliegen',
                'springen',
                'aanvallen',
                'slapen',
                'rijden',
                'werken',
            ],
        },
        circle: {
            description: "Goes round on a circle while it plays a travelling loop (play), always facing along it. The radius is where the step finds the model; the speed is play's. Not with walkTo, face, gait or loop; never in a spannend part. VR.",
            type: 'object',
            additionalProperties: false,
            required: ['direction', 'rounds'],
            properties: {
                around: {
                    description: 'The centre: [x, z] on the ground (default [0, 0], the stage centre), or an object that stays put.',
                    oneOf: [
                        { type: 'array', minItems: 2, maxItems: 2, items: { type: 'number' } },
                        { $ref: '#/definitions/slug' },
                    ],
                },
                direction: {
                    description: 'links: counter-clockwise seen from above; rechts: clockwise.',
                    enum: ['links', 'rechts'],
                },
                rounds: {
                    description: 'How many rounds, 0.25 to 4 in quarters, or "loop": on until a later step names the model.',
                    oneOf: [
                        { type: 'number', minimum: 0.25, maximum: 4, multipleOf: 0.25 },
                        { const: 'loop' },
                    ],
                },
            },
        },
    },
};
function validate70(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.object === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'object' },
                message: "must have required property '" + 'object' + "'",
                schema: schema134.required,
                parentSchema: schema134,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!func2.call(schema134.properties, key0)) {
                const err1 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema134,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        if (data.object !== undefined) {
            let data0 = data.object;
            if (typeof data0 === 'string') {
                if (func3(data0) > 64) {
                    const err2 = {
                        instancePath: instancePath + '/object',
                        schemaPath: '#/definitions/slug/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 characters',
                        schema: 64,
                        parentSchema: schema12,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
                if (!pattern0.test(data0)) {
                    const err3 = {
                        instancePath: instancePath + '/object',
                        schemaPath: '#/definitions/slug/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                        message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                        schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                        parentSchema: schema12,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
            }
            else {
                const err4 = {
                    instancePath: instancePath + '/object',
                    schemaPath: '#/definitions/slug/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema12.type,
                    parentSchema: schema12,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.walkTo !== undefined) {
            let data1 = data.walkTo;
            const _errs6 = errors;
            let valid2 = false;
            let passing0 = null;
            const _errs7 = errors;
            if (Array.isArray(data1)) {
                if (data1.length > 2) {
                    const err5 = {
                        instancePath: instancePath + '/walkTo',
                        schemaPath: '#/properties/walkTo/oneOf/0/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 2 },
                        message: 'must NOT have more than 2 items',
                        schema: 2,
                        parentSchema: schema134.properties.walkTo.oneOf[0],
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (data1.length < 2) {
                    const err6 = {
                        instancePath: instancePath + '/walkTo',
                        schemaPath: '#/properties/walkTo/oneOf/0/minItems',
                        keyword: 'minItems',
                        params: { limit: 2 },
                        message: 'must NOT have fewer than 2 items',
                        schema: 2,
                        parentSchema: schema134.properties.walkTo.oneOf[0],
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
                const len0 = data1.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data2 = data1[i0];
                    if (!(typeof data2 == 'number' && isFinite(data2))) {
                        const err7 = {
                            instancePath: instancePath + '/walkTo/' + i0,
                            schemaPath: '#/properties/walkTo/oneOf/0/items/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema134.properties.walkTo.oneOf[0].items.type,
                            parentSchema: schema134.properties.walkTo.oneOf[0].items,
                            data: data2,
                        };
                        if (vErrors === null) {
                            vErrors = [err7];
                        }
                        else {
                            vErrors.push(err7);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err8 = {
                    instancePath: instancePath + '/walkTo',
                    schemaPath: '#/properties/walkTo/oneOf/0/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema134.properties.walkTo.oneOf[0].type,
                    parentSchema: schema134.properties.walkTo.oneOf[0],
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            var _valid0 = _errs7 === errors;
            if (_valid0) {
                valid2 = true;
                passing0 = 0;
            }
            const _errs11 = errors;
            if ('pupil' !== data1) {
                const err9 = {
                    instancePath: instancePath + '/walkTo',
                    schemaPath: '#/properties/walkTo/oneOf/1/const',
                    keyword: 'const',
                    params: { allowedValue: 'pupil' },
                    message: 'must be equal to constant',
                    schema: 'pupil',
                    parentSchema: schema134.properties.walkTo.oneOf[1],
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
            var _valid0 = _errs11 === errors;
            if (_valid0 && valid2) {
                valid2 = false;
                passing0 = [passing0, 1];
            }
            else {
                if (_valid0) {
                    valid2 = true;
                    passing0 = 1;
                }
            }
            if (!valid2) {
                const err10 = {
                    instancePath: instancePath + '/walkTo',
                    schemaPath: '#/properties/walkTo/oneOf',
                    keyword: 'oneOf',
                    params: { passingSchemas: passing0 },
                    message: 'must match exactly one schema in oneOf',
                    schema: schema134.properties.walkTo.oneOf,
                    parentSchema: schema134.properties.walkTo,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
            else {
                errors = _errs6;
                if (vErrors !== null) {
                    if (_errs6) {
                        vErrors.length = _errs6;
                    }
                    else {
                        vErrors = null;
                    }
                }
            }
        }
        if (data.gait !== undefined) {
            let data3 = data.gait;
            if (!(data3 === 'lopen' ||
                data3 === 'rennen' ||
                data3 === 'zwemmen' ||
                data3 === 'vliegen' ||
                data3 === 'rijden')) {
                const err11 = {
                    instancePath: instancePath + '/gait',
                    schemaPath: '#/properties/gait/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema134.properties.gait.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema134.properties.gait.enum,
                    parentSchema: schema134.properties.gait,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
        }
        if (data.face !== undefined) {
            let data4 = data.face;
            if ('pupil' !== data4) {
                const err12 = {
                    instancePath: instancePath + '/face',
                    schemaPath: '#/properties/face/const',
                    keyword: 'const',
                    params: { allowedValue: 'pupil' },
                    message: 'must be equal to constant',
                    schema: 'pupil',
                    parentSchema: schema134.properties.face,
                    data: data4,
                };
                if (vErrors === null) {
                    vErrors = [err12];
                }
                else {
                    vErrors.push(err12);
                }
                errors++;
            }
        }
        if (data.turn !== undefined) {
            let data5 = data.turn;
            if (typeof data5 == 'number' && isFinite(data5)) {
                if (data5 > 360 || isNaN(data5)) {
                    const err13 = {
                        instancePath: instancePath + '/turn',
                        schemaPath: '#/properties/turn/maximum',
                        keyword: 'maximum',
                        params: { comparison: '<=', limit: 360 },
                        message: 'must be <= 360',
                        schema: 360,
                        parentSchema: schema134.properties.turn,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err13];
                    }
                    else {
                        vErrors.push(err13);
                    }
                    errors++;
                }
                if (data5 < -360 || isNaN(data5)) {
                    const err14 = {
                        instancePath: instancePath + '/turn',
                        schemaPath: '#/properties/turn/minimum',
                        keyword: 'minimum',
                        params: { comparison: '>=', limit: -360 },
                        message: 'must be >= -360',
                        schema: -360,
                        parentSchema: schema134.properties.turn,
                        data: data5,
                    };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
            }
            else {
                const err15 = {
                    instancePath: instancePath + '/turn',
                    schemaPath: '#/properties/turn/type',
                    keyword: 'type',
                    params: { type: 'number' },
                    message: 'must be number',
                    schema: schema134.properties.turn.type,
                    parentSchema: schema134.properties.turn,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err15];
                }
                else {
                    vErrors.push(err15);
                }
                errors++;
            }
        }
        if (data.play !== undefined) {
            let data6 = data.play;
            if (!(data6 === 'staan' ||
                data6 === 'lopen' ||
                data6 === 'rennen' ||
                data6 === 'brullen' ||
                data6 === 'bijten' ||
                data6 === 'eten' ||
                data6 === 'kijken' ||
                data6 === 'liggen' ||
                data6 === 'zwemmen' ||
                data6 === 'vliegen' ||
                data6 === 'springen' ||
                data6 === 'aanvallen' ||
                data6 === 'slapen' ||
                data6 === 'rijden' ||
                data6 === 'werken')) {
                const err16 = {
                    instancePath: instancePath + '/play',
                    schemaPath: '#/properties/play/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema134.properties.play.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema134.properties.play.enum,
                    parentSchema: schema134.properties.play,
                    data: data6,
                };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.loop !== undefined) {
            let data7 = data.loop;
            if (typeof data7 !== 'boolean') {
                const err17 = {
                    instancePath: instancePath + '/loop',
                    schemaPath: '#/properties/loop/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema134.properties.loop.type,
                    parentSchema: schema134.properties.loop,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err17];
                }
                else {
                    vErrors.push(err17);
                }
                errors++;
            }
        }
        if (data.then !== undefined) {
            let data8 = data.then;
            if (!(data8 === 'staan' ||
                data8 === 'lopen' ||
                data8 === 'rennen' ||
                data8 === 'brullen' ||
                data8 === 'bijten' ||
                data8 === 'eten' ||
                data8 === 'kijken' ||
                data8 === 'liggen' ||
                data8 === 'zwemmen' ||
                data8 === 'vliegen' ||
                data8 === 'springen' ||
                data8 === 'aanvallen' ||
                data8 === 'slapen' ||
                data8 === 'rijden' ||
                data8 === 'werken')) {
                const err18 = {
                    instancePath: instancePath + '/then',
                    schemaPath: '#/properties/then/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema134.properties.then.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema134.properties.then.enum,
                    parentSchema: schema134.properties.then,
                    data: data8,
                };
                if (vErrors === null) {
                    vErrors = [err18];
                }
                else {
                    vErrors.push(err18);
                }
                errors++;
            }
        }
        if (data.circle !== undefined) {
            let data9 = data.circle;
            if (data9 && typeof data9 == 'object' && !Array.isArray(data9)) {
                if (data9.direction === undefined) {
                    const err19 = {
                        instancePath: instancePath + '/circle',
                        schemaPath: '#/properties/circle/required',
                        keyword: 'required',
                        params: { missingProperty: 'direction' },
                        message: "must have required property '" + 'direction' + "'",
                        schema: schema134.properties.circle.required,
                        parentSchema: schema134.properties.circle,
                        data: data9,
                    };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
                if (data9.rounds === undefined) {
                    const err20 = {
                        instancePath: instancePath + '/circle',
                        schemaPath: '#/properties/circle/required',
                        keyword: 'required',
                        params: { missingProperty: 'rounds' },
                        message: "must have required property '" + 'rounds' + "'",
                        schema: schema134.properties.circle.required,
                        parentSchema: schema134.properties.circle,
                        data: data9,
                    };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
                for (const key1 in data9) {
                    if (!(key1 === 'around' || key1 === 'direction' || key1 === 'rounds')) {
                        const err21 = {
                            instancePath: instancePath + '/circle',
                            schemaPath: '#/properties/circle/additionalProperties',
                            keyword: 'additionalProperties',
                            params: { additionalProperty: key1 },
                            message: 'must NOT have additional properties',
                            schema: false,
                            parentSchema: schema134.properties.circle,
                            data: data9,
                        };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                }
                if (data9.around !== undefined) {
                    let data10 = data9.around;
                    const _errs24 = errors;
                    let valid6 = false;
                    let passing1 = null;
                    const _errs25 = errors;
                    if (Array.isArray(data10)) {
                        if (data10.length > 2) {
                            const err22 = {
                                instancePath: instancePath + '/circle/around',
                                schemaPath: '#/properties/circle/properties/around/oneOf/0/maxItems',
                                keyword: 'maxItems',
                                params: { limit: 2 },
                                message: 'must NOT have more than 2 items',
                                schema: 2,
                                parentSchema: schema134.properties.circle.properties.around.oneOf[0],
                                data: data10,
                            };
                            if (vErrors === null) {
                                vErrors = [err22];
                            }
                            else {
                                vErrors.push(err22);
                            }
                            errors++;
                        }
                        if (data10.length < 2) {
                            const err23 = {
                                instancePath: instancePath + '/circle/around',
                                schemaPath: '#/properties/circle/properties/around/oneOf/0/minItems',
                                keyword: 'minItems',
                                params: { limit: 2 },
                                message: 'must NOT have fewer than 2 items',
                                schema: 2,
                                parentSchema: schema134.properties.circle.properties.around.oneOf[0],
                                data: data10,
                            };
                            if (vErrors === null) {
                                vErrors = [err23];
                            }
                            else {
                                vErrors.push(err23);
                            }
                            errors++;
                        }
                        const len1 = data10.length;
                        for (let i1 = 0; i1 < len1; i1++) {
                            let data11 = data10[i1];
                            if (!(typeof data11 == 'number' && isFinite(data11))) {
                                const err24 = {
                                    instancePath: instancePath + '/circle/around/' + i1,
                                    schemaPath: '#/properties/circle/properties/around/oneOf/0/items/type',
                                    keyword: 'type',
                                    params: { type: 'number' },
                                    message: 'must be number',
                                    schema: schema134.properties.circle.properties.around.oneOf[0].items.type,
                                    parentSchema: schema134.properties.circle.properties.around.oneOf[0].items,
                                    data: data11,
                                };
                                if (vErrors === null) {
                                    vErrors = [err24];
                                }
                                else {
                                    vErrors.push(err24);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        const err25 = {
                            instancePath: instancePath + '/circle/around',
                            schemaPath: '#/properties/circle/properties/around/oneOf/0/type',
                            keyword: 'type',
                            params: { type: 'array' },
                            message: 'must be array',
                            schema: schema134.properties.circle.properties.around.oneOf[0].type,
                            parentSchema: schema134.properties.circle.properties.around.oneOf[0],
                            data: data10,
                        };
                        if (vErrors === null) {
                            vErrors = [err25];
                        }
                        else {
                            vErrors.push(err25);
                        }
                        errors++;
                    }
                    var _valid1 = _errs25 === errors;
                    if (_valid1) {
                        valid6 = true;
                        passing1 = 0;
                    }
                    const _errs29 = errors;
                    if (typeof data10 === 'string') {
                        if (func3(data10) > 64) {
                            const err26 = {
                                instancePath: instancePath + '/circle/around',
                                schemaPath: '#/definitions/slug/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 64 },
                                message: 'must NOT have more than 64 characters',
                                schema: 64,
                                parentSchema: schema12,
                                data: data10,
                            };
                            if (vErrors === null) {
                                vErrors = [err26];
                            }
                            else {
                                vErrors.push(err26);
                            }
                            errors++;
                        }
                        if (!pattern0.test(data10)) {
                            const err27 = {
                                instancePath: instancePath + '/circle/around',
                                schemaPath: '#/definitions/slug/pattern',
                                keyword: 'pattern',
                                params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                                message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                                schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                                parentSchema: schema12,
                                data: data10,
                            };
                            if (vErrors === null) {
                                vErrors = [err27];
                            }
                            else {
                                vErrors.push(err27);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err28 = {
                            instancePath: instancePath + '/circle/around',
                            schemaPath: '#/definitions/slug/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                            schema: schema12.type,
                            parentSchema: schema12,
                            data: data10,
                        };
                        if (vErrors === null) {
                            vErrors = [err28];
                        }
                        else {
                            vErrors.push(err28);
                        }
                        errors++;
                    }
                    var _valid1 = _errs29 === errors;
                    if (_valid1 && valid6) {
                        valid6 = false;
                        passing1 = [passing1, 1];
                    }
                    else {
                        if (_valid1) {
                            valid6 = true;
                            passing1 = 1;
                        }
                    }
                    if (!valid6) {
                        const err29 = {
                            instancePath: instancePath + '/circle/around',
                            schemaPath: '#/properties/circle/properties/around/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing1 },
                            message: 'must match exactly one schema in oneOf',
                            schema: schema134.properties.circle.properties.around.oneOf,
                            parentSchema: schema134.properties.circle.properties.around,
                            data: data10,
                        };
                        if (vErrors === null) {
                            vErrors = [err29];
                        }
                        else {
                            vErrors.push(err29);
                        }
                        errors++;
                    }
                    else {
                        errors = _errs24;
                        if (vErrors !== null) {
                            if (_errs24) {
                                vErrors.length = _errs24;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                }
                if (data9.direction !== undefined) {
                    let data12 = data9.direction;
                    if (!(data12 === 'links' || data12 === 'rechts')) {
                        const err30 = {
                            instancePath: instancePath + '/circle/direction',
                            schemaPath: '#/properties/circle/properties/direction/enum',
                            keyword: 'enum',
                            params: { allowedValues: schema134.properties.circle.properties.direction.enum },
                            message: 'must be equal to one of the allowed values',
                            schema: schema134.properties.circle.properties.direction.enum,
                            parentSchema: schema134.properties.circle.properties.direction,
                            data: data12,
                        };
                        if (vErrors === null) {
                            vErrors = [err30];
                        }
                        else {
                            vErrors.push(err30);
                        }
                        errors++;
                    }
                }
                if (data9.rounds !== undefined) {
                    let data13 = data9.rounds;
                    const _errs34 = errors;
                    let valid10 = false;
                    let passing2 = null;
                    const _errs35 = errors;
                    if (typeof data13 == 'number' && isFinite(data13)) {
                        if (data13 > 4 || isNaN(data13)) {
                            const err31 = {
                                instancePath: instancePath + '/circle/rounds',
                                schemaPath: '#/properties/circle/properties/rounds/oneOf/0/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 4 },
                                message: 'must be <= 4',
                                schema: 4,
                                parentSchema: schema134.properties.circle.properties.rounds.oneOf[0],
                                data: data13,
                            };
                            if (vErrors === null) {
                                vErrors = [err31];
                            }
                            else {
                                vErrors.push(err31);
                            }
                            errors++;
                        }
                        if (data13 < 0.25 || isNaN(data13)) {
                            const err32 = {
                                instancePath: instancePath + '/circle/rounds',
                                schemaPath: '#/properties/circle/properties/rounds/oneOf/0/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: 0.25 },
                                message: 'must be >= 0.25',
                                schema: 0.25,
                                parentSchema: schema134.properties.circle.properties.rounds.oneOf[0],
                                data: data13,
                            };
                            if (vErrors === null) {
                                vErrors = [err32];
                            }
                            else {
                                vErrors.push(err32);
                            }
                            errors++;
                        }
                        let res0;
                        if (0.25 === 0 || ((res0 = data13 / 0.25), res0 !== parseInt(res0))) {
                            const err33 = {
                                instancePath: instancePath + '/circle/rounds',
                                schemaPath: '#/properties/circle/properties/rounds/oneOf/0/multipleOf',
                                keyword: 'multipleOf',
                                params: { multipleOf: 0.25 },
                                message: 'must be multiple of 0.25',
                                schema: 0.25,
                                parentSchema: schema134.properties.circle.properties.rounds.oneOf[0],
                                data: data13,
                            };
                            if (vErrors === null) {
                                vErrors = [err33];
                            }
                            else {
                                vErrors.push(err33);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err34 = {
                            instancePath: instancePath + '/circle/rounds',
                            schemaPath: '#/properties/circle/properties/rounds/oneOf/0/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number',
                            schema: schema134.properties.circle.properties.rounds.oneOf[0].type,
                            parentSchema: schema134.properties.circle.properties.rounds.oneOf[0],
                            data: data13,
                        };
                        if (vErrors === null) {
                            vErrors = [err34];
                        }
                        else {
                            vErrors.push(err34);
                        }
                        errors++;
                    }
                    var _valid2 = _errs35 === errors;
                    if (_valid2) {
                        valid10 = true;
                        passing2 = 0;
                    }
                    const _errs37 = errors;
                    if ('loop' !== data13) {
                        const err35 = {
                            instancePath: instancePath + '/circle/rounds',
                            schemaPath: '#/properties/circle/properties/rounds/oneOf/1/const',
                            keyword: 'const',
                            params: { allowedValue: 'loop' },
                            message: 'must be equal to constant',
                            schema: 'loop',
                            parentSchema: schema134.properties.circle.properties.rounds.oneOf[1],
                            data: data13,
                        };
                        if (vErrors === null) {
                            vErrors = [err35];
                        }
                        else {
                            vErrors.push(err35);
                        }
                        errors++;
                    }
                    var _valid2 = _errs37 === errors;
                    if (_valid2 && valid10) {
                        valid10 = false;
                        passing2 = [passing2, 1];
                    }
                    else {
                        if (_valid2) {
                            valid10 = true;
                            passing2 = 1;
                        }
                    }
                    if (!valid10) {
                        const err36 = {
                            instancePath: instancePath + '/circle/rounds',
                            schemaPath: '#/properties/circle/properties/rounds/oneOf',
                            keyword: 'oneOf',
                            params: { passingSchemas: passing2 },
                            message: 'must match exactly one schema in oneOf',
                            schema: schema134.properties.circle.properties.rounds.oneOf,
                            parentSchema: schema134.properties.circle.properties.rounds,
                            data: data13,
                        };
                        if (vErrors === null) {
                            vErrors = [err36];
                        }
                        else {
                            vErrors.push(err36);
                        }
                        errors++;
                    }
                    else {
                        errors = _errs34;
                        if (vErrors !== null) {
                            if (_errs34) {
                                vErrors.length = _errs34;
                            }
                            else {
                                vErrors = null;
                            }
                        }
                    }
                }
            }
            else {
                const err37 = {
                    instancePath: instancePath + '/circle',
                    schemaPath: '#/properties/circle/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                    schema: schema134.properties.circle.type,
                    parentSchema: schema134.properties.circle,
                    data: data9,
                };
                if (vErrors === null) {
                    vErrors = [err37];
                }
                else {
                    vErrors.push(err37);
                }
                errors++;
            }
        }
    }
    else {
        const err38 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema134.type,
            parentSchema: schema134,
            data,
        };
        if (vErrors === null) {
            vErrors = [err38];
        }
        else {
            vErrors.push(err38);
        }
        errors++;
    }
    validate70.errors = vErrors;
    return errors === 0;
}
const schema137 = {
    description: "The models of a step's exciting version.",
    type: 'object',
    additionalProperties: false,
    required: ['models'],
    properties: {
        models: { type: 'array', minItems: 1, maxItems: 5, items: { $ref: '#/definitions/stepModel' } },
    },
};
function validate72(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.models === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'models' },
                message: "must have required property '" + 'models' + "'",
                schema: schema137.required,
                parentSchema: schema137,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!(key0 === 'models')) {
                const err1 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema137,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        if (data.models !== undefined) {
            let data0 = data.models;
            if (Array.isArray(data0)) {
                if (data0.length > 5) {
                    const err2 = {
                        instancePath: instancePath + '/models',
                        schemaPath: '#/properties/models/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 5 },
                        message: 'must NOT have more than 5 items',
                        schema: 5,
                        parentSchema: schema137.properties.models,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
                if (data0.length < 1) {
                    const err3 = {
                        instancePath: instancePath + '/models',
                        schemaPath: '#/properties/models/minItems',
                        keyword: 'minItems',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 items',
                        schema: 1,
                        parentSchema: schema137.properties.models,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
                const len0 = data0.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    if (!validate70(data0[i0], {
                        instancePath: instancePath + '/models/' + i0,
                        parentData: data0,
                        parentDataProperty: i0,
                        rootData,
                    })) {
                        vErrors = vErrors === null ? validate70.errors : vErrors.concat(validate70.errors);
                        errors = vErrors.length;
                    }
                }
            }
            else {
                const err4 = {
                    instancePath: instancePath + '/models',
                    schemaPath: '#/properties/models/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema137.properties.models.type,
                    parentSchema: schema137.properties.models,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
    }
    else {
        const err5 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema137.type,
            parentSchema: schema137,
            data,
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
    }
    validate72.errors = vErrors;
    return errors === 0;
}
function validate59(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        let missing0;
        if ((data.quiz === undefined && (missing0 = 'quiz')) ||
            (data.task === undefined && (missing0 = 'task'))) {
            const err0 = {};
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    var valid0 = _errs2 === errors;
    if (valid0) {
        const err1 = {
            instancePath,
            schemaPath: '#/not',
            keyword: 'not',
            params: {},
            message: 'must NOT be valid',
            schema: schema105.not,
            parentSchema: schema105,
            data,
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    else {
        errors = _errs1;
        if (vErrors !== null) {
            if (_errs1) {
                vErrors.length = _errs1;
            }
            else {
                vErrors = null;
            }
        }
    }
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.id === undefined) {
            const err2 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'id' },
                message: "must have required property '" + 'id' + "'",
                schema: schema105.required,
                parentSchema: schema105,
                data,
            };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        if (data.title === undefined) {
            const err3 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'title' },
                message: "must have required property '" + 'title' + "'",
                schema: schema105.required,
                parentSchema: schema105,
                data,
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!func2.call(schema105.properties, key0)) {
                const err4 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema105,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
        }
        if (data.id !== undefined) {
            let data0 = data.id;
            if (typeof data0 === 'string') {
                if (func3(data0) > 64) {
                    const err5 = {
                        instancePath: instancePath + '/id',
                        schemaPath: '#/definitions/slug/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 characters',
                        schema: 64,
                        parentSchema: schema12,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (!pattern0.test(data0)) {
                    const err6 = {
                        instancePath: instancePath + '/id',
                        schemaPath: '#/definitions/slug/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                        message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                        schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                        parentSchema: schema12,
                        data: data0,
                    };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
            }
            else {
                const err7 = {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/definitions/slug/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema12.type,
                    parentSchema: schema12,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
        }
        if (data.title !== undefined) {
            let data1 = data.title;
            if (typeof data1 === 'string') {
                if (func3(data1) > 80) {
                    const err8 = {
                        instancePath: instancePath + '/title',
                        schemaPath: '#/properties/title/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 80 },
                        message: 'must NOT have more than 80 characters',
                        schema: 80,
                        parentSchema: schema105.properties.title,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err8];
                    }
                    else {
                        vErrors.push(err8);
                    }
                    errors++;
                }
                if (func3(data1) < 1) {
                    const err9 = {
                        instancePath: instancePath + '/title',
                        schemaPath: '#/properties/title/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema105.properties.title,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err9];
                    }
                    else {
                        vErrors.push(err9);
                    }
                    errors++;
                }
            }
            else {
                const err10 = {
                    instancePath: instancePath + '/title',
                    schemaPath: '#/properties/title/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema105.properties.title.type,
                    parentSchema: schema105.properties.title,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
        }
        if (data.focus !== undefined) {
            let data2 = data.focus;
            const _errs10 = errors;
            let valid3 = false;
            let passing0 = null;
            const _errs11 = errors;
            if (typeof data2 === 'string') {
                if (func3(data2) > 64) {
                    const err11 = {
                        instancePath: instancePath + '/focus',
                        schemaPath: '#/definitions/slug/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 characters',
                        schema: 64,
                        parentSchema: schema12,
                        data: data2,
                    };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
                if (!pattern0.test(data2)) {
                    const err12 = {
                        instancePath: instancePath + '/focus',
                        schemaPath: '#/definitions/slug/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                        message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                        schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                        parentSchema: schema12,
                        data: data2,
                    };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
            }
            else {
                const err13 = {
                    instancePath: instancePath + '/focus',
                    schemaPath: '#/definitions/slug/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema12.type,
                    parentSchema: schema12,
                    data: data2,
                };
                if (vErrors === null) {
                    vErrors = [err13];
                }
                else {
                    vErrors.push(err13);
                }
                errors++;
            }
            var _valid0 = _errs11 === errors;
            if (_valid0) {
                valid3 = true;
                passing0 = 0;
            }
            const _errs14 = errors;
            if (typeof data2 === 'string') {
                if (func3(data2) > 71) {
                    const err14 = {
                        instancePath: instancePath + '/focus',
                        schemaPath: '#/definitions/worldFeature/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 71 },
                        message: 'must NOT have more than 71 characters',
                        schema: 71,
                        parentSchema: schema108,
                        data: data2,
                    };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
                if (!pattern19.test(data2)) {
                    const err15 = {
                        instancePath: instancePath + '/focus',
                        schemaPath: '#/definitions/worldFeature/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^wereld:[a-z0-9]+(-[a-z0-9]+)*$' },
                        message: 'must match pattern "' + '^wereld:[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                        schema: '^wereld:[a-z0-9]+(-[a-z0-9]+)*$',
                        parentSchema: schema108,
                        data: data2,
                    };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            else {
                const err16 = {
                    instancePath: instancePath + '/focus',
                    schemaPath: '#/definitions/worldFeature/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema108.type,
                    parentSchema: schema108,
                    data: data2,
                };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
            var _valid0 = _errs14 === errors;
            if (_valid0 && valid3) {
                valid3 = false;
                passing0 = [passing0, 1];
            }
            else {
                if (_valid0) {
                    valid3 = true;
                    passing0 = 1;
                }
            }
            if (!valid3) {
                const err17 = {
                    instancePath: instancePath + '/focus',
                    schemaPath: '#/properties/focus/oneOf',
                    keyword: 'oneOf',
                    params: { passingSchemas: passing0 },
                    message: 'must match exactly one schema in oneOf',
                    schema: schema105.properties.focus.oneOf,
                    parentSchema: schema105.properties.focus,
                    data: data2,
                };
                if (vErrors === null) {
                    vErrors = [err17];
                }
                else {
                    vErrors.push(err17);
                }
                errors++;
            }
            else {
                errors = _errs10;
                if (vErrors !== null) {
                    if (_errs10) {
                        vErrors.length = _errs10;
                    }
                    else {
                        vErrors = null;
                    }
                }
            }
        }
        if (data.view !== undefined) {
            if (!validate60(data.view, {
                instancePath: instancePath + '/view',
                parentData: data,
                parentDataProperty: 'view',
                rootData,
            })) {
                vErrors = vErrors === null ? validate60.errors : vErrors.concat(validate60.errors);
                errors = vErrors.length;
            }
        }
        if (data.panel !== undefined) {
            let data4 = data.panel;
            if (data4 && typeof data4 == 'object' && !Array.isArray(data4)) {
                if (data4.title === undefined) {
                    const err18 = {
                        instancePath: instancePath + '/panel',
                        schemaPath: '#/definitions/panel/required',
                        keyword: 'required',
                        params: { missingProperty: 'title' },
                        message: "must have required property '" + 'title' + "'",
                        schema: schema117.required,
                        parentSchema: schema117,
                        data: data4,
                    };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                if (data4.text === undefined) {
                    const err19 = {
                        instancePath: instancePath + '/panel',
                        schemaPath: '#/definitions/panel/required',
                        keyword: 'required',
                        params: { missingProperty: 'text' },
                        message: "must have required property '" + 'text' + "'",
                        schema: schema117.required,
                        parentSchema: schema117,
                        data: data4,
                    };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
                for (const key1 in data4) {
                    if (!(key1 === 'title' || key1 === 'text')) {
                        const err20 = {
                            instancePath: instancePath + '/panel',
                            schemaPath: '#/definitions/panel/additionalProperties',
                            keyword: 'additionalProperties',
                            params: { additionalProperty: key1 },
                            message: 'must NOT have additional properties',
                            schema: false,
                            parentSchema: schema117,
                            data: data4,
                        };
                        if (vErrors === null) {
                            vErrors = [err20];
                        }
                        else {
                            vErrors.push(err20);
                        }
                        errors++;
                    }
                }
                if (data4.title !== undefined) {
                    let data5 = data4.title;
                    if (typeof data5 === 'string') {
                        if (func3(data5) > 80) {
                            const err21 = {
                                instancePath: instancePath + '/panel/title',
                                schemaPath: '#/definitions/panel/properties/title/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 80 },
                                message: 'must NOT have more than 80 characters',
                                schema: 80,
                                parentSchema: schema117.properties.title,
                                data: data5,
                            };
                            if (vErrors === null) {
                                vErrors = [err21];
                            }
                            else {
                                vErrors.push(err21);
                            }
                            errors++;
                        }
                        if (func3(data5) < 1) {
                            const err22 = {
                                instancePath: instancePath + '/panel/title',
                                schemaPath: '#/definitions/panel/properties/title/minLength',
                                keyword: 'minLength',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 characters',
                                schema: 1,
                                parentSchema: schema117.properties.title,
                                data: data5,
                            };
                            if (vErrors === null) {
                                vErrors = [err22];
                            }
                            else {
                                vErrors.push(err22);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err23 = {
                            instancePath: instancePath + '/panel/title',
                            schemaPath: '#/definitions/panel/properties/title/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                            schema: schema117.properties.title.type,
                            parentSchema: schema117.properties.title,
                            data: data5,
                        };
                        if (vErrors === null) {
                            vErrors = [err23];
                        }
                        else {
                            vErrors.push(err23);
                        }
                        errors++;
                    }
                }
                if (data4.text !== undefined) {
                    let data6 = data4.text;
                    if (typeof data6 === 'string') {
                        if (func3(data6) > 260) {
                            const err24 = {
                                instancePath: instancePath + '/panel/text',
                                schemaPath: '#/definitions/panel/properties/text/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 260 },
                                message: 'must NOT have more than 260 characters',
                                schema: 260,
                                parentSchema: schema117.properties.text,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err24];
                            }
                            else {
                                vErrors.push(err24);
                            }
                            errors++;
                        }
                        if (func3(data6) < 1) {
                            const err25 = {
                                instancePath: instancePath + '/panel/text',
                                schemaPath: '#/definitions/panel/properties/text/minLength',
                                keyword: 'minLength',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 characters',
                                schema: 1,
                                parentSchema: schema117.properties.text,
                                data: data6,
                            };
                            if (vErrors === null) {
                                vErrors = [err25];
                            }
                            else {
                                vErrors.push(err25);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err26 = {
                            instancePath: instancePath + '/panel/text',
                            schemaPath: '#/definitions/panel/properties/text/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                            schema: schema117.properties.text.type,
                            parentSchema: schema117.properties.text,
                            data: data6,
                        };
                        if (vErrors === null) {
                            vErrors = [err26];
                        }
                        else {
                            vErrors.push(err26);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err27 = {
                    instancePath: instancePath + '/panel',
                    schemaPath: '#/definitions/panel/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                    schema: schema117.type,
                    parentSchema: schema117,
                    data: data4,
                };
                if (vErrors === null) {
                    vErrors = [err27];
                }
                else {
                    vErrors.push(err27);
                }
                errors++;
            }
        }
        if (data.narration !== undefined) {
            let data7 = data.narration;
            if (typeof data7 === 'string') {
                if (func3(data7) > 600) {
                    const err28 = {
                        instancePath: instancePath + '/narration',
                        schemaPath: '#/properties/narration/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 600 },
                        message: 'must NOT have more than 600 characters',
                        schema: 600,
                        parentSchema: schema105.properties.narration,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err28];
                    }
                    else {
                        vErrors.push(err28);
                    }
                    errors++;
                }
                if (func3(data7) < 1) {
                    const err29 = {
                        instancePath: instancePath + '/narration',
                        schemaPath: '#/properties/narration/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema105.properties.narration,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
                if (!pattern25.test(data7)) {
                    const err30 = {
                        instancePath: instancePath + '/narration',
                        schemaPath: '#/properties/narration/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^ *[^ ].*$' },
                        message: 'must match pattern "' + '^ *[^ ].*$' + '"',
                        schema: '^ *[^ ].*$',
                        parentSchema: schema105.properties.narration,
                        data: data7,
                    };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
            }
            else {
                const err31 = {
                    instancePath: instancePath + '/narration',
                    schemaPath: '#/properties/narration/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema105.properties.narration.type,
                    parentSchema: schema105.properties.narration,
                    data: data7,
                };
                if (vErrors === null) {
                    vErrors = [err31];
                }
                else {
                    vErrors.push(err31);
                }
                errors++;
            }
        }
        if (data.voiceover !== undefined) {
            let data8 = data.voiceover;
            if (typeof data8 === 'string') {
                if (!pattern1.test(data8)) {
                    const err32 = {
                        instancePath: instancePath + '/voiceover',
                        schemaPath: '#/definitions/mediaId/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^m_[A-Za-z0-9_-]{1,64}$' },
                        message: 'must match pattern "' + '^m_[A-Za-z0-9_-]{1,64}$' + '"',
                        schema: '^m_[A-Za-z0-9_-]{1,64}$',
                        parentSchema: schema14,
                        data: data8,
                    };
                    if (vErrors === null) {
                        vErrors = [err32];
                    }
                    else {
                        vErrors.push(err32);
                    }
                    errors++;
                }
            }
            else {
                const err33 = {
                    instancePath: instancePath + '/voiceover',
                    schemaPath: '#/definitions/mediaId/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema14.type,
                    parentSchema: schema14,
                    data: data8,
                };
                if (vErrors === null) {
                    vErrors = [err33];
                }
                else {
                    vErrors.push(err33);
                }
                errors++;
            }
        }
        if (data.hotspots !== undefined) {
            let data9 = data.hotspots;
            if (Array.isArray(data9)) {
                if (data9.length > 6) {
                    const err34 = {
                        instancePath: instancePath + '/hotspots',
                        schemaPath: '#/properties/hotspots/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 6 },
                        message: 'must NOT have more than 6 items',
                        schema: 6,
                        parentSchema: schema105.properties.hotspots,
                        data: data9,
                    };
                    if (vErrors === null) {
                        vErrors = [err34];
                    }
                    else {
                        vErrors.push(err34);
                    }
                    errors++;
                }
                const len0 = data9.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    if (!validate62(data9[i0], {
                        instancePath: instancePath + '/hotspots/' + i0,
                        parentData: data9,
                        parentDataProperty: i0,
                        rootData,
                    })) {
                        vErrors = vErrors === null ? validate62.errors : vErrors.concat(validate62.errors);
                        errors = vErrors.length;
                    }
                }
            }
            else {
                const err35 = {
                    instancePath: instancePath + '/hotspots',
                    schemaPath: '#/properties/hotspots/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema105.properties.hotspots.type,
                    parentSchema: schema105.properties.hotspots,
                    data: data9,
                };
                if (vErrors === null) {
                    vErrors = [err35];
                }
                else {
                    vErrors.push(err35);
                }
                errors++;
            }
        }
        if (data.quiz !== undefined) {
            let data11 = data.quiz;
            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                if (data11.question === undefined) {
                    const err36 = {
                        instancePath: instancePath + '/quiz',
                        schemaPath: '#/definitions/quiz/required',
                        keyword: 'required',
                        params: { missingProperty: 'question' },
                        message: "must have required property '" + 'question' + "'",
                        schema: schema121.required,
                        parentSchema: schema121,
                        data: data11,
                    };
                    if (vErrors === null) {
                        vErrors = [err36];
                    }
                    else {
                        vErrors.push(err36);
                    }
                    errors++;
                }
                if (data11.options === undefined) {
                    const err37 = {
                        instancePath: instancePath + '/quiz',
                        schemaPath: '#/definitions/quiz/required',
                        keyword: 'required',
                        params: { missingProperty: 'options' },
                        message: "must have required property '" + 'options' + "'",
                        schema: schema121.required,
                        parentSchema: schema121,
                        data: data11,
                    };
                    if (vErrors === null) {
                        vErrors = [err37];
                    }
                    else {
                        vErrors.push(err37);
                    }
                    errors++;
                }
                if (data11.answer === undefined) {
                    const err38 = {
                        instancePath: instancePath + '/quiz',
                        schemaPath: '#/definitions/quiz/required',
                        keyword: 'required',
                        params: { missingProperty: 'answer' },
                        message: "must have required property '" + 'answer' + "'",
                        schema: schema121.required,
                        parentSchema: schema121,
                        data: data11,
                    };
                    if (vErrors === null) {
                        vErrors = [err38];
                    }
                    else {
                        vErrors.push(err38);
                    }
                    errors++;
                }
                if (data11.explain === undefined) {
                    const err39 = {
                        instancePath: instancePath + '/quiz',
                        schemaPath: '#/definitions/quiz/required',
                        keyword: 'required',
                        params: { missingProperty: 'explain' },
                        message: "must have required property '" + 'explain' + "'",
                        schema: schema121.required,
                        parentSchema: schema121,
                        data: data11,
                    };
                    if (vErrors === null) {
                        vErrors = [err39];
                    }
                    else {
                        vErrors.push(err39);
                    }
                    errors++;
                }
                for (const key2 in data11) {
                    if (!(key2 === 'question' ||
                        key2 === 'options' ||
                        key2 === 'answer' ||
                        key2 === 'explain' ||
                        key2 === 'level' ||
                        key2 === 'doordenk')) {
                        const err40 = {
                            instancePath: instancePath + '/quiz',
                            schemaPath: '#/definitions/quiz/additionalProperties',
                            keyword: 'additionalProperties',
                            params: { additionalProperty: key2 },
                            message: 'must NOT have additional properties',
                            schema: false,
                            parentSchema: schema121,
                            data: data11,
                        };
                        if (vErrors === null) {
                            vErrors = [err40];
                        }
                        else {
                            vErrors.push(err40);
                        }
                        errors++;
                    }
                }
                if (data11.question !== undefined) {
                    let data12 = data11.question;
                    if (typeof data12 === 'string') {
                        if (func3(data12) > 200) {
                            const err41 = {
                                instancePath: instancePath + '/quiz/question',
                                schemaPath: '#/definitions/quiz/properties/question/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 200 },
                                message: 'must NOT have more than 200 characters',
                                schema: 200,
                                parentSchema: schema121.properties.question,
                                data: data12,
                            };
                            if (vErrors === null) {
                                vErrors = [err41];
                            }
                            else {
                                vErrors.push(err41);
                            }
                            errors++;
                        }
                        if (func3(data12) < 1) {
                            const err42 = {
                                instancePath: instancePath + '/quiz/question',
                                schemaPath: '#/definitions/quiz/properties/question/minLength',
                                keyword: 'minLength',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 characters',
                                schema: 1,
                                parentSchema: schema121.properties.question,
                                data: data12,
                            };
                            if (vErrors === null) {
                                vErrors = [err42];
                            }
                            else {
                                vErrors.push(err42);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err43 = {
                            instancePath: instancePath + '/quiz/question',
                            schemaPath: '#/definitions/quiz/properties/question/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                            schema: schema121.properties.question.type,
                            parentSchema: schema121.properties.question,
                            data: data12,
                        };
                        if (vErrors === null) {
                            vErrors = [err43];
                        }
                        else {
                            vErrors.push(err43);
                        }
                        errors++;
                    }
                }
                if (data11.options !== undefined) {
                    let data13 = data11.options;
                    if (Array.isArray(data13)) {
                        if (data13.length > 4) {
                            const err44 = {
                                instancePath: instancePath + '/quiz/options',
                                schemaPath: '#/definitions/quiz/properties/options/maxItems',
                                keyword: 'maxItems',
                                params: { limit: 4 },
                                message: 'must NOT have more than 4 items',
                                schema: 4,
                                parentSchema: schema121.properties.options,
                                data: data13,
                            };
                            if (vErrors === null) {
                                vErrors = [err44];
                            }
                            else {
                                vErrors.push(err44);
                            }
                            errors++;
                        }
                        if (data13.length < 2) {
                            const err45 = {
                                instancePath: instancePath + '/quiz/options',
                                schemaPath: '#/definitions/quiz/properties/options/minItems',
                                keyword: 'minItems',
                                params: { limit: 2 },
                                message: 'must NOT have fewer than 2 items',
                                schema: 2,
                                parentSchema: schema121.properties.options,
                                data: data13,
                            };
                            if (vErrors === null) {
                                vErrors = [err45];
                            }
                            else {
                                vErrors.push(err45);
                            }
                            errors++;
                        }
                        const len1 = data13.length;
                        for (let i1 = 0; i1 < len1; i1++) {
                            let data14 = data13[i1];
                            if (typeof data14 === 'string') {
                                if (func3(data14) > 80) {
                                    const err46 = {
                                        instancePath: instancePath + '/quiz/options/' + i1,
                                        schemaPath: '#/definitions/quiz/properties/options/items/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 80 },
                                        message: 'must NOT have more than 80 characters',
                                        schema: 80,
                                        parentSchema: schema121.properties.options.items,
                                        data: data14,
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err46];
                                    }
                                    else {
                                        vErrors.push(err46);
                                    }
                                    errors++;
                                }
                                if (func3(data14) < 1) {
                                    const err47 = {
                                        instancePath: instancePath + '/quiz/options/' + i1,
                                        schemaPath: '#/definitions/quiz/properties/options/items/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters',
                                        schema: 1,
                                        parentSchema: schema121.properties.options.items,
                                        data: data14,
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err47];
                                    }
                                    else {
                                        vErrors.push(err47);
                                    }
                                    errors++;
                                }
                            }
                            else {
                                const err48 = {
                                    instancePath: instancePath + '/quiz/options/' + i1,
                                    schemaPath: '#/definitions/quiz/properties/options/items/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                    schema: schema121.properties.options.items.type,
                                    parentSchema: schema121.properties.options.items,
                                    data: data14,
                                };
                                if (vErrors === null) {
                                    vErrors = [err48];
                                }
                                else {
                                    vErrors.push(err48);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        const err49 = {
                            instancePath: instancePath + '/quiz/options',
                            schemaPath: '#/definitions/quiz/properties/options/type',
                            keyword: 'type',
                            params: { type: 'array' },
                            message: 'must be array',
                            schema: schema121.properties.options.type,
                            parentSchema: schema121.properties.options,
                            data: data13,
                        };
                        if (vErrors === null) {
                            vErrors = [err49];
                        }
                        else {
                            vErrors.push(err49);
                        }
                        errors++;
                    }
                }
                if (data11.answer !== undefined) {
                    let data15 = data11.answer;
                    if (!(typeof data15 == 'number' && !(data15 % 1) && !isNaN(data15) && isFinite(data15))) {
                        const err50 = {
                            instancePath: instancePath + '/quiz/answer',
                            schemaPath: '#/definitions/quiz/properties/answer/type',
                            keyword: 'type',
                            params: { type: 'integer' },
                            message: 'must be integer',
                            schema: schema121.properties.answer.type,
                            parentSchema: schema121.properties.answer,
                            data: data15,
                        };
                        if (vErrors === null) {
                            vErrors = [err50];
                        }
                        else {
                            vErrors.push(err50);
                        }
                        errors++;
                    }
                    if (typeof data15 == 'number' && isFinite(data15)) {
                        if (data15 < 0 || isNaN(data15)) {
                            const err51 = {
                                instancePath: instancePath + '/quiz/answer',
                                schemaPath: '#/definitions/quiz/properties/answer/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: 0 },
                                message: 'must be >= 0',
                                schema: 0,
                                parentSchema: schema121.properties.answer,
                                data: data15,
                            };
                            if (vErrors === null) {
                                vErrors = [err51];
                            }
                            else {
                                vErrors.push(err51);
                            }
                            errors++;
                        }
                    }
                }
                if (data11.explain !== undefined) {
                    let data16 = data11.explain;
                    if (typeof data16 === 'string') {
                        if (func3(data16) > 260) {
                            const err52 = {
                                instancePath: instancePath + '/quiz/explain',
                                schemaPath: '#/definitions/quiz/properties/explain/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 260 },
                                message: 'must NOT have more than 260 characters',
                                schema: 260,
                                parentSchema: schema121.properties.explain,
                                data: data16,
                            };
                            if (vErrors === null) {
                                vErrors = [err52];
                            }
                            else {
                                vErrors.push(err52);
                            }
                            errors++;
                        }
                        if (func3(data16) < 1) {
                            const err53 = {
                                instancePath: instancePath + '/quiz/explain',
                                schemaPath: '#/definitions/quiz/properties/explain/minLength',
                                keyword: 'minLength',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 characters',
                                schema: 1,
                                parentSchema: schema121.properties.explain,
                                data: data16,
                            };
                            if (vErrors === null) {
                                vErrors = [err53];
                            }
                            else {
                                vErrors.push(err53);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err54 = {
                            instancePath: instancePath + '/quiz/explain',
                            schemaPath: '#/definitions/quiz/properties/explain/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                            schema: schema121.properties.explain.type,
                            parentSchema: schema121.properties.explain,
                            data: data16,
                        };
                        if (vErrors === null) {
                            vErrors = [err54];
                        }
                        else {
                            vErrors.push(err54);
                        }
                        errors++;
                    }
                }
                if (data11.level !== undefined) {
                    let data17 = data11.level;
                    if (!(data17 === 'herkennen' || data17 === 'begrijpen' || data17 === 'toepassen')) {
                        const err55 = {
                            instancePath: instancePath + '/quiz/level',
                            schemaPath: '#/definitions/quiz/properties/level/enum',
                            keyword: 'enum',
                            params: { allowedValues: schema121.properties.level.enum },
                            message: 'must be equal to one of the allowed values',
                            schema: schema121.properties.level.enum,
                            parentSchema: schema121.properties.level,
                            data: data17,
                        };
                        if (vErrors === null) {
                            vErrors = [err55];
                        }
                        else {
                            vErrors.push(err55);
                        }
                        errors++;
                    }
                }
                if (data11.doordenk !== undefined) {
                    let data18 = data11.doordenk;
                    if (typeof data18 !== 'boolean') {
                        const err56 = {
                            instancePath: instancePath + '/quiz/doordenk',
                            schemaPath: '#/definitions/quiz/properties/doordenk/type',
                            keyword: 'type',
                            params: { type: 'boolean' },
                            message: 'must be boolean',
                            schema: schema121.properties.doordenk.type,
                            parentSchema: schema121.properties.doordenk,
                            data: data18,
                        };
                        if (vErrors === null) {
                            vErrors = [err56];
                        }
                        else {
                            vErrors.push(err56);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err57 = {
                    instancePath: instancePath + '/quiz',
                    schemaPath: '#/definitions/quiz/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                    schema: schema121.type,
                    parentSchema: schema121,
                    data: data11,
                };
                if (vErrors === null) {
                    vErrors = [err57];
                }
                else {
                    vErrors.push(err57);
                }
                errors++;
            }
        }
        if (data.predict !== undefined) {
            let data19 = data.predict;
            if (data19 && typeof data19 == 'object' && !Array.isArray(data19)) {
                if (data19.question === undefined) {
                    const err58 = {
                        instancePath: instancePath + '/predict',
                        schemaPath: '#/definitions/predict/required',
                        keyword: 'required',
                        params: { missingProperty: 'question' },
                        message: "must have required property '" + 'question' + "'",
                        schema: schema122.required,
                        parentSchema: schema122,
                        data: data19,
                    };
                    if (vErrors === null) {
                        vErrors = [err58];
                    }
                    else {
                        vErrors.push(err58);
                    }
                    errors++;
                }
                if (data19.options === undefined) {
                    const err59 = {
                        instancePath: instancePath + '/predict',
                        schemaPath: '#/definitions/predict/required',
                        keyword: 'required',
                        params: { missingProperty: 'options' },
                        message: "must have required property '" + 'options' + "'",
                        schema: schema122.required,
                        parentSchema: schema122,
                        data: data19,
                    };
                    if (vErrors === null) {
                        vErrors = [err59];
                    }
                    else {
                        vErrors.push(err59);
                    }
                    errors++;
                }
                for (const key3 in data19) {
                    if (!(key3 === 'question' || key3 === 'options' || key3 === 'answer')) {
                        const err60 = {
                            instancePath: instancePath + '/predict',
                            schemaPath: '#/definitions/predict/additionalProperties',
                            keyword: 'additionalProperties',
                            params: { additionalProperty: key3 },
                            message: 'must NOT have additional properties',
                            schema: false,
                            parentSchema: schema122,
                            data: data19,
                        };
                        if (vErrors === null) {
                            vErrors = [err60];
                        }
                        else {
                            vErrors.push(err60);
                        }
                        errors++;
                    }
                }
                if (data19.question !== undefined) {
                    let data20 = data19.question;
                    if (typeof data20 === 'string') {
                        if (func3(data20) > 200) {
                            const err61 = {
                                instancePath: instancePath + '/predict/question',
                                schemaPath: '#/definitions/predict/properties/question/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 200 },
                                message: 'must NOT have more than 200 characters',
                                schema: 200,
                                parentSchema: schema122.properties.question,
                                data: data20,
                            };
                            if (vErrors === null) {
                                vErrors = [err61];
                            }
                            else {
                                vErrors.push(err61);
                            }
                            errors++;
                        }
                        if (func3(data20) < 1) {
                            const err62 = {
                                instancePath: instancePath + '/predict/question',
                                schemaPath: '#/definitions/predict/properties/question/minLength',
                                keyword: 'minLength',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 characters',
                                schema: 1,
                                parentSchema: schema122.properties.question,
                                data: data20,
                            };
                            if (vErrors === null) {
                                vErrors = [err62];
                            }
                            else {
                                vErrors.push(err62);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err63 = {
                            instancePath: instancePath + '/predict/question',
                            schemaPath: '#/definitions/predict/properties/question/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                            schema: schema122.properties.question.type,
                            parentSchema: schema122.properties.question,
                            data: data20,
                        };
                        if (vErrors === null) {
                            vErrors = [err63];
                        }
                        else {
                            vErrors.push(err63);
                        }
                        errors++;
                    }
                }
                if (data19.options !== undefined) {
                    let data21 = data19.options;
                    if (Array.isArray(data21)) {
                        if (data21.length > 4) {
                            const err64 = {
                                instancePath: instancePath + '/predict/options',
                                schemaPath: '#/definitions/predict/properties/options/maxItems',
                                keyword: 'maxItems',
                                params: { limit: 4 },
                                message: 'must NOT have more than 4 items',
                                schema: 4,
                                parentSchema: schema122.properties.options,
                                data: data21,
                            };
                            if (vErrors === null) {
                                vErrors = [err64];
                            }
                            else {
                                vErrors.push(err64);
                            }
                            errors++;
                        }
                        if (data21.length < 2) {
                            const err65 = {
                                instancePath: instancePath + '/predict/options',
                                schemaPath: '#/definitions/predict/properties/options/minItems',
                                keyword: 'minItems',
                                params: { limit: 2 },
                                message: 'must NOT have fewer than 2 items',
                                schema: 2,
                                parentSchema: schema122.properties.options,
                                data: data21,
                            };
                            if (vErrors === null) {
                                vErrors = [err65];
                            }
                            else {
                                vErrors.push(err65);
                            }
                            errors++;
                        }
                        const len2 = data21.length;
                        for (let i2 = 0; i2 < len2; i2++) {
                            let data22 = data21[i2];
                            if (typeof data22 === 'string') {
                                if (func3(data22) > 80) {
                                    const err66 = {
                                        instancePath: instancePath + '/predict/options/' + i2,
                                        schemaPath: '#/definitions/predict/properties/options/items/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 80 },
                                        message: 'must NOT have more than 80 characters',
                                        schema: 80,
                                        parentSchema: schema122.properties.options.items,
                                        data: data22,
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err66];
                                    }
                                    else {
                                        vErrors.push(err66);
                                    }
                                    errors++;
                                }
                                if (func3(data22) < 1) {
                                    const err67 = {
                                        instancePath: instancePath + '/predict/options/' + i2,
                                        schemaPath: '#/definitions/predict/properties/options/items/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters',
                                        schema: 1,
                                        parentSchema: schema122.properties.options.items,
                                        data: data22,
                                    };
                                    if (vErrors === null) {
                                        vErrors = [err67];
                                    }
                                    else {
                                        vErrors.push(err67);
                                    }
                                    errors++;
                                }
                            }
                            else {
                                const err68 = {
                                    instancePath: instancePath + '/predict/options/' + i2,
                                    schemaPath: '#/definitions/predict/properties/options/items/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string',
                                    schema: schema122.properties.options.items.type,
                                    parentSchema: schema122.properties.options.items,
                                    data: data22,
                                };
                                if (vErrors === null) {
                                    vErrors = [err68];
                                }
                                else {
                                    vErrors.push(err68);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        const err69 = {
                            instancePath: instancePath + '/predict/options',
                            schemaPath: '#/definitions/predict/properties/options/type',
                            keyword: 'type',
                            params: { type: 'array' },
                            message: 'must be array',
                            schema: schema122.properties.options.type,
                            parentSchema: schema122.properties.options,
                            data: data21,
                        };
                        if (vErrors === null) {
                            vErrors = [err69];
                        }
                        else {
                            vErrors.push(err69);
                        }
                        errors++;
                    }
                }
                if (data19.answer !== undefined) {
                    let data23 = data19.answer;
                    if (!(typeof data23 == 'number' && !(data23 % 1) && !isNaN(data23) && isFinite(data23))) {
                        const err70 = {
                            instancePath: instancePath + '/predict/answer',
                            schemaPath: '#/definitions/predict/properties/answer/type',
                            keyword: 'type',
                            params: { type: 'integer' },
                            message: 'must be integer',
                            schema: schema122.properties.answer.type,
                            parentSchema: schema122.properties.answer,
                            data: data23,
                        };
                        if (vErrors === null) {
                            vErrors = [err70];
                        }
                        else {
                            vErrors.push(err70);
                        }
                        errors++;
                    }
                    if (typeof data23 == 'number' && isFinite(data23)) {
                        if (data23 < 0 || isNaN(data23)) {
                            const err71 = {
                                instancePath: instancePath + '/predict/answer',
                                schemaPath: '#/definitions/predict/properties/answer/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: 0 },
                                message: 'must be >= 0',
                                schema: 0,
                                parentSchema: schema122.properties.answer,
                                data: data23,
                            };
                            if (vErrors === null) {
                                vErrors = [err71];
                            }
                            else {
                                vErrors.push(err71);
                            }
                            errors++;
                        }
                    }
                }
            }
            else {
                const err72 = {
                    instancePath: instancePath + '/predict',
                    schemaPath: '#/definitions/predict/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                    schema: schema122.type,
                    parentSchema: schema122,
                    data: data19,
                };
                if (vErrors === null) {
                    vErrors = [err72];
                }
                else {
                    vErrors.push(err72);
                }
                errors++;
            }
        }
        if (data.task !== undefined) {
            if (!validate64(data.task, {
                instancePath: instancePath + '/task',
                parentData: data,
                parentDataProperty: 'task',
                rootData,
            })) {
                vErrors = vErrors === null ? validate64.errors : vErrors.concat(validate64.errors);
                errors = vErrors.length;
            }
        }
        if (data.show !== undefined) {
            let data25 = data.show;
            if (Array.isArray(data25)) {
                if (data25.length > 12) {
                    const err73 = {
                        instancePath: instancePath + '/show',
                        schemaPath: '#/properties/show/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 12 },
                        message: 'must NOT have more than 12 items',
                        schema: 12,
                        parentSchema: schema105.properties.show,
                        data: data25,
                    };
                    if (vErrors === null) {
                        vErrors = [err73];
                    }
                    else {
                        vErrors.push(err73);
                    }
                    errors++;
                }
                const len3 = data25.length;
                for (let i3 = 0; i3 < len3; i3++) {
                    let data26 = data25[i3];
                    if (typeof data26 === 'string') {
                        if (func3(data26) > 64) {
                            const err74 = {
                                instancePath: instancePath + '/show/' + i3,
                                schemaPath: '#/definitions/slug/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 64 },
                                message: 'must NOT have more than 64 characters',
                                schema: 64,
                                parentSchema: schema12,
                                data: data26,
                            };
                            if (vErrors === null) {
                                vErrors = [err74];
                            }
                            else {
                                vErrors.push(err74);
                            }
                            errors++;
                        }
                        if (!pattern0.test(data26)) {
                            const err75 = {
                                instancePath: instancePath + '/show/' + i3,
                                schemaPath: '#/definitions/slug/pattern',
                                keyword: 'pattern',
                                params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                                message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                                schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                                parentSchema: schema12,
                                data: data26,
                            };
                            if (vErrors === null) {
                                vErrors = [err75];
                            }
                            else {
                                vErrors.push(err75);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err76 = {
                            instancePath: instancePath + '/show/' + i3,
                            schemaPath: '#/definitions/slug/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                            schema: schema12.type,
                            parentSchema: schema12,
                            data: data26,
                        };
                        if (vErrors === null) {
                            vErrors = [err76];
                        }
                        else {
                            vErrors.push(err76);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err77 = {
                    instancePath: instancePath + '/show',
                    schemaPath: '#/properties/show/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema105.properties.show.type,
                    parentSchema: schema105.properties.show,
                    data: data25,
                };
                if (vErrors === null) {
                    vErrors = [err77];
                }
                else {
                    vErrors.push(err77);
                }
                errors++;
            }
        }
        if (data.hide !== undefined) {
            let data27 = data.hide;
            if (Array.isArray(data27)) {
                if (data27.length > 12) {
                    const err78 = {
                        instancePath: instancePath + '/hide',
                        schemaPath: '#/properties/hide/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 12 },
                        message: 'must NOT have more than 12 items',
                        schema: 12,
                        parentSchema: schema105.properties.hide,
                        data: data27,
                    };
                    if (vErrors === null) {
                        vErrors = [err78];
                    }
                    else {
                        vErrors.push(err78);
                    }
                    errors++;
                }
                const len4 = data27.length;
                for (let i4 = 0; i4 < len4; i4++) {
                    let data28 = data27[i4];
                    if (typeof data28 === 'string') {
                        if (func3(data28) > 64) {
                            const err79 = {
                                instancePath: instancePath + '/hide/' + i4,
                                schemaPath: '#/definitions/slug/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 64 },
                                message: 'must NOT have more than 64 characters',
                                schema: 64,
                                parentSchema: schema12,
                                data: data28,
                            };
                            if (vErrors === null) {
                                vErrors = [err79];
                            }
                            else {
                                vErrors.push(err79);
                            }
                            errors++;
                        }
                        if (!pattern0.test(data28)) {
                            const err80 = {
                                instancePath: instancePath + '/hide/' + i4,
                                schemaPath: '#/definitions/slug/pattern',
                                keyword: 'pattern',
                                params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                                message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                                schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                                parentSchema: schema12,
                                data: data28,
                            };
                            if (vErrors === null) {
                                vErrors = [err80];
                            }
                            else {
                                vErrors.push(err80);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err81 = {
                            instancePath: instancePath + '/hide/' + i4,
                            schemaPath: '#/definitions/slug/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                            schema: schema12.type,
                            parentSchema: schema12,
                            data: data28,
                        };
                        if (vErrors === null) {
                            vErrors = [err81];
                        }
                        else {
                            vErrors.push(err81);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err82 = {
                    instancePath: instancePath + '/hide',
                    schemaPath: '#/properties/hide/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema105.properties.hide.type,
                    parentSchema: schema105.properties.hide,
                    data: data27,
                };
                if (vErrors === null) {
                    vErrors = [err82];
                }
                else {
                    vErrors.push(err82);
                }
                errors++;
            }
        }
        if (data.move !== undefined) {
            let data29 = data.move;
            if (Array.isArray(data29)) {
                if (data29.length > 8) {
                    const err83 = {
                        instancePath: instancePath + '/move',
                        schemaPath: '#/properties/move/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 8 },
                        message: 'must NOT have more than 8 items',
                        schema: 8,
                        parentSchema: schema105.properties.move,
                        data: data29,
                    };
                    if (vErrors === null) {
                        vErrors = [err83];
                    }
                    else {
                        vErrors.push(err83);
                    }
                    errors++;
                }
                const len5 = data29.length;
                for (let i5 = 0; i5 < len5; i5++) {
                    if (!validate66(data29[i5], {
                        instancePath: instancePath + '/move/' + i5,
                        parentData: data29,
                        parentDataProperty: i5,
                        rootData,
                    })) {
                        vErrors = vErrors === null ? validate66.errors : vErrors.concat(validate66.errors);
                        errors = vErrors.length;
                    }
                }
            }
            else {
                const err84 = {
                    instancePath: instancePath + '/move',
                    schemaPath: '#/properties/move/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema105.properties.move.type,
                    parentSchema: schema105.properties.move,
                    data: data29,
                };
                if (vErrors === null) {
                    vErrors = [err84];
                }
                else {
                    vErrors.push(err84);
                }
                errors++;
            }
        }
        if (data.highlight !== undefined) {
            let data31 = data.highlight;
            if (typeof data31 === 'string') {
                if (func3(data31) > 64) {
                    const err85 = {
                        instancePath: instancePath + '/highlight',
                        schemaPath: '#/definitions/slug/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 characters',
                        schema: 64,
                        parentSchema: schema12,
                        data: data31,
                    };
                    if (vErrors === null) {
                        vErrors = [err85];
                    }
                    else {
                        vErrors.push(err85);
                    }
                    errors++;
                }
                if (!pattern0.test(data31)) {
                    const err86 = {
                        instancePath: instancePath + '/highlight',
                        schemaPath: '#/definitions/slug/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                        message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                        schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                        parentSchema: schema12,
                        data: data31,
                    };
                    if (vErrors === null) {
                        vErrors = [err86];
                    }
                    else {
                        vErrors.push(err86);
                    }
                    errors++;
                }
            }
            else {
                const err87 = {
                    instancePath: instancePath + '/highlight',
                    schemaPath: '#/definitions/slug/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema12.type,
                    parentSchema: schema12,
                    data: data31,
                };
                if (vErrors === null) {
                    vErrors = [err87];
                }
                else {
                    vErrors.push(err87);
                }
                errors++;
            }
        }
        if (data.world !== undefined) {
            let data32 = data.world;
            if (data32 && typeof data32 == 'object' && !Array.isArray(data32)) {
                for (const key4 in data32) {
                    let data33 = data32[key4];
                    if (typeof data33 !== 'string') {
                        const err88 = {
                            instancePath: instancePath + '/world/' + key4.replace(/~/g, '~0').replace(/\//g, '~1'),
                            schemaPath: '#/properties/world/additionalProperties/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                            schema: schema105.properties.world.additionalProperties.type,
                            parentSchema: schema105.properties.world.additionalProperties,
                            data: data33,
                        };
                        if (vErrors === null) {
                            vErrors = [err88];
                        }
                        else {
                            vErrors.push(err88);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err89 = {
                    instancePath: instancePath + '/world',
                    schemaPath: '#/properties/world/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                    schema: schema105.properties.world.type,
                    parentSchema: schema105.properties.world,
                    data: data32,
                };
                if (vErrors === null) {
                    vErrors = [err89];
                }
                else {
                    vErrors.push(err89);
                }
                errors++;
            }
        }
        if (data.pano !== undefined) {
            if (!validate68(data.pano, {
                instancePath: instancePath + '/pano',
                parentData: data,
                parentDataProperty: 'pano',
                rootData,
            })) {
                vErrors = vErrors === null ? validate68.errors : vErrors.concat(validate68.errors);
                errors = vErrors.length;
            }
        }
        if (data.models !== undefined) {
            let data35 = data.models;
            if (Array.isArray(data35)) {
                if (data35.length > 5) {
                    const err90 = {
                        instancePath: instancePath + '/models',
                        schemaPath: '#/properties/models/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 5 },
                        message: 'must NOT have more than 5 items',
                        schema: 5,
                        parentSchema: schema105.properties.models,
                        data: data35,
                    };
                    if (vErrors === null) {
                        vErrors = [err90];
                    }
                    else {
                        vErrors.push(err90);
                    }
                    errors++;
                }
                const len6 = data35.length;
                for (let i6 = 0; i6 < len6; i6++) {
                    if (!validate70(data35[i6], {
                        instancePath: instancePath + '/models/' + i6,
                        parentData: data35,
                        parentDataProperty: i6,
                        rootData,
                    })) {
                        vErrors = vErrors === null ? validate70.errors : vErrors.concat(validate70.errors);
                        errors = vErrors.length;
                    }
                }
            }
            else {
                const err91 = {
                    instancePath: instancePath + '/models',
                    schemaPath: '#/properties/models/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema105.properties.models.type,
                    parentSchema: schema105.properties.models,
                    data: data35,
                };
                if (vErrors === null) {
                    vErrors = [err91];
                }
                else {
                    vErrors.push(err91);
                }
                errors++;
            }
        }
        if (data.spannend !== undefined) {
            if (!validate72(data.spannend, {
                instancePath: instancePath + '/spannend',
                parentData: data,
                parentDataProperty: 'spannend',
                rootData,
            })) {
                vErrors = vErrors === null ? validate72.errors : vErrors.concat(validate72.errors);
                errors = vErrors.length;
            }
        }
        if (data.pause !== undefined) {
            let data38 = data.pause;
            if (typeof data38 !== 'boolean') {
                const err92 = {
                    instancePath: instancePath + '/pause',
                    schemaPath: '#/properties/pause/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema105.properties.pause.type,
                    parentSchema: schema105.properties.pause,
                    data: data38,
                };
                if (vErrors === null) {
                    vErrors = [err92];
                }
                else {
                    vErrors.push(err92);
                }
                errors++;
            }
        }
    }
    else {
        const err93 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema105.type,
            parentSchema: schema105,
            data,
        };
        if (vErrors === null) {
            vErrors = [err93];
        }
        else {
            vErrors.push(err93);
        }
        errors++;
    }
    validate59.errors = vErrors;
    return errors === 0;
}
function validate10(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="https://vrlearning.eu/schemas/lesson-v1.json" */ let vErrors = null;
    let errors = 0;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.schemaVersion === undefined) {
            const err0 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'schemaVersion' },
                message: "must have required property '" + 'schemaVersion' + "'",
                schema: schema11.required,
                parentSchema: schema11,
                data,
            };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.id === undefined) {
            const err1 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'id' },
                message: "must have required property '" + 'id' + "'",
                schema: schema11.required,
                parentSchema: schema11,
                data,
            };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.title === undefined) {
            const err2 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'title' },
                message: "must have required property '" + 'title' + "'",
                schema: schema11.required,
                parentSchema: schema11,
                data,
            };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
        if (data.language === undefined) {
            const err3 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'language' },
                message: "must have required property '" + 'language' + "'",
                schema: schema11.required,
                parentSchema: schema11,
                data,
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
        }
        if (data.mode === undefined) {
            const err4 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'mode' },
                message: "must have required property '" + 'mode' + "'",
                schema: schema11.required,
                parentSchema: schema11,
                data,
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
        if (data.audience === undefined) {
            const err5 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'audience' },
                message: "must have required property '" + 'audience' + "'",
                schema: schema11.required,
                parentSchema: schema11,
                data,
            };
            if (vErrors === null) {
                vErrors = [err5];
            }
            else {
                vErrors.push(err5);
            }
            errors++;
        }
        if (data.learningGoals === undefined) {
            const err6 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'learningGoals' },
                message: "must have required property '" + 'learningGoals' + "'",
                schema: schema11.required,
                parentSchema: schema11,
                data,
            };
            if (vErrors === null) {
                vErrors = [err6];
            }
            else {
                vErrors.push(err6);
            }
            errors++;
        }
        if (data.scene === undefined) {
            const err7 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'scene' },
                message: "must have required property '" + 'scene' + "'",
                schema: schema11.required,
                parentSchema: schema11,
                data,
            };
            if (vErrors === null) {
                vErrors = [err7];
            }
            else {
                vErrors.push(err7);
            }
            errors++;
        }
        if (data.steps === undefined) {
            const err8 = {
                instancePath,
                schemaPath: '#/required',
                keyword: 'required',
                params: { missingProperty: 'steps' },
                message: "must have required property '" + 'steps' + "'",
                schema: schema11.required,
                parentSchema: schema11,
                data,
            };
            if (vErrors === null) {
                vErrors = [err8];
            }
            else {
                vErrors.push(err8);
            }
            errors++;
        }
        for (const key0 in data) {
            if (!func2.call(schema11.properties, key0)) {
                const err9 = {
                    instancePath,
                    schemaPath: '#/additionalProperties',
                    keyword: 'additionalProperties',
                    params: { additionalProperty: key0 },
                    message: 'must NOT have additional properties',
                    schema: false,
                    parentSchema: schema11,
                    data,
                };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
        }
        if (data.schemaVersion !== undefined) {
            let data0 = data.schemaVersion;
            if (1 !== data0) {
                const err10 = {
                    instancePath: instancePath + '/schemaVersion',
                    schemaPath: '#/properties/schemaVersion/const',
                    keyword: 'const',
                    params: { allowedValue: 1 },
                    message: 'must be equal to constant',
                    schema: 1,
                    parentSchema: schema11.properties.schemaVersion,
                    data: data0,
                };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
        }
        if (data.id !== undefined) {
            let data1 = data.id;
            if (typeof data1 === 'string') {
                if (func3(data1) > 64) {
                    const err11 = {
                        instancePath: instancePath + '/id',
                        schemaPath: '#/definitions/slug/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 64 },
                        message: 'must NOT have more than 64 characters',
                        schema: 64,
                        parentSchema: schema12,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
                if (!pattern0.test(data1)) {
                    const err12 = {
                        instancePath: instancePath + '/id',
                        schemaPath: '#/definitions/slug/pattern',
                        keyword: 'pattern',
                        params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                        message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                        schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                        parentSchema: schema12,
                        data: data1,
                    };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
            }
            else {
                const err13 = {
                    instancePath: instancePath + '/id',
                    schemaPath: '#/definitions/slug/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema12.type,
                    parentSchema: schema12,
                    data: data1,
                };
                if (vErrors === null) {
                    vErrors = [err13];
                }
                else {
                    vErrors.push(err13);
                }
                errors++;
            }
        }
        if (data.title !== undefined) {
            let data2 = data.title;
            if (typeof data2 === 'string') {
                if (func3(data2) > 120) {
                    const err14 = {
                        instancePath: instancePath + '/title',
                        schemaPath: '#/properties/title/maxLength',
                        keyword: 'maxLength',
                        params: { limit: 120 },
                        message: 'must NOT have more than 120 characters',
                        schema: 120,
                        parentSchema: schema11.properties.title,
                        data: data2,
                    };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
                if (func3(data2) < 1) {
                    const err15 = {
                        instancePath: instancePath + '/title',
                        schemaPath: '#/properties/title/minLength',
                        keyword: 'minLength',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 characters',
                        schema: 1,
                        parentSchema: schema11.properties.title,
                        data: data2,
                    };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            else {
                const err16 = {
                    instancePath: instancePath + '/title',
                    schemaPath: '#/properties/title/type',
                    keyword: 'type',
                    params: { type: 'string' },
                    message: 'must be string',
                    schema: schema11.properties.title.type,
                    parentSchema: schema11.properties.title,
                    data: data2,
                };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
        }
        if (data.language !== undefined) {
            let data3 = data.language;
            if (!(data3 === 'nl' || data3 === 'en')) {
                const err17 = {
                    instancePath: instancePath + '/language',
                    schemaPath: '#/properties/language/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema11.properties.language.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema11.properties.language.enum,
                    parentSchema: schema11.properties.language,
                    data: data3,
                };
                if (vErrors === null) {
                    vErrors = [err17];
                }
                else {
                    vErrors.push(err17);
                }
                errors++;
            }
        }
        if (data.mode !== undefined) {
            let data4 = data.mode;
            if (!(data4 === 'vr' || data4 === 'ar')) {
                const err18 = {
                    instancePath: instancePath + '/mode',
                    schemaPath: '#/properties/mode/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema11.properties.mode.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema11.properties.mode.enum,
                    parentSchema: schema11.properties.mode,
                    data: data4,
                };
                if (vErrors === null) {
                    vErrors = [err18];
                }
                else {
                    vErrors.push(err18);
                }
                errors++;
            }
        }
        if (data.selfPractice !== undefined) {
            let data5 = data.selfPractice;
            if (typeof data5 !== 'boolean') {
                const err19 = {
                    instancePath: instancePath + '/selfPractice',
                    schemaPath: '#/properties/selfPractice/type',
                    keyword: 'type',
                    params: { type: 'boolean' },
                    message: 'must be boolean',
                    schema: schema11.properties.selfPractice.type,
                    parentSchema: schema11.properties.selfPractice,
                    data: data5,
                };
                if (vErrors === null) {
                    vErrors = [err19];
                }
                else {
                    vErrors.push(err19);
                }
                errors++;
            }
        }
        if (data.audience !== undefined) {
            let data6 = data.audience;
            if (data6 && typeof data6 == 'object' && !Array.isArray(data6)) {
                if (data6.ageMin === undefined) {
                    const err20 = {
                        instancePath: instancePath + '/audience',
                        schemaPath: '#/properties/audience/required',
                        keyword: 'required',
                        params: { missingProperty: 'ageMin' },
                        message: "must have required property '" + 'ageMin' + "'",
                        schema: schema11.properties.audience.required,
                        parentSchema: schema11.properties.audience,
                        data: data6,
                    };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
                for (const key1 in data6) {
                    if (!(key1 === 'ageMin' || key1 === 'level')) {
                        const err21 = {
                            instancePath: instancePath + '/audience',
                            schemaPath: '#/properties/audience/additionalProperties',
                            keyword: 'additionalProperties',
                            params: { additionalProperty: key1 },
                            message: 'must NOT have additional properties',
                            schema: false,
                            parentSchema: schema11.properties.audience,
                            data: data6,
                        };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                }
                if (data6.ageMin !== undefined) {
                    let data7 = data6.ageMin;
                    if (!(typeof data7 == 'number' && !(data7 % 1) && !isNaN(data7) && isFinite(data7))) {
                        const err22 = {
                            instancePath: instancePath + '/audience/ageMin',
                            schemaPath: '#/properties/audience/properties/ageMin/type',
                            keyword: 'type',
                            params: { type: 'integer' },
                            message: 'must be integer',
                            schema: schema11.properties.audience.properties.ageMin.type,
                            parentSchema: schema11.properties.audience.properties.ageMin,
                            data: data7,
                        };
                        if (vErrors === null) {
                            vErrors = [err22];
                        }
                        else {
                            vErrors.push(err22);
                        }
                        errors++;
                    }
                    if (typeof data7 == 'number' && isFinite(data7)) {
                        if (data7 > 99 || isNaN(data7)) {
                            const err23 = {
                                instancePath: instancePath + '/audience/ageMin',
                                schemaPath: '#/properties/audience/properties/ageMin/maximum',
                                keyword: 'maximum',
                                params: { comparison: '<=', limit: 99 },
                                message: 'must be <= 99',
                                schema: 99,
                                parentSchema: schema11.properties.audience.properties.ageMin,
                                data: data7,
                            };
                            if (vErrors === null) {
                                vErrors = [err23];
                            }
                            else {
                                vErrors.push(err23);
                            }
                            errors++;
                        }
                        if (data7 < 4 || isNaN(data7)) {
                            const err24 = {
                                instancePath: instancePath + '/audience/ageMin',
                                schemaPath: '#/properties/audience/properties/ageMin/minimum',
                                keyword: 'minimum',
                                params: { comparison: '>=', limit: 4 },
                                message: 'must be >= 4',
                                schema: 4,
                                parentSchema: schema11.properties.audience.properties.ageMin,
                                data: data7,
                            };
                            if (vErrors === null) {
                                vErrors = [err24];
                            }
                            else {
                                vErrors.push(err24);
                            }
                            errors++;
                        }
                    }
                }
                if (data6.level !== undefined) {
                    let data8 = data6.level;
                    if (typeof data8 === 'string') {
                        if (func3(data8) > 60) {
                            const err25 = {
                                instancePath: instancePath + '/audience/level',
                                schemaPath: '#/properties/audience/properties/level/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 60 },
                                message: 'must NOT have more than 60 characters',
                                schema: 60,
                                parentSchema: schema11.properties.audience.properties.level,
                                data: data8,
                            };
                            if (vErrors === null) {
                                vErrors = [err25];
                            }
                            else {
                                vErrors.push(err25);
                            }
                            errors++;
                        }
                        if (func3(data8) < 1) {
                            const err26 = {
                                instancePath: instancePath + '/audience/level',
                                schemaPath: '#/properties/audience/properties/level/minLength',
                                keyword: 'minLength',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 characters',
                                schema: 1,
                                parentSchema: schema11.properties.audience.properties.level,
                                data: data8,
                            };
                            if (vErrors === null) {
                                vErrors = [err26];
                            }
                            else {
                                vErrors.push(err26);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err27 = {
                            instancePath: instancePath + '/audience/level',
                            schemaPath: '#/properties/audience/properties/level/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                            schema: schema11.properties.audience.properties.level.type,
                            parentSchema: schema11.properties.audience.properties.level,
                            data: data8,
                        };
                        if (vErrors === null) {
                            vErrors = [err27];
                        }
                        else {
                            vErrors.push(err27);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err28 = {
                    instancePath: instancePath + '/audience',
                    schemaPath: '#/properties/audience/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                    schema: schema11.properties.audience.type,
                    parentSchema: schema11.properties.audience,
                    data: data6,
                };
                if (vErrors === null) {
                    vErrors = [err28];
                }
                else {
                    vErrors.push(err28);
                }
                errors++;
            }
        }
        if (data.learningGoals !== undefined) {
            let data9 = data.learningGoals;
            if (Array.isArray(data9)) {
                if (data9.length > 2) {
                    const err29 = {
                        instancePath: instancePath + '/learningGoals',
                        schemaPath: '#/properties/learningGoals/maxItems',
                        keyword: 'maxItems',
                        params: { limit: 2 },
                        message: 'must NOT have more than 2 items',
                        schema: 2,
                        parentSchema: schema11.properties.learningGoals,
                        data: data9,
                    };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
                if (data9.length < 1) {
                    const err30 = {
                        instancePath: instancePath + '/learningGoals',
                        schemaPath: '#/properties/learningGoals/minItems',
                        keyword: 'minItems',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 items',
                        schema: 1,
                        parentSchema: schema11.properties.learningGoals,
                        data: data9,
                    };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
                const len0 = data9.length;
                for (let i0 = 0; i0 < len0; i0++) {
                    let data10 = data9[i0];
                    if (typeof data10 === 'string') {
                        if (func3(data10) > 200) {
                            const err31 = {
                                instancePath: instancePath + '/learningGoals/' + i0,
                                schemaPath: '#/properties/learningGoals/items/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 200 },
                                message: 'must NOT have more than 200 characters',
                                schema: 200,
                                parentSchema: schema11.properties.learningGoals.items,
                                data: data10,
                            };
                            if (vErrors === null) {
                                vErrors = [err31];
                            }
                            else {
                                vErrors.push(err31);
                            }
                            errors++;
                        }
                        if (func3(data10) < 1) {
                            const err32 = {
                                instancePath: instancePath + '/learningGoals/' + i0,
                                schemaPath: '#/properties/learningGoals/items/minLength',
                                keyword: 'minLength',
                                params: { limit: 1 },
                                message: 'must NOT have fewer than 1 characters',
                                schema: 1,
                                parentSchema: schema11.properties.learningGoals.items,
                                data: data10,
                            };
                            if (vErrors === null) {
                                vErrors = [err32];
                            }
                            else {
                                vErrors.push(err32);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err33 = {
                            instancePath: instancePath + '/learningGoals/' + i0,
                            schemaPath: '#/properties/learningGoals/items/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                            schema: schema11.properties.learningGoals.items.type,
                            parentSchema: schema11.properties.learningGoals.items,
                            data: data10,
                        };
                        if (vErrors === null) {
                            vErrors = [err33];
                        }
                        else {
                            vErrors.push(err33);
                        }
                        errors++;
                    }
                }
            }
            else {
                const err34 = {
                    instancePath: instancePath + '/learningGoals',
                    schemaPath: '#/properties/learningGoals/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema11.properties.learningGoals.type,
                    parentSchema: schema11.properties.learningGoals,
                    data: data9,
                };
                if (vErrors === null) {
                    vErrors = [err34];
                }
                else {
                    vErrors.push(err34);
                }
                errors++;
            }
        }
        if (data.scene !== undefined) {
            if (!validate11(data.scene, {
                instancePath: instancePath + '/scene',
                parentData: data,
                parentDataProperty: 'scene',
                rootData,
            })) {
                vErrors = vErrors === null ? validate11.errors : vErrors.concat(validate11.errors);
                errors = vErrors.length;
            }
        }
        if (data.objects !== undefined) {
            let data12 = data.objects;
            if (data12 && typeof data12 == 'object' && !Array.isArray(data12)) {
                for (const key2 in data12) {
                    const _errs26 = errors;
                    if (typeof key2 === 'string') {
                        if (func3(key2) > 64) {
                            const err35 = {
                                instancePath: instancePath + '/objects',
                                schemaPath: '#/definitions/slug/maxLength',
                                keyword: 'maxLength',
                                params: { limit: 64 },
                                message: 'must NOT have more than 64 characters',
                                schema: 64,
                                parentSchema: schema12,
                                data: key2,
                                propertyName: key2,
                            };
                            if (vErrors === null) {
                                vErrors = [err35];
                            }
                            else {
                                vErrors.push(err35);
                            }
                            errors++;
                        }
                        if (!pattern0.test(key2)) {
                            const err36 = {
                                instancePath: instancePath + '/objects',
                                schemaPath: '#/definitions/slug/pattern',
                                keyword: 'pattern',
                                params: { pattern: '^[a-z0-9]+(-[a-z0-9]+)*$' },
                                message: 'must match pattern "' + '^[a-z0-9]+(-[a-z0-9]+)*$' + '"',
                                schema: '^[a-z0-9]+(-[a-z0-9]+)*$',
                                parentSchema: schema12,
                                data: key2,
                                propertyName: key2,
                            };
                            if (vErrors === null) {
                                vErrors = [err36];
                            }
                            else {
                                vErrors.push(err36);
                            }
                            errors++;
                        }
                    }
                    else {
                        const err37 = {
                            instancePath: instancePath + '/objects',
                            schemaPath: '#/definitions/slug/type',
                            keyword: 'type',
                            params: { type: 'string' },
                            message: 'must be string',
                            schema: schema12.type,
                            parentSchema: schema12,
                            data: key2,
                            propertyName: key2,
                        };
                        if (vErrors === null) {
                            vErrors = [err37];
                        }
                        else {
                            vErrors.push(err37);
                        }
                        errors++;
                    }
                    var valid5 = _errs26 === errors;
                    if (!valid5) {
                        const err38 = {
                            instancePath: instancePath + '/objects',
                            schemaPath: '#/properties/objects/propertyNames',
                            keyword: 'propertyNames',
                            params: { propertyName: key2 },
                            message: 'property name must be valid',
                            schema: schema11.properties.objects.propertyNames,
                            parentSchema: schema11.properties.objects,
                            data: data12,
                        };
                        if (vErrors === null) {
                            vErrors = [err38];
                        }
                        else {
                            vErrors.push(err38);
                        }
                        errors++;
                    }
                }
                for (const key3 in data12) {
                    if (!validate13(data12[key3], {
                        instancePath: instancePath + '/objects/' + key3.replace(/~/g, '~0').replace(/\//g, '~1'),
                        parentData: data12,
                        parentDataProperty: key3,
                        rootData,
                    })) {
                        vErrors = vErrors === null ? validate13.errors : vErrors.concat(validate13.errors);
                        errors = vErrors.length;
                    }
                }
            }
            else {
                const err39 = {
                    instancePath: instancePath + '/objects',
                    schemaPath: '#/properties/objects/type',
                    keyword: 'type',
                    params: { type: 'object' },
                    message: 'must be object',
                    schema: schema11.properties.objects.type,
                    parentSchema: schema11.properties.objects,
                    data: data12,
                };
                if (vErrors === null) {
                    vErrors = [err39];
                }
                else {
                    vErrors.push(err39);
                }
                errors++;
            }
        }
        if (data.steps !== undefined) {
            let data14 = data.steps;
            if (Array.isArray(data14)) {
                if (data14.length < 1) {
                    const err40 = {
                        instancePath: instancePath + '/steps',
                        schemaPath: '#/properties/steps/minItems',
                        keyword: 'minItems',
                        params: { limit: 1 },
                        message: 'must NOT have fewer than 1 items',
                        schema: 1,
                        parentSchema: schema11.properties.steps,
                        data: data14,
                    };
                    if (vErrors === null) {
                        vErrors = [err40];
                    }
                    else {
                        vErrors.push(err40);
                    }
                    errors++;
                }
                const len1 = data14.length;
                for (let i1 = 0; i1 < len1; i1++) {
                    if (!validate59(data14[i1], {
                        instancePath: instancePath + '/steps/' + i1,
                        parentData: data14,
                        parentDataProperty: i1,
                        rootData,
                    })) {
                        vErrors = vErrors === null ? validate59.errors : vErrors.concat(validate59.errors);
                        errors = vErrors.length;
                    }
                }
            }
            else {
                const err41 = {
                    instancePath: instancePath + '/steps',
                    schemaPath: '#/properties/steps/type',
                    keyword: 'type',
                    params: { type: 'array' },
                    message: 'must be array',
                    schema: schema11.properties.steps.type,
                    parentSchema: schema11.properties.steps,
                    data: data14,
                };
                if (vErrors === null) {
                    vErrors = [err41];
                }
                else {
                    vErrors.push(err41);
                }
                errors++;
            }
        }
        if (data.labels !== undefined) {
            let data16 = data.labels;
            if (!(data16 === 'always' || data16 === 'on-demand')) {
                const err42 = {
                    instancePath: instancePath + '/labels',
                    schemaPath: '#/properties/labels/enum',
                    keyword: 'enum',
                    params: { allowedValues: schema11.properties.labels.enum },
                    message: 'must be equal to one of the allowed values',
                    schema: schema11.properties.labels.enum,
                    parentSchema: schema11.properties.labels,
                    data: data16,
                };
                if (vErrors === null) {
                    vErrors = [err42];
                }
                else {
                    vErrors.push(err42);
                }
                errors++;
            }
        }
    }
    else {
        const err43 = {
            instancePath,
            schemaPath: '#/type',
            keyword: 'type',
            params: { type: 'object' },
            message: 'must be object',
            schema: schema11.type,
            parentSchema: schema11,
            data,
        };
        if (vErrors === null) {
            vErrors = [err43];
        }
        else {
            vErrors.push(err43);
        }
        errors++;
    }
    validate10.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validate.generated.js.map